// file: B4A_Wallet.tsx

// ---------- import Local Tools
import React from 'react';
import * as RN from 'react-native';
import { mapElements } from '../tools/project/mapElements';
import * as functions from '../tools/functions';
import * as Elements from '../tools/Elements';
import * as customs from '../tools/customs';
import { Project } from '../tools/project/';
import * as jsvals from '../tools/jsvals';
import { props } from '../tools/props';
import * as stls from '../tools/stls';
import { tools } from '../tools';
import {
  doc,
  updateDoc,
  setDoc,
  getFirestore,
  onSnapshot,
  getDocs,
  where,
  query,
  collection,
} from 'firebase/firestore';
import { firestoreOutFlax } from '../tools/functions/firebase/firebase';

// ---------- set Temp Dev DataBase
import * as devDB from '../devDB';
import { mock } from '../devDB';
import { useData } from '..';

export const screen = (...args: any) => (
  <Elements.Screen3
    pass={{
      pathScreen: 'b4paymentForm',

      styles: [
        stls.backgroundColor({
          pass: {
            arrayValue: [
              jsvals.varReader({
                pass: {
                  path: jsvals.j8({
                    pass: {
                      propertieValues: 'all.colors.ice',
                    },
                  }),
                },
              }),
            ],
          },
        }),

        stls.width({
          pass: {
            arrayValue: [
              jsvals.j8({
                pass: {
                  propertieValues: '100%',
                },
              }),
            ],
          },
        }),
        stls.height({
          pass: {
            arrayValue: [
              jsvals.j8({
                pass: {
                  propertieValues: '100%',
                },
              }),
            ],
          },
        }),
        stls.flex({
          pass: {
            arrayValue: [
              jsvals.j8({
                pass: {
                  propertieValues: '1px',
                },
              }),
            ],
          },
        }),
        stls.shadows({
          pass: {
            shadowColor: [
              jsvals.j8({
                pass: {
                  propertieValues: '#000000',
                },
              }),
            ],
            shadowOffset: ['{width: 0, height: 0}'],
            shadowOpacity: [
              jsvals.j8({
                pass: {
                  propertieValues: '0.2',
                },
              }),
            ],
            shadowRadius: [
              jsvals.j8({
                pass: {
                  propertieValues: '10px',
                },
              }),
            ],
          },
        }),
      ],

      screenElements: [
        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.backgroundColor({
                  pass: {
                    arrayValue: [
                      jsvals.varReader({
                        pass: {
                          path: jsvals.j8({
                            pass: {
                              propertieValues: 'all.colors.primary',
                            },
                          }),
                        },
                      }),
                    ],
                  },
                }),
                stls.justifyContent({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'space-between',
                        },
                      }),
                    ],
                  },
                }),
                stls.flexDirection({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'row',
                        },
                      }),
                    ],
                  },
                }),
                stls.alignItems({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
                stls.height({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '60px',
                        },
                      }),
                    ],
                  },
                }),
                stls.paddingHorizontal({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 10,
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [],

              expectedVal: [],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 40,
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 40,
                                },
                              }),
                            ],
                          },
                        }),
                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.justifyContent({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.SvgView1
                            pass={{
                              componentSvg: (Svg: any, SvgObj: any) => {
                                const {
                                  Defs,
                                  Stop,
                                  Path,
                                  LinearGradient,
                                  G,
                                  Circle,
                                  Rect,
                                  Mask,
                                } = SvgObj;
                                return (props: any) => (
                                  <Svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 10"
                                    {...props}
                                  >
                                    
                                    <Path
                                      {...props}
                                      d="M0 1.5A1.5 1.5 0 0 1 1.5 0h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 0 1.5ZM0 8.5A1.5 1.5 0 0 1 1.5 7h12a1.5 1.5 0 0 1 0 3h-12A1.5 1.5 0 0 1 0 8.5Z"
                                    />
                                  </Svg>
                                );
                              },

                              svgOriginal: `
        <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.05979e-07 1.5C3.05979e-07 0.671573 0.671573 0 1.5 0H18.5C19.3284 0 20 0.671573 20 1.5C20 2.32843 19.3284 3 18.5 3H1.5C0.671573 3 3.05979e-07 2.32843 3.05979e-07 1.5Z" fill="white"/> <path d="M0 8.5C0 7.67157 0.671573 7 1.5 7H13.5C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10H1.5C0.671573 10 0 9.32843 0 8.5Z" fill="white"/> </svg>
      `,

                              altura: '16px',

                              largura: '16px',

                              preenchimento: [
                                jsvals.varReader({
                                  pass: {
                                    path: jsvals.j8({
                                      pass: {
                                        propertieValues: 'all.colors.white',
                                      },
                                    }),
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.toggles.sideMenu',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: 'show',
                                },
                              }),
                            },
                          }),
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '1px',
                                },
                              }),
                            ],
                          },
                        }),

                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.justifyContent({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({ pass: { arrayValue: ['1'] } }),
                      ],

                      variablePath: [],

                      expectedVal: [],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.ImageBox
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '50px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '150px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              URIvariablePath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues:
                                      'https://firebasestorage.googleapis.com/v0/b/goodbike-cd338.appspot.com/o/images%2Flogo-no-bg.png?alt=media&token=c3d87ffd-08f1-4f6b-806b-ae60a31e7e04',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 40,
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 40,
                                },
                              }),
                            ],
                          },
                        }),
                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.justifyContent({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      variablePath: [],

                      expectedVal: [],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.ImageBox
                            pass={{
                              elementsProperties: [
                                stls.resizeMode({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'contain',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              styles: [
                                stls.borderRadius({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 75,
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.borderColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'white',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '40px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '40px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              URIvariablePath: [
                                jsvals.varReader({
                                  pass: {
                                    path: jsvals.j8({
                                      pass: {
                                        propertieValues:
                                          'all.userData.userImage',
                                      },
                                    }),
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),
        (...args: any) => (
          <Elements.ScrollBar
            pass={{
              styles: [],
              arrProps: [],
              arrItems: [
                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.varReader({
                                pass: {
                                  path: jsvals.j8({
                                    pass: {
                                      propertieValues: 'all.colors.ice',
                                    },
                                  }),
                                },
                              }),
                            ],
                          },
                        }),

                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '1px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.paddingHorizontal({
                          pass: { arrayValue: ['10px'] },
                        }),
                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.paddingTop({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '30px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      variablePath: [],

                      expectedVal: [],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.justifyContent({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.borderRadius({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '20px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.colors.white',
                                            },
                                          }),
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.shadows({
                                  pass: {
                                    shadowColor: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '#000000',
                                        },
                                      }),
                                    ],
                                    shadowOffset: ['{width: 0, height: 0}'],
                                    shadowOpacity: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '0.2',
                                        },
                                      }),
                                    ],
                                    shadowRadius: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.textSizes.small',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.varReader({
                                          pass: {
                                            path: jsvals.j8({
                                              pass: {
                                                propertieValues:
                                                  'sc.B4.totalPurchase',
                                              },
                                            }),
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '24px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        customs.currencyString({
                                          pass: {
                                            value: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'sc.B3C.currData.currPrice',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.white',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues:
                                                    'space-between',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.flexDirection({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'row',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '60px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.padding({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.borderRadius({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.shadows({
                                          pass: {
                                            shadowColor: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '#000000',
                                                },
                                              }),
                                            ],
                                            shadowOffset: [
                                              '{width: 0, height: 0}',
                                            ],
                                            shadowOpacity: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '0.2',
                                                },
                                              }),
                                            ],
                                            shadowRadius: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.creditCard',
                                          },
                                        }),
                                      ],

                                      expectedVal: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'close',
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.toggles.radioCreditCard',
                                                  },
                                                }),
                                              ],

                                              expectedVal: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'unselected',
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Pressable3
                                                    pass={{
                                                      elementProperties: [{}],

                                                      styles: [
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.borderColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.grey',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderWidth(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '1px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderRadius(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '10px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.ice',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                () => <></>,
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      pressableFunctions: [
                                                        async (...args) =>
                                                          functions.setVar({
                                                            args,
                                                            pass: {
                                                              keyPath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'all.toggles.radioCreditCard',
                                                                  },
                                                                }),
                                                              ],
                                                              value: jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'selected',
                                                                },
                                                              }),
                                                            },
                                                          }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),

                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.toggles.radioCreditCard',
                                                  },
                                                }),
                                              ],

                                              expectedVal: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'selected',
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Pressable3
                                                    pass={{
                                                      elementProperties: [{}],

                                                      styles: [
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.white',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.borderColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.primary',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderWidth(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '1px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderRadius(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '10px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.alignItems(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'center',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.justifyContent(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'center',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.backgroundColor(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.varReader(
                                                                                    {
                                                                                      pass: {
                                                                                        path: jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'all.colors.primary',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '12px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.height(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '12px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.borderRadius(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '10px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          () => (
                                                                            <>

                                                                            </>
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      pressableFunctions: [
                                                        async (...args) =>
                                                          functions.setVar({
                                                            args,
                                                            pass: {
                                                              keyPath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'all.toggles.radioCreditCard',
                                                                  },
                                                                }),
                                                              ],
                                                              value: jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'unselected',
                                                                },
                                                              }),
                                                            },
                                                          }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                        (...args: any) => (
                                          <Elements.Pressable3
                                            pass={{
                                              elementProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.width({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '100%',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.alignItems({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'center',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.justifyContent({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'space-between',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.flexDirection({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'row',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.height({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '60px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.padding({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.borderRadius({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Text
                                                    pass={{
                                                      arrProps: [{}],

                                                      arrStyles: [
                                                        stls.fontWeight({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'bold',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      children: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'Cartão de Crédito',
                                                          },
                                                        }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.SvgView1
                                                    pass={{
                                                      componentSvg: (
                                                        Svg: any,
                                                        SvgObj: any,
                                                      ) => {
                                                        const {
                                                          Defs,
                                                          Stop,
                                                          Path,
                                                          LinearGradient,
                                                          G,
                                                          Circle,
                                                          Rect,
                                                          Mask,
                                                        } = SvgObj;
                                                        return (props: any) => (
                                                          <Svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={28}
                                                            height={28}
                                                            fill="red"
                                                            viewBox="0 0 28 28"
                                                            {...props}
                                                          >
                                                            
                                                            <Path
                                                              fill="#0F1729"
                                                              fillRule="evenodd"
                                                              d="M6.293 9.793a1 1 0 0 1 1.414 0L14 16.086l6.293-6.293a1 1 0 1 1 1.414 1.414l-6.823 6.823a1.25 1.25 0 0 1-1.768 0l-6.823-6.823a1 1 0 0 1 0-1.414Z"
                                                              clipRule="evenodd"
                                                            />
                                                          </Svg>
                                                        );
                                                      },

                                                      svgOriginal: `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.79289C6.68342 9.40237 7.31658 9.40237 7.70711 9.79289L14 16.0858L20.2929 9.79289C20.6834 9.40237 21.3166 9.40237 21.7071 9.79289C22.0976 10.1834 22.0976 10.8166 21.7071 11.2071L14.8839 18.0303C14.3957 18.5185 13.6043 18.5185 13.1161 18.0303L6.29289 11.2071C5.90237 10.8166 5.90237 10.1834 6.29289 9.79289Z" fill="#0F1729"/> </svg>
      `,

                                                      altura: '20px',

                                                      largura: '20px',

                                                      preenchimento: [
                                                        'transparent',
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              pressableFunctions: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.creditCard',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'open',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.radioCreditCard',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'selected',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.pix',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'close',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.radioPix',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'unselected',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.payMethod',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'creditCard',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),

                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.white',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.borderRadius({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.padding({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.shadows({
                                          pass: {
                                            shadowColor: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '#000000',
                                                },
                                              }),
                                            ],
                                            shadowOffset: [
                                              '{width: 0, height: 0}',
                                            ],
                                            shadowOpacity: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '0.2',
                                                },
                                              }),
                                            ],
                                            shadowRadius: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.creditCard',
                                          },
                                        }),
                                      ],

                                      expectedVal: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'open',
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Pressable3
                                            pass={{
                                              elementProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.width({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '100%',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.alignItems({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'center',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.justifyContent({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'space-between',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.flexDirection({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'row',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.borderRadius({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.paddingBottom({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '10px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.DynView
                                                    pass={{
                                                      elementsProperties: [{}],

                                                      styles: [
                                                        stls.flexDirection({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'row',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.justifyContent({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'start',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      variablePath: [],

                                                      expectedVal: [],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.white',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'all.toggles.radioCreditCard',
                                                                  },
                                                                }),
                                                              ],

                                                              expectedVal: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'selected',
                                                                  },
                                                                }),
                                                              ],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Pressable3
                                                                    pass={{
                                                                      elementProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.backgroundColor(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.varReader(
                                                                                    {
                                                                                      pass: {
                                                                                        path: jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'all.colors.white',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      childrenItems:
                                                                        [
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.DynView
                                                                              pass={{
                                                                                elementsProperties:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                styles:
                                                                                  [
                                                                                    stls.backgroundColor(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.white',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.width(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '18px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.height(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '18px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.borderColor(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.primary',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.borderWidth(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '1px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.borderRadius(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '10px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.alignItems(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'center',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.justifyContent(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'center',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                variablePath:
                                                                                  [],

                                                                                expectedVal:
                                                                                  [],

                                                                                childrenItems:
                                                                                  [
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.DynView
                                                                                        pass={{
                                                                                          elementsProperties:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          styles:
                                                                                            [
                                                                                              stls.backgroundColor(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.primary',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.width(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '12px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.height(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '12px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.borderRadius(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '10px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          variablePath:
                                                                                            [],

                                                                                          expectedVal:
                                                                                            [],

                                                                                          childrenItems:
                                                                                            [
                                                                                              () => (
                                                                                                <>

                                                                                                </>
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                        ],

                                                                      pressableFunctions:
                                                                        [
                                                                          async (
                                                                            ...args
                                                                          ) =>
                                                                            functions.setVar(
                                                                              {
                                                                                args,
                                                                                pass: {
                                                                                  keyPath:
                                                                                    [
                                                                                      jsvals.j8(
                                                                                        {
                                                                                          pass: {
                                                                                            propertieValues:
                                                                                              'all.toggles.radioCreditCard',
                                                                                          },
                                                                                        },
                                                                                      ),
                                                                                    ],
                                                                                  value:
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'unselected',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                },
                                                                              },
                                                                            ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                        (...args: any) => (
                                                          <Elements.Text
                                                            pass={{
                                                              arrProps: [{}],

                                                              arrStyles: [
                                                                stls.paddingLeft(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '20px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.fontWeight(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'bold',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              children: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'Cartão de Crédito',
                                                                  },
                                                                }),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.SvgView1
                                                    pass={{
                                                      componentSvg: (
                                                        Svg: any,
                                                        SvgObj: any,
                                                      ) => {
                                                        const {
                                                          Defs,
                                                          Stop,
                                                          Path,
                                                          LinearGradient,
                                                          G,
                                                          Circle,
                                                          Rect,
                                                          Mask,
                                                        } = SvgObj;
                                                        return (props: any) => (
                                                          <Svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={28}
                                                            height={28}
                                                            fill="red"
                                                            viewBox="0 0 28 28"
                                                            {...props}
                                                          >
                                                            
                                                            <Path
                                                              fill="#0F1729"
                                                              fillRule="evenodd"
                                                              d="M6.293 9.793a1 1 0 0 1 1.414 0L14 16.086l6.293-6.293a1 1 0 1 1 1.414 1.414l-6.823 6.823a1.25 1.25 0 0 1-1.768 0l-6.823-6.823a1 1 0 0 1 0-1.414Z"
                                                              clipRule="evenodd"
                                                            />
                                                          </Svg>
                                                        );
                                                      },

                                                      svgOriginal: `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.79289C6.68342 9.40237 7.31658 9.40237 7.70711 9.79289L14 16.0858L20.2929 9.79289C20.6834 9.40237 21.3166 9.40237 21.7071 9.79289C22.0976 10.1834 22.0976 10.8166 21.7071 11.2071L14.8839 18.0303C14.3957 18.5185 13.6043 18.5185 13.1161 18.0303L6.29289 11.2071C5.90237 10.8166 5.90237 10.1834 6.29289 9.79289Z" fill="#0F1729"/> </svg>
      `,

                                                      altura: '20px',

                                                      largura: '20px',

                                                      preenchimento: [
                                                        'transparent',
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              pressableFunctions: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.creditCard',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'close',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                        (...args: any) => (
                                          <customs.CondFormCard
                                            pass={{
                                              ipt1: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.userData.paymentData.id',
                                                  },
                                                }),
                                              ],
                                              ipt2: [
                                                (...args: any) => (
                                                  <Elements.DynView
                                                    pass={{
                                                      elementsProperties: [{}],

                                                      styles: [
                                                        stls.borderRadius({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '20px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.width({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '100%',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.padding({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '35px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.paddingTop({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '20px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.shadows({
                                                          pass: {
                                                            shadowColor: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '#000000',
                                                                },
                                                              }),
                                                            ],
                                                            shadowOffset: [
                                                              '{width: 0, height: 0}',
                                                            ],
                                                            shadowOpacity: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '0.2',
                                                                },
                                                              }),
                                                            ],
                                                            shadowRadius: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '10px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      variablePath: [],

                                                      expectedVal: [],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.flexDirection(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'row',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.justifyContent(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'space-between',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Text
                                                                    pass={{
                                                                      arrProps:
                                                                        [{}],

                                                                      arrStyles:
                                                                        [
                                                                          stls.fontSize(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            '18px',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.fontWeight(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            '600px',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.marginBottom(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            '10px',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.color(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'rgb(68, 68, 68)',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      children:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'Cartão de Crédito',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Pressable3
                                                                    pass={{
                                                                      elementProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '45px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.height(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '20px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.borderRadius(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '10px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.borderColor(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          'grey',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.borderWidth(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '1px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.alignItems(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          'center',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      childrenItems:
                                                                        [
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.Text
                                                                              pass={{
                                                                                arrProps:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                arrStyles:
                                                                                  [
                                                                                    {
                                                                                      color:
                                                                                        'black',
                                                                                      fontSize: 12,
                                                                                    },
                                                                                  ],

                                                                                children:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'Editar',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                        ],

                                                                      pressableFunctions:
                                                                        [
                                                                          (
                                                                            ...args
                                                                          ) => {
                                                                            // ---------- get Function from A_Project Scope
                                                                            return tools.goTo(
                                                                              'b4paymentEditCard',
                                                                            );
                                                                          },
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),

                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.white',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.white',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '140px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Text
                                                                    pass={{
                                                                      arrProps:
                                                                        [{}],

                                                                      arrStyles:
                                                                        [
                                                                          stls.fontSize(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.textSizes.small',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.fontWeight(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'bold',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.color(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.colors.grey2',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      children:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'Número do Cartão',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Text
                                                                    pass={{
                                                                      arrProps:
                                                                        [{}],

                                                                      arrStyles:
                                                                        [
                                                                          stls.borderBottomWidth(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            '2px',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.borderBottomColor(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.colors.grey',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.color(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.colors.grey2',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.fontSize(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.textSizes.small',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.fontSize(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.textSizes.large',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.padding(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            '5px',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      children:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.paymentData.first_six_digits',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '********',
                                                                              },
                                                                            },
                                                                          ),
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.paymentData.last_four_digits',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],
                                              ipt3: [
                                                (...args: any) => (
                                                  <Elements.DynView
                                                    pass={{
                                                      elementsProperties: [{}],

                                                      styles: [
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.borderRadius({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '20px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.padding({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '20px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.width({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '100%',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.shadows({
                                                          pass: {
                                                            shadowColor: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '#000000',
                                                                },
                                                              }),
                                                            ],
                                                            shadowOffset: [
                                                              '{width: 0, height: 0}',
                                                            ],
                                                            shadowOpacity: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '0.2',
                                                                },
                                                              }),
                                                            ],
                                                            shadowRadius: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '10px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      variablePath: [],

                                                      expectedVal: [],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [[]],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.backgroundColor(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.varReader(
                                                                                    {
                                                                                      pass: {
                                                                                        path: jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'all.colors.white',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '100%',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.Text
                                                                              pass={{
                                                                                arrProps:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                arrStyles:
                                                                                  [
                                                                                    stls.fontSize(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.textSizes.small',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.fontWeight(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'bold',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.color(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.grey2',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                children:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'Número do Cartão',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.IptTxtMaskCCard
                                                                              pass={{
                                                                                propsArray:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                stylesArray:
                                                                                  [
                                                                                    stls.borderBottomWidth(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '2px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.borderBottomColor(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.grey',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.color(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.grey2',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.fontSize(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.textSizes.small',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.fontSize(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.textSizes.large',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.padding(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '5px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                editPath:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'sc.B4.currData.orderData.payments.0.credit_card.card.number',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                funcsArray:
                                                                                  [
                                                                                    async (
                                                                                      ...args
                                                                                    ) =>
                                                                                      functions.setVar(
                                                                                        {
                                                                                          args,
                                                                                          pass: {
                                                                                            keyPath:
                                                                                              [
                                                                                                jsvals.j8(
                                                                                                  {
                                                                                                    pass: {
                                                                                                      propertieValues:
                                                                                                        'sc.B4.currData.orderData.payments.0.credit_card.card.number',
                                                                                                    },
                                                                                                  },
                                                                                                ),
                                                                                              ],
                                                                                            value:
                                                                                              jsvals.argReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    argPath:
                                                                                                      jsvals.j8(
                                                                                                        {
                                                                                                          pass: {
                                                                                                            propertieValues:
                                                                                                              '#0',
                                                                                                          },
                                                                                                        },
                                                                                                      ),
                                                                                                    args,
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                          },
                                                                                        },
                                                                                      ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),

                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.height(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '10px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '100%',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          () => (
                                                                            <>

                                                                            </>
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),

                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.flexDirection(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          'row',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.justifyContent(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          'space-between',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.DynView
                                                                              pass={{
                                                                                elementsProperties:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                styles:
                                                                                  [
                                                                                    stls.flexDirection(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'row',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.justifyContent(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'space-between',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.width(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '65%',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                variablePath:
                                                                                  [],

                                                                                expectedVal:
                                                                                  [],

                                                                                childrenItems:
                                                                                  [
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.DynView
                                                                                        pass={{
                                                                                          elementsProperties:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          styles:
                                                                                            [
                                                                                              stls.backgroundColor(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.white',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.width(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '50%',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          variablePath:
                                                                                            [],

                                                                                          expectedVal:
                                                                                            [],

                                                                                          childrenItems:
                                                                                            [
                                                                                              (
                                                                                                ...args: any
                                                                                              ) => (
                                                                                                <Elements.Text
                                                                                                  pass={{
                                                                                                    arrProps:
                                                                                                      [
                                                                                                        {},
                                                                                                      ],

                                                                                                    arrStyles:
                                                                                                      [
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.small',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontWeight(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          'bold',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.color(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey2',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    children:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'Mês de Venc.',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    args,
                                                                                                  }}
                                                                                                />
                                                                                              ),
                                                                                              (
                                                                                                ...args: any
                                                                                              ) => (
                                                                                                <Elements.IptTxtMaskCustomNumbers
                                                                                                  pass={{
                                                                                                    propsArray:
                                                                                                      [
                                                                                                        {},
                                                                                                      ],

                                                                                                    stylesArray:
                                                                                                      [
                                                                                                        stls.borderBottomWidth(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          '2px',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.borderBottomColor(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.color(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey2',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.small',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.large',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.padding(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          '5px',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    editPath:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'sc.B4.currData.orderData.payments.0.credit_card.card.exp_month',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    funcsArray:
                                                                                                      [
                                                                                                        async (
                                                                                                          ...args
                                                                                                        ) =>
                                                                                                          functions.setVar(
                                                                                                            {
                                                                                                              args,
                                                                                                              pass: {
                                                                                                                keyPath:
                                                                                                                  [
                                                                                                                    jsvals.j8(
                                                                                                                      {
                                                                                                                        pass: {
                                                                                                                          propertieValues:
                                                                                                                            'sc.B4.currData.orderData.payments.0.credit_card.card.exp_month',
                                                                                                                        },
                                                                                                                      },
                                                                                                                    ),
                                                                                                                  ],
                                                                                                                value:
                                                                                                                  jsvals.argReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        argPath:
                                                                                                                          jsvals.j8(
                                                                                                                            {
                                                                                                                              pass: {
                                                                                                                                propertieValues:
                                                                                                                                  '#0',
                                                                                                                              },
                                                                                                                            },
                                                                                                                          ),
                                                                                                                        args,
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                              },
                                                                                                            },
                                                                                                          ),
                                                                                                      ],

                                                                                                    ipt5: [
                                                                                                      jsvals.j8(
                                                                                                        {
                                                                                                          pass: {
                                                                                                            propertieValues:
                                                                                                              '2',
                                                                                                          },
                                                                                                        },
                                                                                                      ),
                                                                                                    ],

                                                                                                    args,
                                                                                                  }}
                                                                                                />
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),

                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.DynView
                                                                                        pass={{
                                                                                          elementsProperties:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          styles:
                                                                                            [
                                                                                              stls.backgroundColor(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.white',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.width(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '45%',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          variablePath:
                                                                                            [],

                                                                                          expectedVal:
                                                                                            [],

                                                                                          childrenItems:
                                                                                            [
                                                                                              (
                                                                                                ...args: any
                                                                                              ) => (
                                                                                                <Elements.Text
                                                                                                  pass={{
                                                                                                    arrProps:
                                                                                                      [
                                                                                                        {},
                                                                                                      ],

                                                                                                    arrStyles:
                                                                                                      [
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.small',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontWeight(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          'bold',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.color(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey2',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    children:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'Ano',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    args,
                                                                                                  }}
                                                                                                />
                                                                                              ),
                                                                                              (
                                                                                                ...args: any
                                                                                              ) => (
                                                                                                <Elements.IptTxtMaskCustomNumbers
                                                                                                  pass={{
                                                                                                    propsArray:
                                                                                                      [
                                                                                                        {},
                                                                                                      ],

                                                                                                    stylesArray:
                                                                                                      [
                                                                                                        stls.borderBottomWidth(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          '2px',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.borderBottomColor(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.color(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.colors.grey2',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.small',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.fontSize(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.varReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        path: jsvals.j8(
                                                                                                                          {
                                                                                                                            pass: {
                                                                                                                              propertieValues:
                                                                                                                                'all.textSizes.large',
                                                                                                                            },
                                                                                                                          },
                                                                                                                        ),
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                        stls.padding(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              arrayValue:
                                                                                                                [
                                                                                                                  jsvals.j8(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        propertieValues:
                                                                                                                          '5px',
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                                ],
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    editPath:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'sc.B4.currData.orderData.payments.0.credit_card.card.exp_year',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],

                                                                                                    funcsArray:
                                                                                                      [
                                                                                                        async (
                                                                                                          ...args
                                                                                                        ) =>
                                                                                                          functions.setVar(
                                                                                                            {
                                                                                                              args,
                                                                                                              pass: {
                                                                                                                keyPath:
                                                                                                                  [
                                                                                                                    jsvals.j8(
                                                                                                                      {
                                                                                                                        pass: {
                                                                                                                          propertieValues:
                                                                                                                            'sc.B4.currData.orderData.payments.0.credit_card.card.exp_year',
                                                                                                                        },
                                                                                                                      },
                                                                                                                    ),
                                                                                                                  ],
                                                                                                                value:
                                                                                                                  jsvals.argReader(
                                                                                                                    {
                                                                                                                      pass: {
                                                                                                                        argPath:
                                                                                                                          jsvals.j8(
                                                                                                                            {
                                                                                                                              pass: {
                                                                                                                                propertieValues:
                                                                                                                                  '#0',
                                                                                                                              },
                                                                                                                            },
                                                                                                                          ),
                                                                                                                        args,
                                                                                                                      },
                                                                                                                    },
                                                                                                                  ),
                                                                                                              },
                                                                                                            },
                                                                                                          ),
                                                                                                      ],

                                                                                                    ipt5: [
                                                                                                      jsvals.j8(
                                                                                                        {
                                                                                                          pass: {
                                                                                                            propertieValues:
                                                                                                              '4',
                                                                                                          },
                                                                                                        },
                                                                                                      ),
                                                                                                    ],

                                                                                                    args,
                                                                                                  }}
                                                                                                />
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),

                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.DynView
                                                                              pass={{
                                                                                elementsProperties:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                styles:
                                                                                  [
                                                                                    stls.backgroundColor(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.white',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.width(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '20%',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                variablePath:
                                                                                  [],

                                                                                expectedVal:
                                                                                  [],

                                                                                childrenItems:
                                                                                  [
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.Text
                                                                                        pass={{
                                                                                          arrProps:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          arrStyles:
                                                                                            [
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.small',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontWeight(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'bold',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.color(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.grey2',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          children:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'CVV',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.IptTxtMaskCustomNumbers
                                                                                        pass={{
                                                                                          propsArray:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          stylesArray:
                                                                                            [
                                                                                              stls.borderBottomWidth(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '2px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.borderBottomColor(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.grey',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.color(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.grey2',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.small',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.large',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.padding(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '5px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          editPath:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'sc.B4.currData.orderData.payments.0.credit_card.card.cvv',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          funcsArray:
                                                                                            [
                                                                                              async (
                                                                                                ...args
                                                                                              ) =>
                                                                                                functions.setVar(
                                                                                                  {
                                                                                                    args,
                                                                                                    pass: {
                                                                                                      keyPath:
                                                                                                        [
                                                                                                          jsvals.j8(
                                                                                                            {
                                                                                                              pass: {
                                                                                                                propertieValues:
                                                                                                                  'sc.B4.currData.orderData.payments.0.credit_card.card.cvv',
                                                                                                              },
                                                                                                            },
                                                                                                          ),
                                                                                                        ],
                                                                                                      value:
                                                                                                        jsvals.argReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              argPath:
                                                                                                                jsvals.j8(
                                                                                                                  {
                                                                                                                    pass: {
                                                                                                                      propertieValues:
                                                                                                                        '#0',
                                                                                                                    },
                                                                                                                  },
                                                                                                                ),
                                                                                                              args,
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                    },
                                                                                                  },
                                                                                                ),
                                                                                            ],

                                                                                          ipt5: [
                                                                                            jsvals.j8(
                                                                                              {
                                                                                                pass: {
                                                                                                  propertieValues:
                                                                                                    '3',
                                                                                                },
                                                                                              },
                                                                                            ),
                                                                                          ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),

                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.height(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '10px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '100%',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          () => (
                                                                            <>

                                                                            </>
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),

                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        {
                                                                          backgroundColor:
                                                                            'white',
                                                                          justifyContent:
                                                                            'center',
                                                                          minHeight: 22,
                                                                          width:
                                                                            '100%',
                                                                        },
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.DynView
                                                                              pass={{
                                                                                elementsProperties:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                styles:
                                                                                  [
                                                                                    stls.flexDirection(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'row',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.alignItems(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'baseline',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                variablePath:
                                                                                  [],

                                                                                expectedVal:
                                                                                  [],

                                                                                childrenItems:
                                                                                  [
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.Text
                                                                                        pass={{
                                                                                          arrProps:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          arrStyles:
                                                                                            [
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.small',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontWeight(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'bold',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.color(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.grey2',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          children:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'Nome (Igual ao Cartão)',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),

                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.DynView
                                                                                        pass={{
                                                                                          elementsProperties:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          styles:
                                                                                            [
                                                                                              stls.width(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                '8px',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          variablePath:
                                                                                            [],

                                                                                          expectedVal:
                                                                                            [],

                                                                                          childrenItems:
                                                                                            [
                                                                                              () => (
                                                                                                <>

                                                                                                </>
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                    (
                                                                                      ...args: any
                                                                                    ) => (
                                                                                      <Elements.Text
                                                                                        pass={{
                                                                                          arrProps:
                                                                                            [
                                                                                              {},
                                                                                            ],

                                                                                          arrStyles:
                                                                                            [
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.small',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontWeight(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.j8(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              propertieValues:
                                                                                                                'bold',
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.color(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.colors.grey2',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                              stls.fontSize(
                                                                                                {
                                                                                                  pass: {
                                                                                                    arrayValue:
                                                                                                      [
                                                                                                        jsvals.varReader(
                                                                                                          {
                                                                                                            pass: {
                                                                                                              path: jsvals.j8(
                                                                                                                {
                                                                                                                  pass: {
                                                                                                                    propertieValues:
                                                                                                                      'all.textSizes.smaller',
                                                                                                                  },
                                                                                                                },
                                                                                                              ),
                                                                                                            },
                                                                                                          },
                                                                                                        ),
                                                                                                      ],
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          children:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      'Não utilizar acentuação',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],

                                                                                          args,
                                                                                        }}
                                                                                      />
                                                                                    ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                          (
                                                                            ...args: any
                                                                          ) => (
                                                                            <Elements.IptTxt2
                                                                              pass={{
                                                                                propsArray:
                                                                                  [
                                                                                    {},
                                                                                  ],

                                                                                stylesArray:
                                                                                  [
                                                                                    stls.borderBottomWidth(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '2px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.borderBottomColor(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.grey',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.color(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.colors.grey2',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.fontSize(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.textSizes.small',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.fontSize(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.varReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    path: jsvals.j8(
                                                                                                      {
                                                                                                        pass: {
                                                                                                          propertieValues:
                                                                                                            'all.textSizes.large',
                                                                                                        },
                                                                                                      },
                                                                                                    ),
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                    stls.padding(
                                                                                      {
                                                                                        pass: {
                                                                                          arrayValue:
                                                                                            [
                                                                                              jsvals.j8(
                                                                                                {
                                                                                                  pass: {
                                                                                                    propertieValues:
                                                                                                      '5px',
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                            ],
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],

                                                                                funcsArray:
                                                                                  [
                                                                                    async (
                                                                                      ...args
                                                                                    ) =>
                                                                                      functions.setVar(
                                                                                        {
                                                                                          args,
                                                                                          pass: {
                                                                                            keyPath:
                                                                                              [
                                                                                                jsvals.j8(
                                                                                                  {
                                                                                                    pass: {
                                                                                                      propertieValues:
                                                                                                        'sc.B4.currData.orderData.payments.0.credit_card.card.holder_name',
                                                                                                    },
                                                                                                  },
                                                                                                ),
                                                                                              ],
                                                                                            value:
                                                                                              jsvals.argReader(
                                                                                                {
                                                                                                  pass: {
                                                                                                    argPath:
                                                                                                      jsvals.j8(
                                                                                                        {
                                                                                                          pass: {
                                                                                                            propertieValues:
                                                                                                              '#0',
                                                                                                          },
                                                                                                        },
                                                                                                      ),
                                                                                                    args,
                                                                                                  },
                                                                                                },
                                                                                              ),
                                                                                          },
                                                                                        },
                                                                                      ),
                                                                                  ],

                                                                                args,
                                                                              }}
                                                                            />
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),

                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '10px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '100%',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                () => <></>,
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),

                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '10px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '100%',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                () => <></>,
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),

                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.alignItems(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'center',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.Text
                                                                    pass={{
                                                                      arrProps:
                                                                        [{}],

                                                                      arrStyles:
                                                                        [
                                                                          stls.fontSize(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.textSizes.small',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.fontWeight(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.j8(
                                                                                      {
                                                                                        pass: {
                                                                                          propertieValues:
                                                                                            'bold',
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                          stls.color(
                                                                            {
                                                                              pass: {
                                                                                arrayValue:
                                                                                  [
                                                                                    jsvals.varReader(
                                                                                      {
                                                                                        pass: {
                                                                                          path: jsvals.j8(
                                                                                            {
                                                                                              pass: {
                                                                                                propertieValues:
                                                                                                  'all.colors.grey2',
                                                                                              },
                                                                                            },
                                                                                          ),
                                                                                        },
                                                                                      },
                                                                                    ),
                                                                                  ],
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      children:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'Ambiente seguro por',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.SvgView1
                                                                    pass={{
                                                                      componentSvg:
                                                                        (
                                                                          Svg: any,
                                                                          SvgObj: any,
                                                                        ) => {
                                                                          const {
                                                                            Defs,
                                                                            Stop,
                                                                            Path,
                                                                            LinearGradient,
                                                                            G,
                                                                            Circle,
                                                                            Rect,
                                                                            Mask,
                                                                          } =
                                                                            SvgObj;
                                                                          return (
                                                                            props: any,
                                                                          ) => (
                                                                            <Svg
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width={
                                                                                160
                                                                              }
                                                                              height={
                                                                                57.107
                                                                              }
                                                                              viewBox="0 0 160 57.107"
                                                                              fill="red"
                                                                              {...props}
                                                                            >
                                                                              
                                                                              <G data-name="logo/pagarme">
                                                                                
                                                                                <Path
                                                                                  d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z"
                                                                                  style={{
                                                                                    fill: '#65a300',
                                                                                  }}
                                                                                  transform="translate(-1422.677)"
                                                                                />
                                                                                <Path
                                                                                  d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z"
                                                                                  style={{
                                                                                    fill: '#1b1c29',
                                                                                  }}
                                                                                  transform="translate(11319 6227.495)"
                                                                                />
                                                                                <Path
                                                                                  d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0 2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329 2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z"
                                                                                  data-name="Path 5415"
                                                                                  style={{
                                                                                    fill: '#454550',
                                                                                  }}
                                                                                  transform="translate(70 57)"
                                                                                />
                                                                              </G>
                                                                            </Svg>
                                                                          );
                                                                        },

                                                                      svgOriginal: `
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="57.107" viewBox="0 0 160 57.107">     <defs>         <style>             .cls-1{fill:#65A300}.cls-2{fill:#1B1C29}.cls-3{fill:#454550}         </style>     </defs>     <g id="logo_pagarme" data-name="logo/pagarme" transform="translate(-180 -37)">         <path id="hat" d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z" class="cls-1" transform="translate(-1242.677 37)"/>         <path id="pagarme" d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z" class="cls-2" transform="translate(11499 6264.495)"/>         <path id="Path_5415" d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0l2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329l2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z" class="cls-3" data-name="Path 5415" transform="translate(250 94)"/>     </g> </svg>
      `,

                                                                      altura:
                                                                        '40px',

                                                                      largura:
                                                                        '100px',

                                                                      preenchimento:
                                                                        [
                                                                          'transparent',
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],
                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.white',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues:
                                                    'space-between',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.flexDirection({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'row',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '60px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.padding({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.borderRadius({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.shadows({
                                          pass: {
                                            shadowColor: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '#000000',
                                                },
                                              }),
                                            ],
                                            shadowOffset: [
                                              '{width: 0, height: 0}',
                                            ],
                                            shadowOpacity: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '0.2',
                                                },
                                              }),
                                            ],
                                            shadowRadius: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'all.toggles.pix',
                                          },
                                        }),
                                      ],

                                      expectedVal: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'close',
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.toggles.radioPix',
                                                  },
                                                }),
                                              ],

                                              expectedVal: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'unselected',
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Pressable3
                                                    pass={{
                                                      elementProperties: [{}],

                                                      styles: [
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.borderColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.grey',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderWidth(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '1px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderRadius(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '10px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.ice',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                () => <></>,
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      pressableFunctions: [
                                                        () =>
                                                          console.log(
                                                            'Você Clicou!',
                                                          ),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),

                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.toggles.radioPix',
                                                  },
                                                }),
                                              ],

                                              expectedVal: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'selected',
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Pressable3
                                                    pass={{
                                                      elementProperties: [{}],

                                                      styles: [
                                                        stls.backgroundColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.white',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      childrenItems: [
                                                        (...args: any) => (
                                                          <Elements.DynView
                                                            pass={{
                                                              elementsProperties:
                                                                [{}],

                                                              styles: [
                                                                stls.backgroundColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.white',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.width({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.height({
                                                                  pass: {
                                                                    arrayValue:
                                                                      [
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '18px',
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],
                                                                  },
                                                                }),
                                                                stls.borderColor(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.colors.primary',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderWidth(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '1px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.borderRadius(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '10px',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.alignItems(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'center',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                                stls.justifyContent(
                                                                  {
                                                                    pass: {
                                                                      arrayValue:
                                                                        [
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'center',
                                                                              },
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  },
                                                                ),
                                                              ],

                                                              variablePath: [],

                                                              expectedVal: [],

                                                              childrenItems: [
                                                                (
                                                                  ...args: any
                                                                ) => (
                                                                  <Elements.DynView
                                                                    pass={{
                                                                      elementsProperties:
                                                                        [{}],

                                                                      styles: [
                                                                        stls.backgroundColor(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.varReader(
                                                                                    {
                                                                                      pass: {
                                                                                        path: jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'all.colors.primary',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.width(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '12px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.height(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '12px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                        stls.borderRadius(
                                                                          {
                                                                            pass: {
                                                                              arrayValue:
                                                                                [
                                                                                  jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          '10px',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                ],
                                                                            },
                                                                          },
                                                                        ),
                                                                      ],

                                                                      variablePath:
                                                                        [],

                                                                      expectedVal:
                                                                        [],

                                                                      childrenItems:
                                                                        [
                                                                          () => (
                                                                            <>

                                                                            </>
                                                                          ),
                                                                        ],

                                                                      args,
                                                                    }}
                                                                  />
                                                                ),
                                                              ],

                                                              args,
                                                            }}
                                                          />
                                                        ),
                                                      ],

                                                      pressableFunctions: [
                                                        async (...args) =>
                                                          functions.setVar({
                                                            args,
                                                            pass: {
                                                              keyPath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'all.toggles.radioPix',
                                                                  },
                                                                }),
                                                              ],
                                                              value: jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'unselected',
                                                                },
                                                              }),
                                                            },
                                                          }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                        (...args: any) => (
                                          <Elements.Pressable3
                                            pass={{
                                              elementProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.width({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '100%',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.alignItems({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'center',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.justifyContent({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'space-between',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.flexDirection({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'row',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.height({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '60px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.padding({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.borderRadius({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Text
                                                    pass={{
                                                      arrProps: [{}],

                                                      arrStyles: [
                                                        stls.fontWeight({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'bold',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      children: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'Depósito Bancário PIX',
                                                          },
                                                        }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.SvgView1
                                                    pass={{
                                                      componentSvg: (
                                                        Svg: any,
                                                        SvgObj: any,
                                                      ) => {
                                                        const {
                                                          Defs,
                                                          Stop,
                                                          Path,
                                                          LinearGradient,
                                                          G,
                                                          Circle,
                                                          Rect,
                                                          Mask,
                                                        } = SvgObj;
                                                        return (props: any) => (
                                                          <Svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={28}
                                                            height={28}
                                                            fill="red"
                                                            viewBox="0 0 28 28"
                                                            {...props}
                                                          >
                                                            
                                                            <Path
                                                              fill="#0F1729"
                                                              fillRule="evenodd"
                                                              d="M6.293 9.793a1 1 0 0 1 1.414 0L14 16.086l6.293-6.293a1 1 0 1 1 1.414 1.414l-6.823 6.823a1.25 1.25 0 0 1-1.768 0l-6.823-6.823a1 1 0 0 1 0-1.414Z"
                                                              clipRule="evenodd"
                                                            />
                                                          </Svg>
                                                        );
                                                      },

                                                      svgOriginal: `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.79289C6.68342 9.40237 7.31658 9.40237 7.70711 9.79289L14 16.0858L20.2929 9.79289C20.6834 9.40237 21.3166 9.40237 21.7071 9.79289C22.0976 10.1834 22.0976 10.8166 21.7071 11.2071L14.8839 18.0303C14.3957 18.5185 13.6043 18.5185 13.1161 18.0303L6.29289 11.2071C5.90237 10.8166 5.90237 10.1834 6.29289 9.79289Z" fill="#0F1729"/> </svg>
      `,

                                                      altura: '20px',

                                                      largura: '20px',

                                                      preenchimento: [
                                                        'transparent',
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              pressableFunctions: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.payMethod',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'pix',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.radioPix',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'selected',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.creditCard',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'close',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.radioCreditCard',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'unselected',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),

                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.white',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.borderRadius({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.padding({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'all.toggles.pix',
                                          },
                                        }),
                                      ],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Pressable3
                                            pass={{
                                              elementProperties: [{}],

                                              styles: [
                                                stls.backgroundColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.white',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.width({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '100%',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.alignItems({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'center',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.justifyContent({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'space-between',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.flexDirection({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'row',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.borderRadius({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '20px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.paddingBottom({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '10px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Text
                                                    pass={{
                                                      arrProps: [{}],

                                                      arrStyles: [
                                                        stls.fontWeight({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'bold',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      children: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'Depósito Bancário PIX',
                                                          },
                                                        }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.SvgView1
                                                    pass={{
                                                      componentSvg: (
                                                        Svg: any,
                                                        SvgObj: any,
                                                      ) => {
                                                        const {
                                                          Defs,
                                                          Stop,
                                                          Path,
                                                          LinearGradient,
                                                          G,
                                                          Circle,
                                                          Rect,
                                                          Mask,
                                                        } = SvgObj;
                                                        return (props: any) => (
                                                          <Svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={28}
                                                            height={28}
                                                            fill="red"
                                                            viewBox="0 0 28 28"
                                                            {...props}
                                                          >
                                                            
                                                            <Path
                                                              fill="#0F1729"
                                                              fillRule="evenodd"
                                                              d="M6.293 9.793a1 1 0 0 1 1.414 0L14 16.086l6.293-6.293a1 1 0 1 1 1.414 1.414l-6.823 6.823a1.25 1.25 0 0 1-1.768 0l-6.823-6.823a1 1 0 0 1 0-1.414Z"
                                                              clipRule="evenodd"
                                                            />
                                                          </Svg>
                                                        );
                                                      },

                                                      svgOriginal: `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.79289C6.68342 9.40237 7.31658 9.40237 7.70711 9.79289L14 16.0858L20.2929 9.79289C20.6834 9.40237 21.3166 9.40237 21.7071 9.79289C22.0976 10.1834 22.0976 10.8166 21.7071 11.2071L14.8839 18.0303C14.3957 18.5185 13.6043 18.5185 13.1161 18.0303L6.29289 11.2071C5.90237 10.8166 5.90237 10.1834 6.29289 9.79289Z" fill="#0F1729"/> </svg>
      `,

                                                      altura: '20px',

                                                      largura: '20px',

                                                      preenchimento: [
                                                        'transparent',
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              pressableFunctions: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.toggles.pix',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'close',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),

                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                {
                                                  backgroundColor: 'white',
                                                  justifyContent: 'center',
                                                  minHeight: 22,
                                                  width: '100%',
                                                },
                                              ],

                                              variablePath: [],

                                              expectedVal: [],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Text
                                                    pass={{
                                                      arrProps: [{}],

                                                      arrStyles: [
                                                        stls.fontSize({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.textSizes.small',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.fontWeight({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'bold',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.color({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.grey2',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      children: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'Chave Pix',
                                                          },
                                                        }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.IptTxt2
                                                    pass={{
                                                      propsArray: [{}],

                                                      stylesArray: [
                                                        stls.borderBottomWidth({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '2px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.borderBottomColor({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.grey',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.color({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.grey2',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.fontSize({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.textSizes.small',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.fontSize({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.textSizes.large',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.padding({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    '5px',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      funcsArray: [
                                                        async (...args) =>
                                                          functions.setVar({
                                                            args,
                                                            pass: {
                                                              keyPath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'sc.B4.currData.orderData.payments.0.pixKey',
                                                                  },
                                                                }),
                                                              ],
                                                              value:
                                                                jsvals.argReader(
                                                                  {
                                                                    pass: {
                                                                      argPath:
                                                                        jsvals.j8(
                                                                          {
                                                                            pass: {
                                                                              propertieValues:
                                                                                '#0',
                                                                            },
                                                                          },
                                                                        ),
                                                                      args,
                                                                    },
                                                                  },
                                                                ),
                                                            },
                                                          }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),

                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.height({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '10px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.width({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '100%',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [],

                                              expectedVal: [],

                                              childrenItems: [() => <></>],

                                              args,
                                            }}
                                          />
                                        ),

                                        (...args: any) => (
                                          <Elements.DynView
                                            pass={{
                                              elementsProperties: [{}],

                                              styles: [
                                                stls.alignItems({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'center',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              variablePath: [],

                                              expectedVal: [],

                                              childrenItems: [
                                                (...args: any) => (
                                                  <Elements.Text
                                                    pass={{
                                                      arrProps: [{}],

                                                      arrStyles: [
                                                        stls.fontSize({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.textSizes.small',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.fontWeight({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'bold',
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                        stls.color({
                                                          pass: {
                                                            arrayValue: [
                                                              jsvals.varReader({
                                                                pass: {
                                                                  path: jsvals.j8(
                                                                    {
                                                                      pass: {
                                                                        propertieValues:
                                                                          'all.colors.grey2',
                                                                      },
                                                                    },
                                                                  ),
                                                                },
                                                              }),
                                                            ],
                                                          },
                                                        }),
                                                      ],

                                                      children: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'Ambiente seguro por',
                                                          },
                                                        }),
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                                (...args: any) => (
                                                  <Elements.SvgView1
                                                    pass={{
                                                      componentSvg: (
                                                        Svg: any,
                                                        SvgObj: any,
                                                      ) => {
                                                        const {
                                                          Defs,
                                                          Stop,
                                                          Path,
                                                          LinearGradient,
                                                          G,
                                                          Circle,
                                                          Rect,
                                                          Mask,
                                                        } = SvgObj;
                                                        return (props: any) => (
                                                          <Svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={160}
                                                            height={57.107}
                                                            viewBox="0 0 160 57.107"
                                                            fill="red"
                                                            {...props}
                                                          >
                                                            
                                                            <G data-name="logo/pagarme">
                                                              
                                                              <Path
                                                                d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z"
                                                                style={{
                                                                  fill: '#65a300',
                                                                }}
                                                                transform="translate(-1422.677)"
                                                              />
                                                              <Path
                                                                d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z"
                                                                style={{
                                                                  fill: '#1b1c29',
                                                                }}
                                                                transform="translate(11319 6227.495)"
                                                              />
                                                              <Path
                                                                d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0 2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329 2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z"
                                                                data-name="Path 5415"
                                                                style={{
                                                                  fill: '#454550',
                                                                }}
                                                                transform="translate(70 57)"
                                                              />
                                                            </G>
                                                          </Svg>
                                                        );
                                                      },

                                                      svgOriginal: `
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="57.107" viewBox="0 0 160 57.107">     <defs>         <style>             .cls-1{fill:#65A300}.cls-2{fill:#1B1C29}.cls-3{fill:#454550}         </style>     </defs>     <g id="logo_pagarme" data-name="logo/pagarme" transform="translate(-180 -37)">         <path id="hat" d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z" class="cls-1" transform="translate(-1242.677 37)"/>         <path id="pagarme" d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z" class="cls-2" transform="translate(11499 6264.495)"/>         <path id="Path_5415" d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0l2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329l2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z" class="cls-3" data-name="Path 5415" transform="translate(250 94)"/>     </g> </svg>
      `,

                                                      altura: '40px',

                                                      largura: '100px',

                                                      preenchimento: [
                                                        'transparent',
                                                      ],

                                                      args,
                                                    }}
                                                  />
                                                ),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),
              ],
              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.flexDirection({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'row',
                        },
                      }),
                    ],
                  },
                }),
                stls.alignItems({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
                stls.justifyContent({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'space-between',
                        },
                      }),
                    ],
                  },
                }),
                stls.width({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.backgroundColor({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'rgb(166, 79, 102)',
                        },
                      }),
                    ],
                  },
                }),
                stls.padding({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '20px',
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'all.apis.msgs.condShow',
                  },
                }),
              ],

              expectedVal: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'true',
                  },
                }),
              ],

              childrenItems: [
                (...args: any) => (
                  <Elements.CustomListener
                    pass={{
                      variable: [
                        jsvals.j8({
                          pass: {
                            propertieValues: 'all.apis.msgs.error',
                          },
                        }),
                      ],
                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [
                                stls.color({ pass: { arrayValue: ['white'] } }),
                                stls.fontSize({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '12px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              children: [
                                jsvals.varReader({
                                  pass: {
                                    path: jsvals.j8({
                                      pass: {
                                        propertieValues: 'all.apis.msgs.error',
                                      },
                                    }),
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],
                      args,
                    }}
                  />
                ),
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'transparent',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [
                                stls.color({ pass: { arrayValue: ['white'] } }),
                                stls.fontSize({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '12px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'x',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.apis.msgs.condShow',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: 'false',
                                },
                              }),
                            },
                          }),
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.apis.msgs.error',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: '',
                                },
                              }),
                            },
                          }),
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.flexDirection({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'row',
                        },
                      }),
                    ],
                  },
                }),
                stls.alignItems({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
                stls.justifyContent({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'space-around',
                        },
                      }),
                    ],
                  },
                }),
                stls.width({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.height({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '55px',
                        },
                      }),
                    ],
                  },
                }),
                stls.backgroundColor({
                  pass: {
                    arrayValue: [
                      jsvals.varReader({
                        pass: {
                          path: jsvals.j8({
                            pass: {
                              propertieValues: 'all.colors.grey2',
                            },
                          }),
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [],

              expectedVal: [],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'transparent',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [
                                stls.color({ pass: { arrayValue: ['white'] } }),
                                stls.fontSize({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '12px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'CANCELAR',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        (...args) => {
                          // ---------- get Function from A_Project Scope
                          return tools.goTo('b3bikemap');
                        },
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.varReader({
                                pass: {
                                  path: jsvals.j8({
                                    pass: {
                                      propertieValues: 'all.colors.grey',
                                    },
                                  }),
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '12px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '2px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.borderRadius({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '10px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      variablePath: [],

                      expectedVal: [],

                      childrenItems: [() => <></>],

                      args,
                    }}
                  />
                ),
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'transparent',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [
                                stls.color({ pass: { arrayValue: ['white'] } }),
                                stls.fontSize({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '12px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'CONFIRMAR',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.funcGroup({
                            args,
                            pass: {
                              arrFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userName',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userName',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.bikesList',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.mainList',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.totalPrice',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.currPrice',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.paymentData',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B4.currData.orderData.payments.0',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.localName',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.localName',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4xxx.currData.checkout.bikeId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.localAdress',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.localAddress.formatted_address',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userCPF',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userCPF',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userEmail',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userEmail',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userPhone',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userPhone',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userAddress',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userAddress',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userGender',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userGender',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.locationId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.totalHours',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.selecHours',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userCep',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userCep',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userImage',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userImage',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.locationType',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.locationType',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.bikeReturned',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'não',
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.condition({
                                    args,
                                    pass: {
                                      conditionPath: [
                                        jsvals.varReader({
                                          pass: {
                                            path: jsvals.j8({
                                              pass: {
                                                propertieValues:
                                                  'sc.B3A.currData.currLocation.data.locationType',
                                              },
                                            }),
                                          },
                                        }),
                                      ],
                                      expectedValue: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Autônomo',
                                          },
                                        }),
                                      ],
                                      functionsTrue: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'sc.B4.currData.checkout.timer',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: {
                                                    isRunning: jsvals.j8({
                                                      pass: {
                                                        propertieValues: 'true',
                                                      },
                                                    }),
                                                  },
                                                },
                                              }),
                                            },
                                          }),
                                        (...args: any) =>
                                          customs.setAutoBikeTimerDB({
                                            pass: {
                                              type: "'plus'",
                                              args,
                                            },
                                          }),
                                      ],
                                      functionsFalse: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'sc.B4.currData.checkout.timer',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: {
                                                    isRunning: jsvals.j8({
                                                      pass: {
                                                        propertieValues:
                                                          'waiting',
                                                      },
                                                    }),
                                                  },
                                                },
                                              }),
                                            },
                                          }),
                                      ],
                                      args,
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.reasonBlocking',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: '',
                                        },
                                      }),
                                    },
                                  }),
                              ],
                            },
                          }),
                        () => {
                          const checkPix =
                            tools.getCtData('all.payMethod') === 'pix';
                          const checkCard =
                            tools.getCtData('all.payMethod') === 'creditCard';
                          const pagarme = tools.customs.pagarme;
                          const { createOrderPIX, createOrder } = pagarme;
                          if (checkPix) {
                            console.log({ payMethod: 'PIX' });
                            createOrderPIX();
                          }
                          if (checkCard) {
                            console.log({ payMethod: 'CREDIT CARD' });
                            const haveCardHash = !!tools.getCtData(
                              'all.userData.paymentData.id',
                            );
                            console.log({ haveCardHash });
                            if (haveCardHash) {
                              tools.setData({
                                path: 'all.toggles.modalCvv',
                                value: 'show',
                              });
                            }
                            if (!haveCardHash) {
                              createOrder();
                            }
                          }
                        },
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.position({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'absolute',
                        },
                      }),
                    ],
                  },
                }),
                stls.flex({ pass: { arrayValue: ['1'] } }),
                stls.width({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.height({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.top({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.left({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.zIndex({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100px',
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'all.toggles.sideMenu',
                  },
                }),
              ],

              expectedVal: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'show',
                  },
                }),
              ],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.position({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'absolute',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({ pass: { arrayValue: ['1'] } }),
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'rgba(0,0,0,0.5)',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.top({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.left({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [{ color: 'black', fontSize: 12 }],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'aaa',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.toggles.sideMenu',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: 'hide',
                                },
                              }),
                            },
                          }),
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.varReader({
                                pass: {
                                  path: jsvals.j8({
                                    pass: {
                                      propertieValues: 'all.colors.white',
                                    },
                                  }),
                                },
                              }),
                            ],
                          },
                        }),
                        stls.paddingHorizontal({
                          pass: { arrayValue: ['10px'] },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '80%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.position({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'absolute',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.top({ pass: { arrayValue: ['1px'] } }),
                      ],

                      variablePath: [],

                      expectedVal: [],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.paddingVertical({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '4px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.Pressable3
                                    pass={{
                                      elementProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.flexDirection({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'row',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={20}
                                                    height={14}
                                                    viewBox="0 0 20 14"
                                                    {...props}
                                                  >
                                                    <Path
                                                      fillRule="evenodd"
                                                      d="M7.707.293a1 1 0 0 1 0 1.414L3.414 6H19a1 1 0 1 1 0 2H3.414l4.293 4.293a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z"
                                                      clipRule="evenodd"
                                                      {...props}
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg></svg>
      `,

                                              altura: '15px',

                                              largura: '15px',

                                              preenchimento: [
                                                jsvals.varReader({
                                                  pass: {
                                                    path: jsvals.j8({
                                                      pass: {
                                                        propertieValues:
                                                          'all.colors.primary',
                                                      },
                                                    }),
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                        (...args: any) => (
                                          <Elements.Text
                                            pass={{
                                              arrProps: [{}],

                                              arrStyles: [
                                                stls.paddingLeft({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '5px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.color({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.primary',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              children: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'Voltar',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      pressableFunctions: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.toggles.sideMenu',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hide',
                                                },
                                              }),
                                            },
                                          }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'transparent',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.overflow({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hidden',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginRight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={14}
                                                    height={14}
                                                    fill="#555"
                                                    viewBox="0 0 14 14"
                                                    {...props}
                                                  >
                                                    
                                                    <Mask
                                                      id="a"
                                                      width={15}
                                                      height={15}
                                                      x={-0.5}
                                                      y={-0.535}
                                                      fill="#555"
                                                      maskUnits="userSpaceOnUse"
                                                    >
                                                      
                                                      <Path
                                                        fill="#fff"
                                                        d="M-.5-.535h15v15h-15z"
                                                      />
                                                      <Path
                                                        fillRule="evenodd"
                                                        d="M6.403.5c0 .02-.106.035-.246.035S5.91.55 5.91.57c0 .02-.094.035-.211.035-.117 0-.21.016-.21.036 0 .019-.048.035-.106.035-.058 0-.106.015-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.038 0-.07.016-.07.036 0 .019-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035-.001.02-.033.036-.071.036-.039 0-.07.015-.07.035 0 .019-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.029.035-.063.035s-.085.032-.113.07c-.028.04-.076.07-.106.07s-.077.033-.105.071c-.028.039-.073.07-.1.07-.026 0-.092.048-.146.106-.054.058-.116.105-.137.105-.051 0-1.128 1.077-1.128 1.128 0 .021-.047.083-.105.137-.058.054-.106.12-.106.147 0 .027-.031.071-.07.1-.039.027-.07.078-.07.112 0 .035-.016.063-.035.063-.02 0-.035.028-.035.062 0 .035-.032.086-.07.113-.04.028-.071.08-.071.114s-.016.062-.035.062c-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.036.032-.036.07 0 .04-.015.071-.035.071-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.035.031-.035.07 0 .038-.016.07-.036.07-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.019 0-.035.079-.035.176 0 .096-.016.175-.035.175-.022 0-.035.34-.035.949s.013.948.035.948c.02 0 .035.094.035.211 0 .117.016.211.035.211.02 0 .036.063.036.14 0 .078.015.141.035.141.019 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.048.035.105 0 .058.016.106.035.106.02 0 .036.032.036.07 0 .039.015.07.035.07.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.032.035.071 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.029.035.063 0 .035.032.086.07.114.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.039.028.07.072.07.099 0 .027.048.093.106.147.058.054.105.116.105.137 0 .051 1.077 1.128 1.128 1.128.021 0 .083.047.137.105.054.058.12.106.147.106.026 0 .071.031.099.07.028.038.075.07.105.07s.078.032.106.07c.028.039.079.07.113.07s.062.016.062.036c0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.048.036.106.036.058 0 .105.015.105.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.063.035.14.035.078 0 .141.016.141.035 0 .02.08.036.176.036.096 0 .176.015.176.035 0 .02.117.035.28.035.165 0 .282.014.282.035 0 .022.222.035.597.035s.597-.013.597-.035c0-.02.117-.035.281-.035.164 0 .281-.015.281-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.019.063-.035.14-.035.078 0 .14-.015.14-.035 0-.02.048-.035.106-.035.058 0 .106-.016.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.036 0-.019.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.036 0-.019.033-.035.071-.035.039 0 .07-.015.07-.035 0-.019.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.029-.035.063-.035s.085-.032.113-.07c.028-.04.075-.07.106-.07.03 0 .077-.033.105-.071.028-.039.072-.07.1-.07.026 0 .092-.048.146-.106.054-.058.116-.105.137-.105.051 0 1.058-1.007 1.058-1.058 0-.02.047-.083.105-.137.058-.054.105-.117.105-.14 0-.024.048-.087.106-.141.058-.054.105-.124.105-.155 0-.03.016-.056.035-.056.02 0 .035-.028.035-.062 0-.035.032-.086.07-.114.04-.027.071-.078.071-.113 0-.034.016-.062.035-.062.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .035-.031.035-.07 0-.038.016-.07.036-.07.019 0 .035-.048.035-.106 0-.057.016-.105.035-.105.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.063.035-.14 0-.078.016-.14.035-.14.02 0 .036-.064.036-.141 0-.078.015-.14.035-.14.02 0 .035-.095.035-.212 0-.117.015-.21.035-.21.022 0 .035-.317.035-.879s-.013-.878-.035-.878c-.02 0-.035-.094-.035-.211 0-.117-.016-.21-.035-.21-.02 0-.035-.08-.035-.177 0-.096-.016-.175-.036-.175-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.036-.048-.036-.106 0-.058-.015-.105-.035-.105-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.047-.035-.105 0-.058-.016-.106-.035-.106-.02 0-.035-.031-.035-.07 0-.039-.016-.07-.036-.07-.019 0-.035-.029-.035-.063s-.031-.085-.07-.113c-.039-.028-.07-.079-.07-.113 0-.035-.016-.063-.035-.063-.02 0-.036-.028-.036-.062 0-.035-.031-.086-.07-.113-.038-.028-.07-.076-.07-.106s-.032-.077-.07-.105c-.039-.028-.07-.073-.07-.1 0-.026-.048-.092-.106-.146-.058-.054-.105-.116-.105-.138 0-.05-.936-.986-.987-.986-.02 0-.099-.064-.173-.141-.074-.077-.156-.14-.183-.14-.026 0-.07-.032-.098-.07-.028-.04-.079-.071-.113-.071s-.063-.016-.063-.035c0-.02-.028-.035-.062-.035s-.085-.032-.113-.07c-.028-.04-.08-.07-.114-.07s-.062-.017-.062-.036c0-.02-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.036 0-.019-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.064-.035-.14-.035C8.503.676 8.44.66 8.44.64c0-.02-.08-.036-.176-.036-.097 0-.176-.015-.176-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.035 0-.022-.222-.035-.597-.035S6.403.478 6.403.5Zm.983.562c0 .021.13.035.317.035s.316.015.316.035c0 .02.079.036.176.036.096 0 .175.015.175.035 0 .019.064.035.14.035.078 0 .141.016.141.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.032.035.071.035.039 0 .07.016.07.036 0 .019.029.035.063.035s.085.031.113.07c.028.039.079.07.113.07.035 0 .063.016.063.035 0 .02.028.036.062.036.035 0 .086.031.113.07.028.038.076.07.106.07s.077.032.105.07c.028.039.072.07.098.07.026 0 .124.08.218.176.095.097.189.176.21.176.05 0 .423.373.423.423 0 .021.079.115.176.21.096.094.175.189.175.211 0 .023.048.086.106.14.058.054.105.12.105.147 0 .026.032.07.07.099.039.028.07.078.07.113 0 .034.016.062.036.062.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.036.071.019 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.064.035.14 0 .078.016.141.035.141.02 0 .036.106.036.246s.015.246.035.246c.022 0 .035.27.035.738 0 .469-.013.738-.035.738-.02 0-.035.094-.035.21 0 .118-.016.212-.036.212-.019 0-.035.063-.035.14 0 .077-.016.14-.035.14-.02 0-.035.064-.035.141 0 .077-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.036.047-.036.105 0 .058-.015.105-.035.105-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.033-.035.071 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.029-.035.063s-.032.085-.07.113c-.04.028-.07.073-.07.1 0 .026-.048.092-.106.146-.058.054-.106.117-.106.14 0 .023-.063.102-.14.176-.078.075-.14.153-.14.174 0 .054-.447.494-.502.494-.025 0-.068.032-.096.07-.071.1-.106.088-.106-.035 0-.058-.015-.105-.035-.105-.019 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.036-.032-.036-.07 0-.039-.015-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.029-.035-.063s-.032-.085-.07-.113c-.04-.028-.071-.072-.071-.099 0-.026-.063-.108-.14-.182-.078-.075-.141-.153-.141-.174 0-.052-.232-.283-.283-.283-.022 0-.085-.048-.139-.106-.054-.057-.123-.105-.154-.105s-.056-.016-.056-.035c0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.044.035-.098.035a.192.192 0 0 0-.148.07c-.028.039-.079.07-.113.07-.035 0-.063.016-.063.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .021-.152.035-.386.035s-.386-.014-.386-.035c0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.028-.035-.063-.035-.034 0-.085-.031-.113-.07a.192.192 0 0 0-.148-.07c-.054 0-.098-.016-.098-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.026.035-.057.035-.03 0-.1.048-.154.105-.054.058-.117.106-.139.106-.05 0-.283.231-.283.283 0 .021-.063.1-.14.174-.078.074-.141.156-.141.182 0 .027-.032.07-.07.099-.039.028-.07.079-.07.113s-.016.062-.036.062c-.019 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.036.071-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.063-.035.14 0 .078-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.036.106a.035.035 0 0 1-.035-.036c0-.019-.024-.035-.053-.035-.06 0-.58-.505-.58-.564 0-.02-.078-.115-.175-.209-.096-.094-.176-.192-.176-.218 0-.026-.031-.07-.07-.098-.038-.028-.07-.075-.07-.105s-.032-.078-.07-.106c-.039-.028-.07-.079-.07-.113s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.035-.03-.035-.063 0-.035-.032-.086-.07-.114a.192.192 0 0 1-.07-.148c0-.054-.016-.098-.036-.098-.02 0-.035-.031-.035-.07 0-.038-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.08-.035-.176 0-.096-.016-.175-.035-.175-.02 0-.036-.094-.036-.211 0-.117-.015-.211-.035-.211-.022 0-.035-.281-.035-.773s.013-.773.035-.773c.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.019 0 .035-.079.035-.175 0-.097.016-.176.035-.176.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.033.035-.071 0-.039.016-.07.035-.07.02 0 .035-.044.035-.098 0-.057.03-.119.07-.148.04-.028.07-.08.07-.114s.017-.062.036-.062c.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.029.035-.063 0-.035.032-.085.07-.113.04-.028.07-.073.07-.1.001-.026.048-.092.106-.146.058-.054.106-.117.106-.14 0-.023.063-.102.14-.176.078-.075.14-.153.14-.174 0-.05.515-.564.565-.564.021 0 .1-.064.174-.14.074-.078.156-.141.182-.141.027 0 .07-.032.099-.07.028-.04.075-.07.105-.07s.078-.033.106-.071c.027-.039.075-.07.105-.07s.078-.032.105-.07c.028-.04.08-.071.114-.071s.062-.016.062-.035c0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.036.07-.036.04 0 .071-.015.071-.035 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.035.106-.035.058 0 .105-.016.105-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.036 0-.019.047-.035.105-.035.058 0 .106-.015.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.063-.035.14-.035.077 0 .14-.016.14-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.02.129-.035.316-.035.188 0 .317-.014.317-.035 0-.021.152-.035.386-.035s.386.014.386.035Zm-.843 1.406c0 .019-.063.035-.14.035-.078 0-.14.015-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.047.035-.105.035-.058 0-.105.016-.105.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.036 0 .019-.028.035-.063.035-.034 0-.085.031-.113.07-.028.039-.07.07-.096.07-.059 0-.712.653-.712.712 0 .025-.031.069-.07.096-.039.028-.07.08-.07.114s-.016.062-.035.062c-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.02 0-.035.14-.035.351 0 .21.014.351.035.351.02 0 .036.094.036.211 0 .117.015.21.035.21.02 0 .035.064.035.141 0 .078.016.141.035.141.02 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.048.035.106 0 .058.016.105.036.105.019 0 .035.032.035.07 0 .04.015.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.026.035.057 0 .03.047.1.105.154.058.054.106.116.106.138 0 .055.656.706.712.706.025 0 .068.031.096.07.028.038.078.07.113.07.034 0 .062.016.062.035 0 .02.032.035.07.035.04 0 .07.016.07.036 0 .019.048.035.106.035.058 0 .106.015.106.035 0 .02.079.035.175.035.097 0 .176.016.176.035 0 .02.105.035.246.035.14 0 .246-.015.246-.035 0-.02.079-.035.176-.035.096 0 .175-.016.175-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.036.106-.036.058 0 .106-.015.106-.035 0-.02.028-.035.062-.035.035 0 .085-.032.113-.07.028-.039.071-.07.096-.07.06 0 .712-.653.712-.712 0-.025.032-.069.07-.097.04-.027.071-.075.071-.105s.032-.077.07-.105c.039-.028.07-.08.07-.114S9.23 7 9.25 7c.019 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.048.036-.106 0-.058.015-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.02 0 .035-.117.035-.28 0-.165-.015-.282-.035-.282-.02 0-.036-.094-.036-.21 0-.118-.015-.211-.035-.211-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.044-.035-.098a.192.192 0 0 0-.07-.148c-.04-.028-.07-.075-.07-.105s-.033-.078-.071-.106c-.039-.028-.07-.071-.07-.096 0-.06-.583-.642-.642-.642-.025 0-.068-.031-.096-.07-.028-.039-.08-.07-.113-.07-.035 0-.063-.016-.063-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.063-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.022-.176-.036-.457-.036s-.457.014-.457.036Zm.773.562c0 .019.08.035.176.035.097 0 .176.016.176.035 0 .02.031.035.07.035.038 0 .07.016.07.035 0 .02.044.035.098.035.057 0 .118.03.148.07.028.04.072.07.1.07.026 0 .092.048.146.106.054.058.117.106.139.106.052 0 .212.16.212.212 0 .023.048.085.106.14.058.053.105.123.105.154 0 .03.016.056.035.056.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.105.035.246 0 .14.015.246.035.246.02 0 .036.047.036.105 0 .058-.016.105-.036.105-.02 0-.035.106-.035.246 0 .141-.015.246-.035.246-.02 0-.035.064-.035.14 0 .078-.016.141-.035.141-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.047-.036.105 0 .058-.015.106-.035.106-.019 0-.035.031-.035.07 0 .039-.016.07-.035.07-.02 0-.035.028-.035.063 0 .034-.032.085-.07.113-.039.028-.07.079-.07.113 0 .035-.016.063-.036.063-.02 0-.035.024-.035.053 0 .07-.72.79-.79.79-.03 0-.053.016-.053.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035 0 .02-.032.035-.071.035-.039 0-.07.016-.07.036 0 .019-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.047.035-.105.035-.058 0-.105-.016-.105-.035 0-.02-.08-.035-.176-.035-.097 0-.176-.016-.176-.035 0-.02-.031-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.026-.035-.056-.035-.03 0-.117-.063-.19-.14-.075-.078-.154-.141-.176-.141-.052 0-.141-.089-.141-.14 0-.023-.063-.102-.14-.176-.078-.075-.141-.157-.141-.183 0-.026-.032-.07-.07-.098-.039-.028-.07-.08-.07-.114s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.106-.035-.247 0-.14-.015-.246-.035-.246-.02 0-.036-.079-.036-.175 0-.097.016-.176.036-.176.019 0 .035-.079.035-.176 0-.096.016-.175.035-.175.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.028.035-.063 0-.034.031-.085.07-.113.039-.028.07-.071.07-.096 0-.06.3-.36.36-.36.026 0 .07-.032.097-.07.028-.04.075-.071.106-.071.03 0 .077-.032.105-.07a.192.192 0 0 1 .148-.07c.054 0 .098-.016.098-.036 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.035 0-.021.129-.035.316-.035s.316.014.316.035ZM5.7 9.495c0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.036.07.036.04 0 .071.015.071.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .022.2.035.527.035.328 0 .527-.013.527-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.036 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.033-.035.071-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.105-.036.246-.036.14 0 .246.016.246.036 0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.024.035.054.035.064 0 .579.508.579.571 0 .025.031.069.07.097.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.041.03.07.09.07.148 0 .054.016.098.035.098.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.117.035.281 0 .246-.007.281-.062.281-.035 0-.085.032-.113.07-.028.04-.08.071-.114.071s-.062.016-.062.035c0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.036-.07.036-.04 0-.071.015-.071.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.048.035-.106.035-.058 0-.105.016-.105.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .02-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.105.036-.246.036-.14 0-.246.015-.246.035 0 .022-.2.035-.527.035-.328 0-.527-.013-.527-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.036 0-.019-.079-.035-.176-.035-.096 0-.175-.015-.175-.035 0-.019-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.047-.035-.105-.035-.058 0-.106-.015-.106-.035 0-.02-.031-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.032-.035-.071-.035-.039 0-.07-.016-.07-.036 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035-.001-.02-.03-.035-.063-.035-.035 0-.086-.032-.114-.07-.027-.039-.078-.07-.113-.07-.054 0-.062-.036-.062-.282 0-.164.014-.28.035-.28.02 0 .035-.064.035-.141 0-.078.016-.14.035-.14.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.028.035-.063 0-.034.032-.085.07-.113.039-.027.07-.075.07-.105s.032-.078.07-.105c.04-.028.071-.072.071-.097 0-.063.515-.571.58-.571.029 0 .053-.016.053-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.035 0-.02.106-.036.246-.036s.246.016.246.036Z"
                                                        clipRule="evenodd"
                                                      />
                                                    </Mask>
                                                    <Path
                                                      fill="#555"
                                                      fillRule="evenodd"
                                                      d="M6.403.5c0 .02-.106.035-.246.035S5.91.55 5.91.57c0 .02-.094.035-.211.035-.117 0-.21.016-.21.036 0 .019-.048.035-.106.035-.058 0-.106.015-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.038 0-.07.016-.07.036 0 .019-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035-.001.02-.033.036-.071.036-.039 0-.07.015-.07.035 0 .019-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.029.035-.063.035s-.085.032-.113.07c-.028.04-.076.07-.106.07s-.077.033-.105.071c-.028.039-.073.07-.1.07-.026 0-.092.048-.146.106-.054.058-.116.105-.137.105-.051 0-1.128 1.077-1.128 1.128 0 .021-.047.083-.105.137-.058.054-.106.12-.106.147 0 .027-.031.071-.07.1-.039.027-.07.078-.07.112 0 .035-.016.063-.035.063-.02 0-.035.028-.035.062 0 .035-.032.086-.07.113-.04.028-.071.08-.071.114s-.016.062-.035.062c-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.036.032-.036.07 0 .04-.015.071-.035.071-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.035.031-.035.07 0 .038-.016.07-.036.07-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.019 0-.035.079-.035.176 0 .096-.016.175-.035.175-.022 0-.035.34-.035.949s.013.948.035.948c.02 0 .035.094.035.211 0 .117.016.211.035.211.02 0 .036.063.036.14 0 .078.015.141.035.141.019 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.048.035.105 0 .058.016.106.035.106.02 0 .036.032.036.07 0 .039.015.07.035.07.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.032.035.071 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.029.035.063 0 .035.032.086.07.114.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.039.028.07.072.07.099 0 .027.048.093.106.147.058.054.105.116.105.137 0 .051 1.077 1.128 1.128 1.128.021 0 .083.047.137.105.054.058.12.106.147.106.026 0 .071.031.099.07.028.038.075.07.105.07s.078.032.106.07c.028.039.079.07.113.07s.062.016.062.036c0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.048.036.106.036.058 0 .105.015.105.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.063.035.14.035.078 0 .141.016.141.035 0 .02.08.036.176.036.096 0 .176.015.176.035 0 .02.117.035.28.035.165 0 .282.014.282.035 0 .022.222.035.597.035s.597-.013.597-.035c0-.02.117-.035.281-.035.164 0 .281-.015.281-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.019.063-.035.14-.035.078 0 .14-.015.14-.035 0-.02.048-.035.106-.035.058 0 .106-.016.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.036 0-.019.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.036 0-.019.033-.035.071-.035.039 0 .07-.015.07-.035 0-.019.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.029-.035.063-.035s.085-.032.113-.07c.028-.04.075-.07.106-.07.03 0 .077-.033.105-.071.028-.039.072-.07.1-.07.026 0 .092-.048.146-.106.054-.058.116-.105.137-.105.051 0 1.058-1.007 1.058-1.058 0-.02.047-.083.105-.137.058-.054.105-.117.105-.14 0-.024.048-.087.106-.141.058-.054.105-.124.105-.155 0-.03.016-.056.035-.056.02 0 .035-.028.035-.062 0-.035.032-.086.07-.114.04-.027.071-.078.071-.113 0-.034.016-.062.035-.062.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .035-.031.035-.07 0-.038.016-.07.036-.07.019 0 .035-.048.035-.106 0-.057.016-.105.035-.105.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.063.035-.14 0-.078.016-.14.035-.14.02 0 .036-.064.036-.141 0-.078.015-.14.035-.14.02 0 .035-.095.035-.212 0-.117.015-.21.035-.21.022 0 .035-.317.035-.879s-.013-.878-.035-.878c-.02 0-.035-.094-.035-.211 0-.117-.016-.21-.035-.21-.02 0-.035-.08-.035-.177 0-.096-.016-.175-.036-.175-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.036-.048-.036-.106 0-.058-.015-.105-.035-.105-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.047-.035-.105 0-.058-.016-.106-.035-.106-.02 0-.035-.031-.035-.07 0-.039-.016-.07-.036-.07-.019 0-.035-.029-.035-.063s-.031-.085-.07-.113c-.039-.028-.07-.079-.07-.113 0-.035-.016-.063-.035-.063-.02 0-.036-.028-.036-.062 0-.035-.031-.086-.07-.113-.038-.028-.07-.076-.07-.106s-.032-.077-.07-.105c-.039-.028-.07-.073-.07-.1 0-.026-.048-.092-.106-.146-.058-.054-.105-.116-.105-.138 0-.05-.936-.986-.987-.986-.02 0-.099-.064-.173-.141-.074-.077-.156-.14-.183-.14-.026 0-.07-.032-.098-.07-.028-.04-.079-.071-.113-.071s-.063-.016-.063-.035c0-.02-.028-.035-.062-.035s-.085-.032-.113-.07c-.028-.04-.08-.07-.114-.07s-.062-.017-.062-.036c0-.02-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.036 0-.019-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.064-.035-.14-.035C8.503.676 8.44.66 8.44.64c0-.02-.08-.036-.176-.036-.097 0-.176-.015-.176-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.035 0-.022-.222-.035-.597-.035S6.403.478 6.403.5Zm.983.562c0 .021.13.035.317.035s.316.015.316.035c0 .02.079.036.176.036.096 0 .175.015.175.035 0 .019.064.035.14.035.078 0 .141.016.141.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.032.035.071.035.039 0 .07.016.07.036 0 .019.029.035.063.035s.085.031.113.07c.028.039.079.07.113.07.035 0 .063.016.063.035 0 .02.028.036.062.036.035 0 .086.031.113.07.028.038.076.07.106.07s.077.032.105.07c.028.039.072.07.098.07.026 0 .124.08.218.176.095.097.189.176.21.176.05 0 .423.373.423.423 0 .021.079.115.176.21.096.094.175.189.175.211 0 .023.048.086.106.14.058.054.105.12.105.147 0 .026.032.07.07.099.039.028.07.078.07.113 0 .034.016.062.036.062.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.036.071.019 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.064.035.14 0 .078.016.141.035.141.02 0 .036.106.036.246s.015.246.035.246c.022 0 .035.27.035.738 0 .469-.013.738-.035.738-.02 0-.035.094-.035.21 0 .118-.016.212-.036.212-.019 0-.035.063-.035.14 0 .077-.016.14-.035.14-.02 0-.035.064-.035.141 0 .077-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.036.047-.036.105 0 .058-.015.105-.035.105-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.033-.035.071 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.029-.035.063s-.032.085-.07.113c-.04.028-.07.073-.07.1 0 .026-.048.092-.106.146-.058.054-.106.117-.106.14 0 .023-.063.102-.14.176-.078.075-.14.153-.14.174 0 .054-.447.494-.502.494-.025 0-.068.032-.096.07-.071.1-.106.088-.106-.035 0-.058-.015-.105-.035-.105-.019 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.036-.032-.036-.07 0-.039-.015-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.029-.035-.063s-.032-.085-.07-.113c-.04-.028-.071-.072-.071-.099 0-.026-.063-.108-.14-.182-.078-.075-.141-.153-.141-.174 0-.052-.232-.283-.283-.283-.022 0-.085-.048-.139-.106-.054-.057-.123-.105-.154-.105s-.056-.016-.056-.035c0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.044.035-.098.035a.192.192 0 0 0-.148.07c-.028.039-.079.07-.113.07-.035 0-.063.016-.063.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .021-.152.035-.386.035s-.386-.014-.386-.035c0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.028-.035-.063-.035-.034 0-.085-.031-.113-.07a.192.192 0 0 0-.148-.07c-.054 0-.098-.016-.098-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.026.035-.057.035-.03 0-.1.048-.154.105-.054.058-.117.106-.139.106-.05 0-.283.231-.283.283 0 .021-.063.1-.14.174-.078.074-.141.156-.141.182 0 .027-.032.07-.07.099-.039.028-.07.079-.07.113s-.016.062-.036.062c-.019 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.036.071-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.063-.035.14 0 .078-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.036.106a.035.035 0 0 1-.035-.036c0-.019-.024-.035-.053-.035-.06 0-.58-.505-.58-.564 0-.02-.078-.115-.175-.209-.096-.094-.176-.192-.176-.218 0-.026-.031-.07-.07-.098-.038-.028-.07-.075-.07-.105s-.032-.078-.07-.106c-.039-.028-.07-.079-.07-.113s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.035-.03-.035-.063 0-.035-.032-.086-.07-.114a.192.192 0 0 1-.07-.148c0-.054-.016-.098-.036-.098-.02 0-.035-.031-.035-.07 0-.038-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.08-.035-.176 0-.096-.016-.175-.035-.175-.02 0-.036-.094-.036-.211 0-.117-.015-.211-.035-.211-.022 0-.035-.281-.035-.773s.013-.773.035-.773c.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.019 0 .035-.079.035-.175 0-.097.016-.176.035-.176.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.033.035-.071 0-.039.016-.07.035-.07.02 0 .035-.044.035-.098 0-.057.03-.119.07-.148.04-.028.07-.08.07-.114s.017-.062.036-.062c.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.029.035-.063 0-.035.032-.085.07-.113.04-.028.07-.073.07-.1.001-.026.048-.092.106-.146.058-.054.106-.117.106-.14 0-.023.063-.102.14-.176.078-.075.14-.153.14-.174 0-.05.515-.564.565-.564.021 0 .1-.064.174-.14.074-.078.156-.141.182-.141.027 0 .07-.032.099-.07.028-.04.075-.07.105-.07s.078-.033.106-.071c.027-.039.075-.07.105-.07s.078-.032.105-.07c.028-.04.08-.071.114-.071s.062-.016.062-.035c0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.036.07-.036.04 0 .071-.015.071-.035 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.035.106-.035.058 0 .105-.016.105-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.036 0-.019.047-.035.105-.035.058 0 .106-.015.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.063-.035.14-.035.077 0 .14-.016.14-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.02.129-.035.316-.035.188 0 .317-.014.317-.035 0-.021.152-.035.386-.035s.386.014.386.035Zm-.843 1.406c0 .019-.063.035-.14.035-.078 0-.14.015-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.047.035-.105.035-.058 0-.105.016-.105.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.036 0 .019-.028.035-.063.035-.034 0-.085.031-.113.07-.028.039-.07.07-.096.07-.059 0-.712.653-.712.712 0 .025-.031.069-.07.096-.039.028-.07.08-.07.114s-.016.062-.035.062c-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.02 0-.035.14-.035.351 0 .21.014.351.035.351.02 0 .036.094.036.211 0 .117.015.21.035.21.02 0 .035.064.035.141 0 .078.016.141.035.141.02 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.048.035.106 0 .058.016.105.036.105.019 0 .035.032.035.07 0 .04.015.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.026.035.057 0 .03.047.1.105.154.058.054.106.116.106.138 0 .055.656.706.712.706.025 0 .068.031.096.07.028.038.078.07.113.07.034 0 .062.016.062.035 0 .02.032.035.07.035.04 0 .07.016.07.036 0 .019.048.035.106.035.058 0 .106.015.106.035 0 .02.079.035.175.035.097 0 .176.016.176.035 0 .02.105.035.246.035.14 0 .246-.015.246-.035 0-.02.079-.035.176-.035.096 0 .175-.016.175-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.036.106-.036.058 0 .106-.015.106-.035 0-.02.028-.035.062-.035.035 0 .085-.032.113-.07.028-.039.071-.07.096-.07.06 0 .712-.653.712-.712 0-.025.032-.069.07-.097.04-.027.071-.075.071-.105s.032-.077.07-.105c.039-.028.07-.08.07-.114S9.23 7 9.25 7c.019 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.048.036-.106 0-.058.015-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.02 0 .035-.117.035-.28 0-.165-.015-.282-.035-.282-.02 0-.036-.094-.036-.21 0-.118-.015-.211-.035-.211-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.044-.035-.098a.192.192 0 0 0-.07-.148c-.04-.028-.07-.075-.07-.105s-.033-.078-.071-.106c-.039-.028-.07-.071-.07-.096 0-.06-.583-.642-.642-.642-.025 0-.068-.031-.096-.07-.028-.039-.08-.07-.113-.07-.035 0-.063-.016-.063-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.063-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.022-.176-.036-.457-.036s-.457.014-.457.036Zm.773.562c0 .019.08.035.176.035.097 0 .176.016.176.035 0 .02.031.035.07.035.038 0 .07.016.07.035 0 .02.044.035.098.035.057 0 .118.03.148.07.028.04.072.07.1.07.026 0 .092.048.146.106.054.058.117.106.139.106.052 0 .212.16.212.212 0 .023.048.085.106.14.058.053.105.123.105.154 0 .03.016.056.035.056.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.105.035.246 0 .14.015.246.035.246.02 0 .036.047.036.105 0 .058-.016.105-.036.105-.02 0-.035.106-.035.246 0 .141-.015.246-.035.246-.02 0-.035.064-.035.14 0 .078-.016.141-.035.141-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.047-.036.105 0 .058-.015.106-.035.106-.019 0-.035.031-.035.07 0 .039-.016.07-.035.07-.02 0-.035.028-.035.063 0 .034-.032.085-.07.113-.039.028-.07.079-.07.113 0 .035-.016.063-.036.063-.02 0-.035.024-.035.053 0 .07-.72.79-.79.79-.03 0-.053.016-.053.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035 0 .02-.032.035-.071.035-.039 0-.07.016-.07.036 0 .019-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.047.035-.105.035-.058 0-.105-.016-.105-.035 0-.02-.08-.035-.176-.035-.097 0-.176-.016-.176-.035 0-.02-.031-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.026-.035-.056-.035-.03 0-.117-.063-.19-.14-.075-.078-.154-.141-.176-.141-.052 0-.141-.089-.141-.14 0-.023-.063-.102-.14-.176-.078-.075-.141-.157-.141-.183 0-.026-.032-.07-.07-.098-.039-.028-.07-.08-.07-.114s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.106-.035-.247 0-.14-.015-.246-.035-.246-.02 0-.036-.079-.036-.175 0-.097.016-.176.036-.176.019 0 .035-.079.035-.176 0-.096.016-.175.035-.175.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.028.035-.063 0-.034.031-.085.07-.113.039-.028.07-.071.07-.096 0-.06.3-.36.36-.36.026 0 .07-.032.097-.07.028-.04.075-.071.106-.071.03 0 .077-.032.105-.07a.192.192 0 0 1 .148-.07c.054 0 .098-.016.098-.036 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.035 0-.021.129-.035.316-.035s.316.014.316.035ZM5.7 9.495c0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.036.07.036.04 0 .071.015.071.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .022.2.035.527.035.328 0 .527-.013.527-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.036 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.033-.035.071-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.105-.036.246-.036.14 0 .246.016.246.036 0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.024.035.054.035.064 0 .579.508.579.571 0 .025.031.069.07.097.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.041.03.07.09.07.148 0 .054.016.098.035.098.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.117.035.281 0 .246-.007.281-.062.281-.035 0-.085.032-.113.07-.028.04-.08.071-.114.071s-.062.016-.062.035c0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.036-.07.036-.04 0-.071.015-.071.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.048.035-.106.035-.058 0-.105.016-.105.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .02-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.105.036-.246.036-.14 0-.246.015-.246.035 0 .022-.2.035-.527.035-.328 0-.527-.013-.527-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.036 0-.019-.079-.035-.176-.035-.096 0-.175-.015-.175-.035 0-.019-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.047-.035-.105-.035-.058 0-.106-.015-.106-.035 0-.02-.031-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.032-.035-.071-.035-.039 0-.07-.016-.07-.036 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035-.001-.02-.03-.035-.063-.035-.035 0-.086-.032-.114-.07-.027-.039-.078-.07-.113-.07-.054 0-.062-.036-.062-.282 0-.164.014-.28.035-.28.02 0 .035-.064.035-.141 0-.078.016-.14.035-.14.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.028.035-.063 0-.034.032-.085.07-.113.039-.027.07-.075.07-.105s.032-.078.07-.105c.04-.028.071-.072.071-.097 0-.063.515-.571.58-.571.029 0 .053-.016.053-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.035 0-.02.106-.036.246-.036s.246.016.246.036Z"
                                                      clipRule="evenodd"
                                                    />
                                                    <Path
                                                      stroke="#555"
                                                      strokeWidth={0.6}
                                                      d="M6.403.5c0 .02-.106.035-.246.035S5.91.55 5.91.57c0 .02-.094.035-.211.035-.117 0-.21.016-.21.036 0 .019-.048.035-.106.035-.058 0-.106.015-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.038 0-.07.016-.07.036 0 .019-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.031.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035-.001.02-.033.036-.071.036-.039 0-.07.015-.07.035 0 .019-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.029.035-.063.035s-.085.032-.113.07c-.028.04-.076.07-.106.07s-.077.033-.105.071c-.028.039-.073.07-.1.07-.026 0-.092.048-.146.106-.054.058-.116.105-.137.105-.051 0-1.128 1.077-1.128 1.128 0 .021-.047.083-.105.137-.058.054-.106.12-.106.147 0 .027-.031.071-.07.1-.039.027-.07.078-.07.112 0 .035-.016.063-.035.063-.02 0-.035.028-.035.062 0 .035-.032.086-.07.113-.04.028-.071.08-.071.114s-.016.062-.035.062c-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.036.032-.036.07 0 .04-.015.071-.035.071-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.035.031-.035.07 0 .038-.016.07-.036.07-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.019 0-.035.079-.035.176 0 .096-.016.175-.035.175-.022 0-.035.34-.035.949s.013.948.035.948c.02 0 .035.094.035.211 0 .117.016.211.035.211.02 0 .036.063.036.14 0 .078.015.141.035.141.019 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.048.035.105 0 .058.016.106.035.106.02 0 .036.032.036.07 0 .039.015.07.035.07.02 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.032.035.071 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.029.035.063 0 .035.032.086.07.114.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.039.028.07.072.07.099 0 .027.048.093.106.147.058.054.105.116.105.137 0 .051 1.077 1.128 1.128 1.128.021 0 .083.047.137.105.054.058.12.106.147.106.026 0 .071.031.099.07.028.038.075.07.105.07s.078.032.106.07c.028.039.079.07.113.07s.062.016.062.036c0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.048.036.106.036.058 0 .105.015.105.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.063.035.14.035.078 0 .141.016.141.035 0 .02.08.036.176.036.096 0 .176.015.176.035 0 .02.117.035.28.035.165 0 .282.014.282.035 0 .022.222.035.597.035s.597-.013.597-.035c0-.02.117-.035.281-.035.164 0 .281-.015.281-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.019.063-.035.14-.035.078 0 .14-.015.14-.035 0-.02.048-.035.106-.035.058 0 .106-.016.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.036 0-.019.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.036 0-.019.033-.035.071-.035.039 0 .07-.015.07-.035 0-.019.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.029-.035.063-.035s.085-.032.113-.07c.028-.04.075-.07.106-.07.03 0 .077-.033.105-.071.028-.039.072-.07.1-.07.026 0 .092-.048.146-.106.054-.058.116-.105.137-.105.051 0 1.058-1.007 1.058-1.058 0-.02.047-.083.105-.137.058-.054.105-.117.105-.14 0-.024.048-.087.106-.141.058-.054.105-.124.105-.155 0-.03.016-.056.035-.056.02 0 .035-.028.035-.062 0-.035.032-.086.07-.114.04-.027.071-.078.071-.113 0-.034.016-.062.035-.062.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .035-.031.035-.07 0-.038.016-.07.036-.07.019 0 .035-.048.035-.106 0-.057.016-.105.035-.105.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.063.035-.14 0-.078.016-.14.035-.14.02 0 .036-.064.036-.141 0-.078.015-.14.035-.14.02 0 .035-.095.035-.212 0-.117.015-.21.035-.21.022 0 .035-.317.035-.879s-.013-.878-.035-.878c-.02 0-.035-.094-.035-.211 0-.117-.016-.21-.035-.21-.02 0-.035-.08-.035-.177 0-.096-.016-.175-.036-.175-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.036-.048-.036-.106 0-.058-.015-.105-.035-.105-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.047-.035-.105 0-.058-.016-.106-.035-.106-.02 0-.035-.031-.035-.07 0-.039-.016-.07-.036-.07-.019 0-.035-.029-.035-.063s-.031-.085-.07-.113c-.039-.028-.07-.079-.07-.113 0-.035-.016-.063-.035-.063-.02 0-.036-.028-.036-.062 0-.035-.031-.086-.07-.113-.038-.028-.07-.076-.07-.106s-.032-.077-.07-.105c-.039-.028-.07-.073-.07-.1 0-.026-.048-.092-.106-.146-.058-.054-.105-.116-.105-.138 0-.05-.936-.986-.987-.986-.02 0-.099-.064-.173-.141-.074-.077-.156-.14-.183-.14-.026 0-.07-.032-.098-.07-.028-.04-.079-.071-.113-.071s-.063-.016-.063-.035c0-.02-.028-.035-.062-.035s-.085-.032-.113-.07c-.028-.04-.08-.07-.114-.07s-.062-.017-.062-.036c0-.02-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.036 0-.019-.032-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.064-.035-.14-.035C8.503.676 8.44.66 8.44.64c0-.02-.08-.036-.176-.036-.097 0-.176-.015-.176-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.035 0-.022-.222-.035-.597-.035S6.403.478 6.403.5Zm.983.562c0 .021.13.035.317.035s.316.015.316.035c0 .02.079.036.176.036.096 0 .175.015.175.035 0 .019.064.035.14.035.078 0 .141.016.141.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.036.07.036.039 0 .07.015.07.035 0 .02.048.035.106.035.058 0 .105.016.105.035 0 .02.032.035.07.035.04 0 .07.016.07.035 0 .02.032.035.071.035.039 0 .07.016.07.036 0 .019.029.035.063.035s.085.031.113.07c.028.039.079.07.113.07.035 0 .063.016.063.035 0 .02.028.036.062.036.035 0 .086.031.113.07.028.038.076.07.106.07s.077.032.105.07c.028.039.072.07.098.07.026 0 .124.08.218.176.095.097.189.176.21.176.05 0 .423.373.423.423 0 .021.079.115.176.21.096.094.175.189.175.211 0 .023.048.086.106.14.058.054.105.12.105.147 0 .026.032.07.07.099.039.028.07.078.07.113 0 .034.016.062.036.062.02 0 .035.032.035.07 0 .04.016.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.036.071.019 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.064.035.14 0 .078.016.141.035.141.02 0 .036.106.036.246s.015.246.035.246c.022 0 .035.27.035.738 0 .469-.013.738-.035.738-.02 0-.035.094-.035.21 0 .118-.016.212-.036.212-.019 0-.035.063-.035.14 0 .077-.016.14-.035.14-.02 0-.035.064-.035.141 0 .077-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.035.106-.02 0-.036.047-.036.105 0 .058-.015.105-.035.105-.019 0-.035.032-.035.07 0 .04-.016.07-.035.07-.02 0-.035.033-.035.071 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.029-.035.063s-.032.085-.07.113c-.04.028-.07.073-.07.1 0 .026-.048.092-.106.146-.058.054-.106.117-.106.14 0 .023-.063.102-.14.176-.078.075-.14.153-.14.174 0 .054-.447.494-.502.494-.025 0-.068.032-.096.07-.071.1-.106.088-.106-.035 0-.058-.015-.105-.035-.105-.019 0-.035-.063-.035-.14 0-.078-.016-.141-.035-.141-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.036-.032-.036-.07 0-.039-.015-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.029-.035-.063s-.032-.085-.07-.113c-.04-.028-.071-.072-.071-.099 0-.026-.063-.108-.14-.182-.078-.075-.141-.153-.141-.174 0-.052-.232-.283-.283-.283-.022 0-.085-.048-.139-.106-.054-.057-.123-.105-.154-.105s-.056-.016-.056-.035c0-.02-.032-.035-.07-.035-.04 0-.071-.016-.071-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.044.035-.098.035a.192.192 0 0 0-.148.07c-.028.039-.079.07-.113.07-.035 0-.063.016-.063.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .021-.152.035-.386.035s-.386-.014-.386-.035c0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.028-.035-.063-.035-.034 0-.085-.031-.113-.07a.192.192 0 0 0-.148-.07c-.054 0-.098-.016-.098-.035 0-.02-.047-.035-.105-.035-.058 0-.106-.016-.106-.036 0-.02-.129-.035-.316-.035s-.316.015-.316.035c0 .02-.048.036-.106.036-.058 0-.105.015-.105.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.026.035-.057.035-.03 0-.1.048-.154.105-.054.058-.117.106-.139.106-.05 0-.283.231-.283.283 0 .021-.063.1-.14.174-.078.074-.141.156-.141.182 0 .027-.032.07-.07.099-.039.028-.07.079-.07.113s-.016.062-.036.062c-.019 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.035.032-.035.07 0 .039-.016.07-.035.07-.02 0-.035.032-.035.07 0 .04-.016.071-.036.071-.019 0-.035.047-.035.105 0 .058-.015.106-.035.106-.02 0-.035.047-.035.105 0 .058-.016.106-.035.106-.02 0-.035.063-.035.14 0 .078-.016.14-.035.14-.02 0-.035.048-.035.106 0 .058-.016.106-.036.106a.035.035 0 0 1-.035-.036c0-.019-.024-.035-.053-.035-.06 0-.58-.505-.58-.564 0-.02-.078-.115-.175-.209-.096-.094-.176-.192-.176-.218 0-.026-.031-.07-.07-.098-.038-.028-.07-.075-.07-.105s-.032-.078-.07-.106c-.039-.028-.07-.079-.07-.113s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.04-.016-.07-.035-.07-.02 0-.035-.03-.035-.063 0-.035-.032-.086-.07-.114a.192.192 0 0 1-.07-.148c0-.054-.016-.098-.036-.098-.02 0-.035-.031-.035-.07 0-.038-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.035-.105-.02 0-.035-.08-.035-.176 0-.096-.016-.175-.035-.175-.02 0-.036-.094-.036-.211 0-.117-.015-.211-.035-.211-.022 0-.035-.281-.035-.773s.013-.773.035-.773c.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.019 0 .035-.079.035-.175 0-.097.016-.176.035-.176.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .035-.047.035-.105 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.07.035-.07.02 0 .035-.033.035-.071 0-.039.016-.07.035-.07.02 0 .035-.044.035-.098 0-.057.03-.119.07-.148.04-.028.07-.08.07-.114s.017-.062.036-.062c.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.029.035-.063 0-.035.032-.085.07-.113.04-.028.07-.073.07-.1.001-.026.048-.092.106-.146.058-.054.106-.117.106-.14 0-.023.063-.102.14-.176.078-.075.14-.153.14-.174 0-.05.515-.564.565-.564.021 0 .1-.064.174-.14.074-.078.156-.141.182-.141.027 0 .07-.032.099-.07.028-.04.075-.07.105-.07s.078-.033.106-.071c.027-.039.075-.07.105-.07s.078-.032.105-.07c.028-.04.08-.071.114-.071s.062-.016.062-.035c0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.032-.036.07-.036.04 0 .071-.015.071-.035 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.035.106-.035.058 0 .105-.016.105-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.036 0-.019.047-.035.105-.035.058 0 .106-.015.106-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.063-.035.14-.035.077 0 .14-.016.14-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.036 0-.02.129-.035.316-.035.188 0 .317-.014.317-.035 0-.021.152-.035.386-.035s.386.014.386.035Zm-.843 1.406c0 .019-.063.035-.14.035-.078 0-.14.015-.14.035 0 .02-.048.035-.106.035-.058 0-.106.016-.106.035 0 .02-.047.035-.105.035-.058 0-.105.016-.105.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.036 0 .019-.028.035-.063.035-.034 0-.085.031-.113.07-.028.039-.07.07-.096.07-.059 0-.712.653-.712.712 0 .025-.031.069-.07.096-.039.028-.07.08-.07.114s-.016.062-.035.062c-.02 0-.036.032-.036.07 0 .039-.015.07-.035.07-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.048-.035.106 0 .058-.016.105-.035.105-.02 0-.035.08-.035.176 0 .097-.016.176-.036.176-.02 0-.035.14-.035.351 0 .21.014.351.035.351.02 0 .036.094.036.211 0 .117.015.21.035.21.02 0 .035.064.035.141 0 .078.016.141.035.141.02 0 .035.032.035.07 0 .039.016.07.035.07.02 0 .035.048.035.106 0 .058.016.105.036.105.019 0 .035.032.035.07 0 .04.015.07.035.07.02 0 .035.033.035.071 0 .039.016.07.035.07.02 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.026.035.057 0 .03.047.1.105.154.058.054.106.116.106.138 0 .055.656.706.712.706.025 0 .068.031.096.07.028.038.078.07.113.07.034 0 .062.016.062.035 0 .02.032.035.07.035.04 0 .07.016.07.036 0 .019.048.035.106.035.058 0 .106.015.106.035 0 .02.079.035.175.035.097 0 .176.016.176.035 0 .02.105.035.246.035.14 0 .246-.015.246-.035 0-.02.079-.035.176-.035.096 0 .175-.016.175-.035 0-.02.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.048-.036.106-.036.058 0 .106-.015.106-.035 0-.02.028-.035.062-.035.035 0 .085-.032.113-.07.028-.039.071-.07.096-.07.06 0 .712-.653.712-.712 0-.025.032-.069.07-.097.04-.027.071-.075.071-.105s.032-.077.07-.105c.039-.028.07-.08.07-.114S9.23 7 9.25 7c.019 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.048.036-.106 0-.058.015-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.094.035-.21 0-.118.016-.212.036-.212.02 0 .035-.117.035-.28 0-.165-.015-.282-.035-.282-.02 0-.036-.094-.036-.21 0-.118-.015-.211-.035-.211-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.044-.035-.098a.192.192 0 0 0-.07-.148c-.04-.028-.07-.075-.07-.105s-.033-.078-.071-.106c-.039-.028-.07-.071-.07-.096 0-.06-.583-.642-.642-.642-.025 0-.068-.031-.096-.07-.028-.039-.08-.07-.113-.07-.035 0-.063-.016-.063-.035 0-.02-.032-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.063-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.022-.176-.036-.457-.036s-.457.014-.457.036Zm.773.562c0 .019.08.035.176.035.097 0 .176.016.176.035 0 .02.031.035.07.035.038 0 .07.016.07.035 0 .02.044.035.098.035.057 0 .118.03.148.07.028.04.072.07.1.07.026 0 .092.048.146.106.054.058.117.106.139.106.052 0 .212.16.212.212 0 .023.048.085.106.14.058.053.105.123.105.154 0 .03.016.056.035.056.02 0 .035.032.035.07 0 .039.016.07.036.07.019 0 .035.032.035.07 0 .04.016.071.035.071.02 0 .035.047.035.105 0 .058.016.106.035.106.02 0 .035.105.035.246 0 .14.015.246.035.246.02 0 .036.047.036.105 0 .058-.016.105-.036.105-.02 0-.035.106-.035.246 0 .141-.015.246-.035.246-.02 0-.035.064-.035.14 0 .078-.016.141-.035.141-.02 0-.035.032-.035.07 0 .04-.016.071-.035.071-.02 0-.036.047-.036.105 0 .058-.015.106-.035.106-.019 0-.035.031-.035.07 0 .039-.016.07-.035.07-.02 0-.035.028-.035.063 0 .034-.032.085-.07.113-.039.028-.07.079-.07.113 0 .035-.016.063-.036.063-.02 0-.035.024-.035.053 0 .07-.72.79-.79.79-.03 0-.053.016-.053.035 0 .02-.032.035-.07.035-.04 0-.07.016-.07.035 0 .02-.032.035-.071.035-.039 0-.07.016-.07.036 0 .019-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.047.035-.105.035-.058 0-.105-.016-.105-.035 0-.02-.08-.035-.176-.035-.097 0-.176-.016-.176-.035 0-.02-.031-.036-.07-.036-.039 0-.07-.015-.07-.035 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.026-.035-.056-.035-.03 0-.117-.063-.19-.14-.075-.078-.154-.141-.176-.141-.052 0-.141-.089-.141-.14 0-.023-.063-.102-.14-.176-.078-.075-.141-.157-.141-.183 0-.026-.032-.07-.07-.098-.039-.028-.07-.08-.07-.114s-.016-.062-.036-.062c-.02 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.032-.035-.07 0-.04-.016-.071-.035-.071-.02 0-.035-.048-.035-.106 0-.058-.016-.105-.036-.105-.019 0-.035-.032-.035-.07 0-.039-.016-.07-.035-.07-.02 0-.035-.064-.035-.141 0-.077-.016-.14-.035-.14-.02 0-.035-.106-.035-.247 0-.14-.015-.246-.035-.246-.02 0-.036-.079-.036-.175 0-.097.016-.176.036-.176.019 0 .035-.079.035-.176 0-.096.016-.175.035-.175.02 0 .035-.048.035-.106 0-.058.016-.105.035-.105.02 0 .035-.032.035-.07 0-.039.016-.07.035-.07.02 0 .036-.032.036-.07 0-.04.015-.071.035-.071.019 0 .035-.028.035-.063 0-.034.031-.085.07-.113.039-.028.07-.071.07-.096 0-.06.3-.36.36-.36.026 0 .07-.032.097-.07.028-.04.075-.071.106-.071.03 0 .077-.032.105-.07a.192.192 0 0 1 .148-.07c.054 0 .098-.016.098-.036 0-.02.032-.035.07-.035.039 0 .07-.016.07-.035 0-.02.08-.035.176-.035.097 0 .176-.016.176-.035 0-.021.129-.035.316-.035s.316.014.316.035ZM5.7 9.495c0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.032.035.07.035.04 0 .071.016.071.035 0 .02.032.035.07.035.039 0 .07.016.07.035 0 .02.032.036.07.036.04 0 .071.015.071.035 0 .019.048.035.106.035.058 0 .105.016.105.035 0 .022.2.035.527.035.328 0 .527-.013.527-.035 0-.02.047-.035.105-.035.058 0 .106-.016.106-.035 0-.02.031-.035.07-.035.039 0 .07-.016.07-.036 0-.019.032-.035.07-.035.04 0 .07-.016.07-.035 0-.02.033-.035.071-.035.039 0 .07-.016.07-.035 0-.02.032-.035.07-.035.04 0 .071-.016.071-.035 0-.02.105-.036.246-.036.14 0 .246.016.246.036 0 .019.032.035.07.035.039 0 .07.016.07.035 0 .02.024.035.054.035.064 0 .579.508.579.571 0 .025.031.069.07.097.039.027.07.078.07.113 0 .034.016.062.036.062.019 0 .035.028.035.063 0 .034.031.085.07.113.041.03.07.09.07.148 0 .054.016.098.035.098.02 0 .035.031.035.07 0 .039.016.07.036.07.019 0 .035.048.035.106 0 .058.016.105.035.105.02 0 .035.063.035.14 0 .078.016.141.035.141.02 0 .035.117.035.281 0 .246-.007.281-.062.281-.035 0-.085.032-.113.07-.028.04-.08.071-.114.071s-.062.016-.062.035c0 .02-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.036-.07.036-.04 0-.071.015-.071.035 0 .019-.032.035-.07.035-.039 0-.07.016-.07.035 0 .02-.032.035-.07.035-.04 0-.071.016-.071.035 0 .02-.048.035-.106.035-.058 0-.105.016-.105.035 0 .02-.047.036-.105.036-.058 0-.106.015-.106.035 0 .02-.047.035-.105.035-.058 0-.106.016-.106.035 0 .02-.063.035-.14.035-.077 0-.14.016-.14.035 0 .02-.08.035-.176.035-.097 0-.176.016-.176.035 0 .02-.105.036-.246.036-.14 0-.246.015-.246.035 0 .022-.2.035-.527.035-.328 0-.527-.013-.527-.035 0-.02-.105-.035-.246-.035-.14 0-.246-.015-.246-.036 0-.019-.079-.035-.176-.035-.096 0-.175-.015-.175-.035 0-.019-.064-.035-.14-.035-.078 0-.141-.016-.141-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.035 0-.02-.048-.035-.106-.035-.058 0-.105-.016-.105-.036 0-.019-.047-.035-.105-.035-.058 0-.106-.015-.106-.035 0-.02-.031-.035-.07-.035-.039 0-.07-.016-.07-.035 0-.02-.032-.035-.07-.035-.04 0-.07-.016-.07-.035 0-.02-.032-.035-.071-.035-.039 0-.07-.016-.07-.036 0-.019-.032-.035-.07-.035-.04 0-.07-.016-.07-.035-.001-.02-.03-.035-.063-.035-.035 0-.086-.032-.114-.07-.027-.039-.078-.07-.113-.07-.054 0-.062-.036-.062-.282 0-.164.014-.28.035-.28.02 0 .035-.064.035-.141 0-.078.016-.14.035-.14.02 0 .035-.048.035-.106 0-.058.016-.106.035-.106.02 0 .036-.047.036-.105 0-.058.015-.105.035-.105.019 0 .035-.032.035-.07 0-.04.016-.071.035-.071.02 0 .035-.028.035-.063 0-.034.032-.085.07-.113.039-.027.07-.075.07-.105s.032-.078.07-.105c.04-.028.071-.072.071-.097 0-.063.515-.571.58-.571.029 0 .053-.016.053-.035 0-.02.031-.035.07-.035.038 0 .07-.016.07-.035 0-.02.106-.036.246-.036s.246.016.246.036Z"
                                                      clipRule="evenodd"
                                                      mask="url(#a)"
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6473 0.0645161C11.6473 0.101355 11.4527 0.129032 11.1932 0.129032C10.9338 0.129032 10.7392 0.15671 10.7392 0.193548C10.7392 0.229419 10.5662 0.258065 10.35 0.258065C10.1338 0.258065 9.96081 0.28671 9.96081 0.322581C9.96081 0.358065 9.87324 0.387097 9.76622 0.387097C9.65919 0.387097 9.57162 0.416129 9.57162 0.451613C9.57162 0.487097 9.45487 0.516129 9.31216 0.516129C9.16946 0.516129 9.0527 0.545161 9.0527 0.580645C9.0527 0.616129 8.96514 0.645161 8.85811 0.645161C8.75108 0.645161 8.66351 0.674194 8.66351 0.709677C8.66351 0.745161 8.60513 0.774194 8.53378 0.774194C8.46243 0.774194 8.40405 0.803226 8.40405 0.83871C8.40405 0.874194 8.31649 0.903226 8.20946 0.903226C8.10243 0.903226 8.01486 0.932258 8.01486 0.967742C8.01486 1.00323 7.95649 1.03226 7.88513 1.03226C7.81378 1.03226 7.75541 1.06129 7.75541 1.09677C7.75541 1.13226 7.69703 1.16129 7.62568 1.16129C7.55432 1.16129 7.49595 1.19032 7.49595 1.22581C7.49595 1.26129 7.43757 1.29032 7.36622 1.29032C7.29486 1.29032 7.23649 1.31935 7.23649 1.35484C7.23649 1.39032 7.17811 1.41935 7.10676 1.41935C7.03541 1.41935 6.97703 1.44839 6.97703 1.48387C6.97703 1.51935 6.91865 1.54839 6.8473 1.54839C6.77595 1.54839 6.71757 1.57742 6.71757 1.6129C6.71757 1.64839 6.66561 1.67742 6.60217 1.67742C6.53867 1.67742 6.44468 1.73548 6.39324 1.80645C6.34181 1.87742 6.25424 1.93548 6.19865 1.93548C6.14306 1.93548 6.05549 1.99355 6.00405 2.06452C5.95262 2.13548 5.8703 2.19355 5.82114 2.19355C5.77203 2.19355 5.64996 2.28065 5.55 2.3871C5.45004 2.49355 5.33595 2.58065 5.29644 2.58065C5.20265 2.58065 3.21486 4.55774 3.21486 4.65103C3.21486 4.69032 3.1273 4.80381 3.02027 4.90323C2.91324 5.00265 2.82568 5.12406 2.82568 5.1729C2.82568 5.22181 2.7673 5.30368 2.69595 5.35484C2.62459 5.406 2.56622 5.49948 2.56622 5.56264C2.56622 5.62574 2.53703 5.67742 2.50135 5.67742C2.46568 5.67742 2.43649 5.7291 2.43649 5.79219C2.43649 5.85535 2.37811 5.94884 2.30676 6C2.23541 6.05116 2.17703 6.14465 2.17703 6.20781C2.17703 6.2709 2.14784 6.32258 2.11216 6.32258C2.07649 6.32258 2.0473 6.38064 2.0473 6.45161C2.0473 6.52258 2.01811 6.58065 1.98243 6.58065C1.94676 6.58065 1.91757 6.63871 1.91757 6.70968C1.91757 6.78065 1.88838 6.83871 1.8527 6.83871C1.81703 6.83871 1.78784 6.89677 1.78784 6.96774C1.78784 7.03871 1.75865 7.09677 1.72297 7.09677C1.6873 7.09677 1.65811 7.18387 1.65811 7.29032C1.65811 7.39677 1.62892 7.48387 1.59324 7.48387C1.55757 7.48387 1.52838 7.54194 1.52838 7.6129C1.52838 7.68387 1.49919 7.74193 1.46351 7.74193C1.42784 7.74193 1.39865 7.82903 1.39865 7.93548C1.39865 8.04194 1.36946 8.12903 1.33378 8.12903C1.29811 8.12903 1.26892 8.21613 1.26892 8.32258C1.26892 8.42903 1.23973 8.51613 1.20405 8.51613C1.16838 8.51613 1.13919 8.60323 1.13919 8.70968C1.13919 8.81613 1.11 8.90323 1.07432 8.90323C1.03865 8.90323 1.00946 9.04839 1.00946 9.22581C1.00946 9.40323 0.98027 9.54839 0.944595 9.54839C0.908919 9.54839 0.87973 9.69355 0.87973 9.87097C0.87973 10.0484 0.850541 10.1935 0.814865 10.1935C0.773222 10.1935 0.75 10.8172 0.75 11.9355C0.75 13.0537 0.773222 13.6774 0.814865 13.6774C0.85093 13.6774 0.87973 13.8495 0.87973 14.0645C0.87973 14.2795 0.90853 14.4516 0.944595 14.4516C0.98027 14.4516 1.00946 14.5677 1.00946 14.7097C1.00946 14.8516 1.03865 14.9677 1.07432 14.9677C1.11 14.9677 1.13919 15.0839 1.13919 15.2258C1.13919 15.3677 1.16838 15.4839 1.20405 15.4839C1.23973 15.4839 1.26892 15.571 1.26892 15.6774C1.26892 15.7839 1.29811 15.871 1.33378 15.871C1.36946 15.871 1.39865 15.9581 1.39865 16.0645C1.39865 16.171 1.42784 16.2581 1.46351 16.2581C1.49919 16.2581 1.52838 16.3161 1.52838 16.3871C1.52838 16.4581 1.55757 16.5161 1.59324 16.5161C1.62892 16.5161 1.65811 16.6032 1.65811 16.7097C1.65811 16.8161 1.6873 16.9032 1.72297 16.9032C1.75865 16.9032 1.78784 16.9613 1.78784 17.0323C1.78784 17.1032 1.81703 17.1613 1.8527 17.1613C1.88838 17.1613 1.91757 17.2194 1.91757 17.2903C1.91757 17.3613 1.94676 17.4194 1.98243 17.4194C2.01811 17.4194 2.0473 17.4774 2.0473 17.5484C2.0473 17.6194 2.07649 17.6774 2.11216 17.6774C2.14784 17.6774 2.17703 17.7291 2.17703 17.7922C2.17703 17.8554 2.23541 17.9488 2.30676 18C2.37811 18.0512 2.43649 18.1446 2.43649 18.2078C2.43649 18.2709 2.46568 18.3226 2.50135 18.3226C2.53703 18.3226 2.56622 18.3743 2.56622 18.4374C2.56622 18.5005 2.62459 18.594 2.69595 18.6452C2.7673 18.6963 2.82568 18.7782 2.82568 18.8271C2.82568 18.8759 2.91324 18.9974 3.02027 19.0968C3.1273 19.1962 3.21486 19.3097 3.21486 19.349C3.21486 19.4423 5.20265 21.4194 5.29644 21.4194C5.33595 21.4194 5.45004 21.5065 5.55 21.6129C5.64996 21.7194 5.77203 21.8065 5.82114 21.8065C5.8703 21.8065 5.95262 21.8645 6.00405 21.9355C6.05549 22.0065 6.14306 22.0645 6.19865 22.0645C6.25424 22.0645 6.34181 22.1226 6.39324 22.1935C6.44468 22.2645 6.53867 22.3226 6.60217 22.3226C6.66561 22.3226 6.71757 22.3516 6.71757 22.3871C6.71757 22.4226 6.77595 22.4516 6.8473 22.4516C6.91865 22.4516 6.97703 22.4806 6.97703 22.5161C6.97703 22.5516 7.03541 22.5806 7.10676 22.5806C7.17811 22.5806 7.23649 22.6097 7.23649 22.6452C7.23649 22.6806 7.29486 22.7097 7.36622 22.7097C7.43757 22.7097 7.49595 22.7387 7.49595 22.7742C7.49595 22.8097 7.55432 22.8387 7.62568 22.8387C7.69703 22.8387 7.75541 22.8677 7.75541 22.9032C7.75541 22.9387 7.81378 22.9677 7.88513 22.9677C7.95649 22.9677 8.01486 22.9968 8.01486 23.0323C8.01486 23.0677 8.07324 23.0968 8.14459 23.0968C8.21595 23.0968 8.27432 23.1258 8.27432 23.1613C8.27432 23.1968 8.36189 23.2258 8.46892 23.2258C8.57595 23.2258 8.66351 23.2548 8.66351 23.2903C8.66351 23.3258 8.75108 23.3548 8.85811 23.3548C8.96514 23.3548 9.0527 23.3839 9.0527 23.4194C9.0527 23.4548 9.14027 23.4839 9.2473 23.4839C9.35432 23.4839 9.44189 23.5129 9.44189 23.5484C9.44189 23.5839 9.55865 23.6129 9.70135 23.6129C9.84405 23.6129 9.96081 23.6419 9.96081 23.6774C9.96081 23.7129 10.1068 23.7419 10.2851 23.7419C10.4635 23.7419 10.6095 23.771 10.6095 23.8065C10.6095 23.8441 10.8257 23.871 11.1284 23.871C11.4311 23.871 11.6473 23.8979 11.6473 23.9355C11.6473 23.9759 12.0581 24 12.75 24C13.4419 24 13.8527 23.9759 13.8527 23.9355C13.8527 23.8979 14.0689 23.871 14.3716 23.871C14.6743 23.871 14.8905 23.8441 14.8905 23.8065C14.8905 23.771 15.0365 23.7419 15.2149 23.7419C15.3932 23.7419 15.5392 23.7129 15.5392 23.6774C15.5392 23.6419 15.6559 23.6129 15.7986 23.6129C15.9414 23.6129 16.0581 23.5839 16.0581 23.5484C16.0581 23.5129 16.1457 23.4839 16.2527 23.4839C16.3597 23.4839 16.4473 23.4548 16.4473 23.4194C16.4473 23.3839 16.5349 23.3548 16.6419 23.3548C16.7489 23.3548 16.8365 23.3258 16.8365 23.2903C16.8365 23.2548 16.8949 23.2258 16.9662 23.2258C17.0376 23.2258 17.0959 23.1968 17.0959 23.1613C17.0959 23.1258 17.1835 23.0968 17.2905 23.0968C17.3976 23.0968 17.4851 23.0677 17.4851 23.0323C17.4851 22.9968 17.5435 22.9677 17.6149 22.9677C17.6862 22.9677 17.7446 22.9387 17.7446 22.9032C17.7446 22.8677 17.803 22.8387 17.8743 22.8387C17.9457 22.8387 18.0041 22.8097 18.0041 22.7742C18.0041 22.7387 18.0624 22.7097 18.1338 22.7097C18.2051 22.7097 18.2635 22.6806 18.2635 22.6452C18.2635 22.6097 18.3219 22.5806 18.3932 22.5806C18.4646 22.5806 18.523 22.5516 18.523 22.5161C18.523 22.4806 18.5814 22.4516 18.6527 22.4516C18.7241 22.4516 18.7824 22.4226 18.7824 22.3871C18.7824 22.3516 18.8344 22.3226 18.8978 22.3226C18.9613 22.3226 19.0553 22.2645 19.1068 22.1935C19.1582 22.1226 19.2458 22.0645 19.3014 22.0645C19.3569 22.0645 19.4445 22.0065 19.4959 21.9355C19.5474 21.8645 19.6297 21.8065 19.6789 21.8065C19.728 21.8065 19.85 21.7194 19.95 21.6129C20.05 21.5065 20.1641 21.4194 20.2036 21.4194C20.2974 21.4194 22.1554 19.5714 22.1554 19.4781C22.1554 19.4388 22.243 19.3252 22.35 19.2258C22.457 19.1264 22.5446 19.0103 22.5446 18.9677C22.5446 18.9252 22.6322 18.8091 22.7392 18.7097C22.8462 18.6103 22.9338 18.4825 22.9338 18.4257C22.9338 18.369 22.963 18.3226 22.9986 18.3226C23.0343 18.3226 23.0635 18.2709 23.0635 18.2078C23.0635 18.1446 23.1219 18.0512 23.1932 18C23.2646 17.9488 23.323 17.8554 23.323 17.7922C23.323 17.7291 23.3522 17.6774 23.3878 17.6774C23.4235 17.6774 23.4527 17.6194 23.4527 17.5484C23.4527 17.4774 23.4819 17.4194 23.5176 17.4194C23.5532 17.4194 23.5824 17.3613 23.5824 17.2903C23.5824 17.2194 23.6116 17.1613 23.6473 17.1613C23.683 17.1613 23.7122 17.1032 23.7122 17.0323C23.7122 16.9613 23.7414 16.9032 23.777 16.9032C23.8127 16.9032 23.8419 16.8161 23.8419 16.7097C23.8419 16.6032 23.8711 16.5161 23.9068 16.5161C23.9424 16.5161 23.9716 16.4581 23.9716 16.3871C23.9716 16.3161 24.0008 16.2581 24.0365 16.2581C24.0722 16.2581 24.1014 16.171 24.1014 16.0645C24.1014 15.9581 24.1305 15.871 24.1662 15.871C24.2019 15.871 24.2311 15.7839 24.2311 15.6774C24.2311 15.571 24.2603 15.4839 24.2959 15.4839C24.3316 15.4839 24.3608 15.3677 24.3608 15.2258C24.3608 15.0839 24.39 14.9677 24.4257 14.9677C24.4614 14.9677 24.4905 14.8516 24.4905 14.7097C24.4905 14.5677 24.5197 14.4516 24.5554 14.4516C24.5915 14.4516 24.6203 14.2795 24.6203 14.0645C24.6203 13.8495 24.6491 13.6774 24.6851 13.6774C24.7266 13.6774 24.75 13.0968 24.75 12.0645C24.75 11.0323 24.7266 10.4516 24.6851 10.4516C24.6491 10.4516 24.6203 10.2795 24.6203 10.0645C24.6203 9.84948 24.5915 9.67742 24.5554 9.67742C24.5197 9.67742 24.4905 9.53226 24.4905 9.35484C24.4905 9.17742 24.4614 9.03226 24.4257 9.03226C24.39 9.03226 24.3608 8.94516 24.3608 8.83871C24.3608 8.73226 24.3316 8.64516 24.2959 8.64516C24.2603 8.64516 24.2311 8.52903 24.2311 8.3871C24.2311 8.24516 24.2019 8.12903 24.1662 8.12903C24.1305 8.12903 24.1014 8.07097 24.1014 8C24.1014 7.92903 24.0722 7.87097 24.0365 7.87097C24.0008 7.87097 23.9716 7.78387 23.9716 7.67742C23.9716 7.57097 23.9424 7.48387 23.9068 7.48387C23.8711 7.48387 23.8419 7.42581 23.8419 7.35484C23.8419 7.28387 23.8127 7.22581 23.777 7.22581C23.7414 7.22581 23.7122 7.13871 23.7122 7.03226C23.7122 6.92581 23.683 6.83871 23.6473 6.83871C23.6116 6.83871 23.5824 6.78065 23.5824 6.70968C23.5824 6.63871 23.5532 6.58065 23.5176 6.58065C23.4819 6.58065 23.4527 6.52897 23.4527 6.46587C23.4527 6.40271 23.3943 6.30923 23.323 6.25806C23.2516 6.2069 23.1932 6.11342 23.1932 6.05026C23.1932 5.98716 23.1641 5.93548 23.1284 5.93548C23.0927 5.93548 23.0635 5.88381 23.0635 5.82071C23.0635 5.75755 23.0051 5.66406 22.9338 5.6129C22.8624 5.56174 22.8041 5.47465 22.8041 5.41935C22.8041 5.36406 22.7457 5.27697 22.6743 5.22581C22.603 5.17464 22.5446 5.09277 22.5446 5.04387C22.5446 4.99503 22.457 4.87361 22.35 4.77419C22.243 4.67477 22.1554 4.56123 22.1554 4.52193C22.1554 4.42942 20.4277 2.70968 20.3347 2.70968C20.2959 2.70968 20.152 2.59355 20.0149 2.45161C19.8777 2.30968 19.726 2.19355 19.6775 2.19355C19.629 2.19355 19.5474 2.13548 19.4959 2.06452C19.4445 1.99355 19.3505 1.93548 19.287 1.93548C19.2236 1.93548 19.1716 1.90645 19.1716 1.87097C19.1716 1.83548 19.1197 1.80645 19.0562 1.80645C18.9927 1.80645 18.8987 1.74839 18.8473 1.67742C18.7959 1.60645 18.7019 1.54839 18.6384 1.54839C18.5749 1.54839 18.523 1.51935 18.523 1.48387C18.523 1.44839 18.4646 1.41935 18.3932 1.41935C18.3219 1.41935 18.2635 1.39032 18.2635 1.35484C18.2635 1.31935 18.2051 1.29032 18.1338 1.29032C18.0624 1.29032 18.0041 1.26129 18.0041 1.22581C18.0041 1.19032 17.9457 1.16129 17.8743 1.16129C17.803 1.16129 17.7446 1.13226 17.7446 1.09677C17.7446 1.06129 17.6862 1.03226 17.6149 1.03226C17.5435 1.03226 17.4851 1.00323 17.4851 0.967742C17.4851 0.932258 17.3976 0.903226 17.2905 0.903226C17.1835 0.903226 17.0959 0.874194 17.0959 0.83871C17.0959 0.803226 17.0376 0.774194 16.9662 0.774194C16.8949 0.774194 16.8365 0.745161 16.8365 0.709677C16.8365 0.674194 16.7489 0.645161 16.6419 0.645161C16.5349 0.645161 16.4473 0.616129 16.4473 0.580645C16.4473 0.545161 16.3305 0.516129 16.1878 0.516129C16.0451 0.516129 15.9284 0.487097 15.9284 0.451613C15.9284 0.416129 15.8116 0.387097 15.6689 0.387097C15.5262 0.387097 15.4095 0.358065 15.4095 0.322581C15.4095 0.287097 15.2635 0.258065 15.0851 0.258065C14.9068 0.258065 14.7608 0.229032 14.7608 0.193548C14.7608 0.15671 14.5662 0.129032 14.3068 0.129032C14.0473 0.129032 13.8527 0.101355 13.8527 0.0645161C13.8527 0.0240645 13.4419 0 12.75 0C12.0581 0 11.6473 0.0240645 11.6473 0.0645161ZM13.4635 1.09677C13.4635 1.13503 13.7014 1.16129 14.0473 1.16129C14.3932 1.16129 14.6311 1.18755 14.6311 1.22581C14.6311 1.26129 14.777 1.29032 14.9554 1.29032C15.1338 1.29032 15.2797 1.31935 15.2797 1.35484C15.2797 1.39032 15.3965 1.41935 15.5392 1.41935C15.6819 1.41935 15.7986 1.44839 15.7986 1.48387C15.7986 1.51935 15.8862 1.54839 15.9932 1.54839C16.1003 1.54839 16.1878 1.57742 16.1878 1.6129C16.1878 1.64839 16.2754 1.67742 16.3824 1.67742C16.4895 1.67742 16.577 1.70645 16.577 1.74194C16.577 1.77742 16.6354 1.80645 16.7068 1.80645C16.7781 1.80645 16.8365 1.83548 16.8365 1.87097C16.8365 1.90645 16.9241 1.93548 17.0311 1.93548C17.1381 1.93548 17.2257 1.96452 17.2257 2C17.2257 2.03548 17.2841 2.06452 17.3554 2.06452C17.4268 2.06452 17.4851 2.09355 17.4851 2.12903C17.4851 2.16452 17.5435 2.19355 17.6149 2.19355C17.6862 2.19355 17.7446 2.22258 17.7446 2.25806C17.7446 2.29355 17.7966 2.32258 17.86 2.32258C17.9235 2.32258 18.0175 2.38065 18.0689 2.45161C18.1204 2.52258 18.2143 2.58065 18.2778 2.58065C18.3413 2.58065 18.3932 2.60968 18.3932 2.64516C18.3932 2.68065 18.4452 2.70968 18.5086 2.70968C18.5721 2.70968 18.6661 2.76774 18.7176 2.83871C18.769 2.90968 18.8566 2.96774 18.9122 2.96774C18.9678 2.96774 19.0553 3.02581 19.1068 3.09677C19.1582 3.16774 19.2395 3.22581 19.2875 3.22581C19.3354 3.22581 19.5168 3.37097 19.6905 3.54839C19.8643 3.72581 20.0382 3.87097 20.0769 3.87097C20.1688 3.87097 20.8581 4.55658 20.8581 4.64794C20.8581 4.68652 21.0041 4.85942 21.1824 5.03226C21.3608 5.2051 21.5068 5.38026 21.5068 5.42155C21.5068 5.46284 21.5943 5.578 21.7014 5.67742C21.8084 5.77684 21.8959 5.89826 21.8959 5.9471C21.8959 5.996 21.9543 6.07787 22.0257 6.12903C22.097 6.18019 22.1554 6.27368 22.1554 6.33684C22.1554 6.39994 22.1846 6.45161 22.2203 6.45161C22.2559 6.45161 22.2851 6.50968 22.2851 6.58065C22.2851 6.65161 22.3143 6.70968 22.35 6.70968C22.3857 6.70968 22.4149 6.76774 22.4149 6.83871C22.4149 6.90968 22.4441 6.96774 22.4797 6.96774C22.5154 6.96774 22.5446 7.02581 22.5446 7.09677C22.5446 7.16774 22.5738 7.22581 22.6095 7.22581C22.6451 7.22581 22.6743 7.28387 22.6743 7.35484C22.6743 7.42581 22.7035 7.48387 22.7392 7.48387C22.7749 7.48387 22.8041 7.54194 22.8041 7.6129C22.8041 7.68387 22.8332 7.74193 22.8689 7.74193C22.9046 7.74193 22.9338 7.82903 22.9338 7.93548C22.9338 8.04194 22.963 8.12903 22.9986 8.12903C23.0343 8.12903 23.0635 8.1871 23.0635 8.25806C23.0635 8.32903 23.0927 8.3871 23.1284 8.3871C23.1641 8.3871 23.1932 8.47419 23.1932 8.58064C23.1932 8.6871 23.2224 8.77419 23.2581 8.77419C23.2938 8.77419 23.323 8.89032 23.323 9.03226C23.323 9.17419 23.3522 9.29032 23.3878 9.29032C23.4235 9.29032 23.4527 9.40645 23.4527 9.54839C23.4527 9.69032 23.4819 9.80645 23.5176 9.80645C23.5546 9.80645 23.5824 10 23.5824 10.2581C23.5824 10.5161 23.6103 10.7097 23.6473 10.7097C23.6885 10.7097 23.7122 11.2043 23.7122 12.0645C23.7122 12.9247 23.6885 13.4194 23.6473 13.4194C23.6112 13.4194 23.5824 13.5914 23.5824 13.8065C23.5824 14.0215 23.5536 14.1935 23.5176 14.1935C23.4819 14.1935 23.4527 14.3097 23.4527 14.4516C23.4527 14.5935 23.4235 14.7097 23.3878 14.7097C23.3522 14.7097 23.323 14.8258 23.323 14.9677C23.323 15.1097 23.2938 15.2258 23.2581 15.2258C23.2224 15.2258 23.1932 15.3129 23.1932 15.4194C23.1932 15.5258 23.1641 15.6129 23.1284 15.6129C23.0927 15.6129 23.0635 15.7 23.0635 15.8065C23.0635 15.9129 23.0343 16 22.9986 16C22.963 16 22.9338 16.0581 22.9338 16.129C22.9338 16.2 22.9046 16.2581 22.8689 16.2581C22.8332 16.2581 22.8041 16.3161 22.8041 16.3871C22.8041 16.4581 22.7749 16.5161 22.7392 16.5161C22.7035 16.5161 22.6743 16.5742 22.6743 16.6452C22.6743 16.7161 22.6451 16.7742 22.6095 16.7742C22.5738 16.7742 22.5446 16.8323 22.5446 16.9032C22.5446 16.9742 22.5154 17.0323 22.4797 17.0323C22.4441 17.0323 22.4149 17.0903 22.4149 17.1613C22.4149 17.2323 22.3857 17.2903 22.35 17.2903C22.3143 17.2903 22.2851 17.3484 22.2851 17.4194C22.2851 17.4903 22.2559 17.5484 22.2203 17.5484C22.1846 17.5484 22.1554 17.6001 22.1554 17.6632C22.1554 17.7263 22.097 17.8198 22.0257 17.871C21.9543 17.9221 21.8959 18.004 21.8959 18.0529C21.8959 18.1017 21.8084 18.2232 21.7014 18.3226C21.5943 18.422 21.5068 18.5375 21.5068 18.5794C21.5068 18.6211 21.39 18.7668 21.2473 18.9032C21.1046 19.0396 20.9878 19.183 20.9878 19.2219C20.9878 19.3219 20.1648 20.129 20.0628 20.129C20.0166 20.129 19.9366 20.1871 19.8851 20.2581C19.7536 20.4395 19.6905 20.4186 19.6905 20.1936C19.6905 20.0871 19.6614 20 19.6257 20C19.59 20 19.5608 19.8839 19.5608 19.7419C19.5608 19.6 19.5316 19.4839 19.4959 19.4839C19.4603 19.4839 19.4311 19.3968 19.4311 19.2903C19.4311 19.1839 19.4019 19.0968 19.3662 19.0968C19.3305 19.0968 19.3014 19.0097 19.3014 18.9032C19.3014 18.7968 19.2722 18.7097 19.2365 18.7097C19.2008 18.7097 19.1716 18.6516 19.1716 18.5806C19.1716 18.5097 19.1424 18.4516 19.1068 18.4516C19.0711 18.4516 19.0419 18.3935 19.0419 18.3226C19.0419 18.2516 19.0127 18.1935 18.977 18.1935C18.9414 18.1935 18.9122 18.1355 18.9122 18.0645C18.9122 17.9935 18.883 17.9355 18.8473 17.9355C18.8116 17.9355 18.7824 17.8838 18.7824 17.8207C18.7824 17.7575 18.7241 17.6641 18.6527 17.6129C18.5814 17.5617 18.523 17.4805 18.523 17.4323C18.523 17.3841 18.4062 17.2332 18.2635 17.0968C18.1208 16.9604 18.0041 16.8166 18.0041 16.7771C18.0041 16.6831 17.5756 16.2581 17.4809 16.2581C17.4405 16.2581 17.3256 16.171 17.2257 16.0645C17.1257 15.9581 16.9972 15.871 16.9402 15.871C16.8831 15.871 16.8365 15.8419 16.8365 15.8065C16.8365 15.771 16.7781 15.7419 16.7068 15.7419C16.6354 15.7419 16.577 15.7129 16.577 15.6774C16.577 15.6419 16.4895 15.6129 16.3824 15.6129C16.2754 15.6129 16.1878 15.5839 16.1878 15.5484C16.1878 15.5101 15.95 15.4839 15.6041 15.4839C15.2581 15.4839 15.0203 15.5101 15.0203 15.5484C15.0203 15.5839 14.9327 15.6129 14.8257 15.6129C14.7186 15.6129 14.6311 15.6419 14.6311 15.6774C14.6311 15.7129 14.5499 15.7419 14.4508 15.7419C14.345 15.7419 14.232 15.7952 14.177 15.871C14.1256 15.9419 14.0316 16 13.9681 16C13.9047 16 13.8527 16.029 13.8527 16.0645C13.8527 16.1 13.7651 16.129 13.6581 16.129C13.5511 16.129 13.4635 16.1581 13.4635 16.1935C13.4635 16.2326 13.1825 16.2581 12.75 16.2581C12.3175 16.2581 12.0365 16.2326 12.0365 16.1935C12.0365 16.1581 11.9489 16.129 11.8419 16.129C11.7349 16.129 11.6473 16.1 11.6473 16.0645C11.6473 16.029 11.5953 16 11.5319 16C11.4684 16 11.3744 15.9419 11.323 15.871C11.268 15.7952 11.155 15.7419 11.0492 15.7419C10.9501 15.7419 10.8689 15.7129 10.8689 15.6774C10.8689 15.6419 10.7814 15.6129 10.6743 15.6129C10.5673 15.6129 10.4797 15.5839 10.4797 15.5484C10.4797 15.5101 10.2419 15.4839 9.89595 15.4839C9.55002 15.4839 9.31216 15.5101 9.31216 15.5484C9.31216 15.5839 9.2246 15.6129 9.11757 15.6129C9.01054 15.6129 8.92297 15.6419 8.92297 15.6774C8.92297 15.7129 8.8646 15.7419 8.79324 15.7419C8.72189 15.7419 8.66351 15.771 8.66351 15.8065C8.66351 15.8419 8.61688 15.871 8.55979 15.871C8.50278 15.871 8.37428 15.9581 8.27432 16.0645C8.17437 16.171 8.05949 16.2581 8.01908 16.2581C7.92438 16.2581 7.49595 16.6831 7.49595 16.7771C7.49595 16.8166 7.37919 16.9604 7.23649 17.0968C7.09378 17.2332 6.97703 17.3841 6.97703 17.4323C6.97703 17.4805 6.91865 17.5617 6.8473 17.6129C6.77595 17.6641 6.71757 17.7575 6.71757 17.8207C6.71757 17.8838 6.68838 17.9355 6.6527 17.9355C6.61703 17.9355 6.58784 17.9935 6.58784 18.0645C6.58784 18.1355 6.55865 18.1935 6.52297 18.1935C6.4873 18.1935 6.45811 18.2516 6.45811 18.3226C6.45811 18.3935 6.42892 18.4516 6.39324 18.4516C6.35757 18.4516 6.32838 18.5097 6.32838 18.5806C6.32838 18.6516 6.29919 18.7097 6.26351 18.7097C6.22784 18.7097 6.19865 18.7968 6.19865 18.9032C6.19865 19.0097 6.16946 19.0968 6.13378 19.0968C6.09811 19.0968 6.06892 19.1839 6.06892 19.2903C6.06892 19.3968 6.03973 19.4839 6.00405 19.4839C5.96838 19.4839 5.93919 19.6 5.93919 19.7419C5.93919 19.8839 5.91 20 5.87432 20C5.83865 20 5.80946 20.0871 5.80946 20.1936C5.80946 20.3 5.78027 20.3871 5.7446 20.3871C5.70892 20.3871 5.67973 20.3581 5.67973 20.3226C5.67973 20.2871 5.63549 20.2581 5.5814 20.2581C5.47022 20.2581 4.51216 19.3303 4.51216 19.2226C4.51216 19.1843 4.36622 19.0115 4.18784 18.8387C4.00946 18.6659 3.86351 18.4855 3.86351 18.4378C3.86351 18.3901 3.80514 18.3092 3.73378 18.2581C3.66243 18.2069 3.60405 18.1198 3.60405 18.0645C3.60405 18.0092 3.54568 17.9221 3.47432 17.871C3.40297 17.8198 3.34459 17.7263 3.34459 17.6632C3.34459 17.6001 3.31541 17.5484 3.27973 17.5484C3.24405 17.5484 3.21486 17.4903 3.21486 17.4194C3.21486 17.3484 3.18568 17.2903 3.15 17.2903C3.11432 17.2903 3.08514 17.2386 3.08514 17.1755C3.08514 17.1124 3.02676 17.0189 2.95541 16.9677C2.87925 16.9131 2.82568 16.8007 2.82568 16.6954C2.82568 16.5968 2.79649 16.5161 2.76081 16.5161C2.72514 16.5161 2.69595 16.4581 2.69595 16.3871C2.69595 16.3161 2.66676 16.2581 2.63108 16.2581C2.59541 16.2581 2.56622 16.2 2.56622 16.129C2.56622 16.0581 2.53703 16 2.50135 16C2.46568 16 2.43649 15.9129 2.43649 15.8065C2.43649 15.7 2.4073 15.6129 2.37162 15.6129C2.33595 15.6129 2.30676 15.5258 2.30676 15.4194C2.30676 15.3129 2.27757 15.2258 2.24189 15.2258C2.20622 15.2258 2.17703 15.1387 2.17703 15.0323C2.17703 14.9258 2.14784 14.8387 2.11216 14.8387C2.07649 14.8387 2.0473 14.6935 2.0473 14.5161C2.0473 14.3387 2.01811 14.1935 1.98243 14.1935C1.94637 14.1935 1.91757 14.0215 1.91757 13.8065C1.91757 13.5914 1.88877 13.4194 1.8527 13.4194C1.81145 13.4194 1.78784 12.9032 1.78784 12C1.78784 11.0968 1.81145 10.5806 1.8527 10.5806C1.88877 10.5806 1.91757 10.4086 1.91757 10.1935C1.91757 9.97852 1.94637 9.80645 1.98243 9.80645C2.01811 9.80645 2.0473 9.66129 2.0473 9.48387C2.0473 9.30645 2.07649 9.16129 2.11216 9.16129C2.14784 9.16129 2.17703 9.07419 2.17703 8.96774C2.17703 8.86129 2.20622 8.77419 2.24189 8.77419C2.27757 8.77419 2.30676 8.6871 2.30676 8.58064C2.30676 8.47419 2.33595 8.3871 2.37162 8.3871C2.4073 8.3871 2.43649 8.3 2.43649 8.19355C2.43649 8.0871 2.46568 8 2.50135 8C2.53703 8 2.56622 7.94194 2.56622 7.87097C2.56622 7.8 2.59541 7.74193 2.63108 7.74193C2.66676 7.74193 2.69595 7.68387 2.69595 7.6129C2.69595 7.54194 2.72514 7.48387 2.76081 7.48387C2.79649 7.48387 2.82568 7.40316 2.82568 7.30458C2.82568 7.19929 2.87925 7.0869 2.95541 7.03226C3.02676 6.9811 3.08514 6.88761 3.08514 6.82445C3.08514 6.76135 3.11432 6.70968 3.15 6.70968C3.18568 6.70968 3.21486 6.65161 3.21486 6.58065C3.21486 6.50968 3.24405 6.45161 3.27973 6.45161C3.31541 6.45161 3.34459 6.39994 3.34459 6.33684C3.34459 6.27368 3.40297 6.18019 3.47432 6.12903C3.54568 6.07787 3.60405 5.996 3.60405 5.9471C3.60405 5.89826 3.69162 5.77684 3.79865 5.67742C3.90568 5.578 3.99324 5.46245 3.99324 5.42065C3.99324 5.3789 4.11 5.23316 4.2527 5.09677C4.39541 4.96039 4.51216 4.81703 4.51216 4.77819C4.51216 4.68613 5.46146 3.74194 5.55402 3.74194C5.59307 3.74194 5.7372 3.62581 5.87432 3.48387C6.01145 3.34194 6.16323 3.22581 6.21169 3.22581C6.26014 3.22581 6.34181 3.16774 6.39324 3.09677C6.44468 3.02581 6.53225 2.96774 6.58784 2.96774C6.64343 2.96774 6.73099 2.90968 6.78243 2.83871C6.83387 2.76774 6.92144 2.70968 6.97703 2.70968C7.03262 2.70968 7.12018 2.65161 7.17162 2.58065C7.22306 2.50968 7.31705 2.45161 7.38055 2.45161C7.44399 2.45161 7.49595 2.42258 7.49595 2.3871C7.49595 2.35161 7.55432 2.32258 7.62568 2.32258C7.69703 2.32258 7.75541 2.29355 7.75541 2.25806C7.75541 2.22258 7.81378 2.19355 7.88513 2.19355C7.95649 2.19355 8.01486 2.16452 8.01486 2.12903C8.01486 2.09355 8.07324 2.06452 8.14459 2.06452C8.21595 2.06452 8.27432 2.03548 8.27432 2C8.27432 1.96452 8.36189 1.93548 8.46892 1.93548C8.57595 1.93548 8.66351 1.90645 8.66351 1.87097C8.66351 1.83548 8.72189 1.80645 8.79324 1.80645C8.8646 1.80645 8.92297 1.77742 8.92297 1.74194C8.92297 1.70645 9.01054 1.67742 9.11757 1.67742C9.2246 1.67742 9.31216 1.64839 9.31216 1.6129C9.31216 1.57742 9.39973 1.54839 9.50676 1.54839C9.61378 1.54839 9.70135 1.51935 9.70135 1.48387C9.70135 1.44839 9.81811 1.41935 9.96081 1.41935C10.1035 1.41935 10.2203 1.39032 10.2203 1.35484C10.2203 1.31935 10.3662 1.29032 10.5446 1.29032C10.723 1.29032 10.8689 1.26129 10.8689 1.22581C10.8689 1.18755 11.1068 1.16129 11.4527 1.16129C11.7986 1.16129 12.0365 1.13503 12.0365 1.09677C12.0365 1.05768 12.3175 1.03226 12.75 1.03226C13.1825 1.03226 13.4635 1.05768 13.4635 1.09677ZM11.9068 3.67742C11.9068 3.7129 11.79 3.74194 11.6473 3.74194C11.5046 3.74194 11.3878 3.77097 11.3878 3.80645C11.3878 3.84194 11.3003 3.87097 11.1932 3.87097C11.0862 3.87097 10.9986 3.9 10.9986 3.93548C10.9986 3.97097 10.9111 4 10.8041 4C10.697 4 10.6095 4.02903 10.6095 4.06452C10.6095 4.1 10.5511 4.12903 10.4797 4.12903C10.4084 4.12903 10.35 4.15806 10.35 4.19355C10.35 4.22903 10.298 4.25806 10.2346 4.25806C10.1711 4.25806 10.0771 4.31613 10.0257 4.3871C9.97424 4.45806 9.89445 4.51613 9.84834 4.51613C9.73904 4.51613 8.53378 5.7149 8.53378 5.82361C8.53378 5.86948 8.47541 5.94884 8.40405 6C8.3327 6.05116 8.27432 6.14465 8.27432 6.20781C8.27432 6.2709 8.24514 6.32258 8.20946 6.32258C8.17378 6.32258 8.14459 6.38064 8.14459 6.45161C8.14459 6.52258 8.11541 6.58065 8.07973 6.58065C8.04405 6.58065 8.01486 6.66774 8.01486 6.77419C8.01486 6.88065 7.98568 6.96774 7.95 6.96774C7.91432 6.96774 7.88513 7.05484 7.88513 7.16129C7.88513 7.26774 7.85595 7.35484 7.82027 7.35484C7.78459 7.35484 7.75541 7.5 7.75541 7.67742C7.75541 7.85484 7.72622 8 7.69054 8C7.65162 8 7.62568 8.25806 7.62568 8.64516C7.62568 9.03226 7.65162 9.29032 7.69054 9.29032C7.72661 9.29032 7.75541 9.46239 7.75541 9.67742C7.75541 9.89245 7.78421 10.0645 7.82027 10.0645C7.85595 10.0645 7.88513 10.1806 7.88513 10.3226C7.88513 10.4645 7.91432 10.5806 7.95 10.5806C7.98568 10.5806 8.01486 10.6387 8.01486 10.7097C8.01486 10.7806 8.04405 10.8387 8.07973 10.8387C8.11541 10.8387 8.14459 10.9258 8.14459 11.0323C8.14459 11.1387 8.17378 11.2258 8.20946 11.2258C8.24514 11.2258 8.27432 11.2839 8.27432 11.3548C8.27432 11.4258 8.30351 11.4839 8.33919 11.4839C8.37486 11.4839 8.40405 11.5419 8.40405 11.6129C8.40405 11.6839 8.43324 11.7419 8.46892 11.7419C8.50459 11.7419 8.53378 11.8 8.53378 11.871C8.53378 11.9419 8.56297 12 8.59865 12C8.63433 12 8.66351 12.0581 8.66351 12.129C8.66351 12.2 8.6927 12.2581 8.72838 12.2581C8.76405 12.2581 8.79324 12.3045 8.79324 12.3612C8.79324 12.4179 8.88081 12.5457 8.98784 12.6452C9.09486 12.7446 9.18243 12.8583 9.18243 12.8977C9.18243 12.9984 10.3949 14.1935 10.497 14.1935C10.5431 14.1935 10.6229 14.2516 10.6743 14.3226C10.7258 14.3935 10.8198 14.4516 10.8833 14.4516C10.9467 14.4516 10.9986 14.4806 10.9986 14.5161C10.9986 14.5516 11.057 14.5806 11.1284 14.5806C11.1997 14.5806 11.2581 14.6097 11.2581 14.6452C11.2581 14.6806 11.3457 14.7097 11.4527 14.7097C11.5597 14.7097 11.6473 14.7387 11.6473 14.7742C11.6473 14.8097 11.7932 14.8387 11.9716 14.8387C12.15 14.8387 12.2959 14.8677 12.2959 14.9032C12.2959 14.9401 12.4905 14.9677 12.75 14.9677C13.0095 14.9677 13.2041 14.9401 13.2041 14.9032C13.2041 14.8677 13.35 14.8387 13.5284 14.8387C13.7068 14.8387 13.8527 14.8097 13.8527 14.7742C13.8527 14.7387 13.9111 14.7097 13.9824 14.7097C14.0538 14.7097 14.1122 14.6806 14.1122 14.6452C14.1122 14.6097 14.1997 14.5806 14.3068 14.5806C14.4138 14.5806 14.5014 14.5516 14.5014 14.5161C14.5014 14.4806 14.5533 14.4516 14.6167 14.4516C14.6802 14.4516 14.7742 14.3935 14.8257 14.3226C14.8771 14.2516 14.9569 14.1935 15.003 14.1935C15.1123 14.1935 16.3176 12.9948 16.3176 12.8861C16.3176 12.8402 16.3759 12.7608 16.4473 12.7097C16.5187 12.6585 16.577 12.5714 16.577 12.5161C16.577 12.4608 16.6354 12.3737 16.7068 12.3226C16.7781 12.2714 16.8365 12.1779 16.8365 12.1148C16.8365 12.0517 16.8657 12 16.9014 12C16.937 12 16.9662 11.9419 16.9662 11.871C16.9662 11.8 16.9954 11.7419 17.0311 11.7419C17.0668 11.7419 17.0959 11.6839 17.0959 11.6129C17.0959 11.5419 17.1251 11.4839 17.1608 11.4839C17.1965 11.4839 17.2257 11.4258 17.2257 11.3548C17.2257 11.2839 17.2549 11.2258 17.2905 11.2258C17.3262 11.2258 17.3554 11.1387 17.3554 11.0323C17.3554 10.9258 17.3846 10.8387 17.4203 10.8387C17.4559 10.8387 17.4851 10.7516 17.4851 10.6452C17.4851 10.5387 17.5143 10.4516 17.55 10.4516C17.5857 10.4516 17.6149 10.3645 17.6149 10.2581C17.6149 10.1516 17.6441 10.0645 17.6797 10.0645C17.7158 10.0645 17.7446 9.89245 17.7446 9.67742C17.7446 9.46239 17.7734 9.29032 17.8095 9.29032C17.8473 9.29032 17.8743 9.07529 17.8743 8.77419C17.8743 8.4731 17.8473 8.25806 17.8095 8.25806C17.7734 8.25806 17.7446 8.086 17.7446 7.87097C17.7446 7.65594 17.7158 7.48387 17.6797 7.48387C17.6441 7.48387 17.6149 7.36774 17.6149 7.22581C17.6149 7.08387 17.5857 6.96774 17.55 6.96774C17.5143 6.96774 17.4851 6.90968 17.4851 6.83871C17.4851 6.76774 17.4559 6.70968 17.4203 6.70968C17.3846 6.70968 17.3554 6.62897 17.3554 6.53039C17.3554 6.4251 17.3018 6.31271 17.2257 6.25806C17.1543 6.2069 17.0959 6.11981 17.0959 6.06452C17.0959 6.00923 17.0376 5.92213 16.9662 5.87097C16.8949 5.81981 16.8365 5.74039 16.8365 5.69452C16.8365 5.58568 15.7612 4.51613 15.6517 4.51613C15.6056 4.51613 15.5258 4.45806 15.4743 4.3871C15.4229 4.31613 15.3289 4.25806 15.2654 4.25806C15.202 4.25806 15.15 4.22903 15.15 4.19355C15.15 4.15806 15.0916 4.12903 15.0203 4.12903C14.9489 4.12903 14.8905 4.1 14.8905 4.06452C14.8905 4.02903 14.803 4 14.6959 4C14.5889 4 14.5014 3.97097 14.5014 3.93548C14.5014 3.9 14.4138 3.87097 14.3068 3.87097C14.1997 3.87097 14.1122 3.84194 14.1122 3.80645C14.1122 3.77097 13.9954 3.74194 13.8527 3.74194C13.71 3.74194 13.5932 3.7129 13.5932 3.67742C13.5932 3.63774 13.2689 3.6129 12.75 3.6129C12.2311 3.6129 11.9068 3.63774 11.9068 3.67742ZM13.3338 4.70968C13.3338 4.74516 13.4797 4.77419 13.6581 4.77419C13.8365 4.77419 13.9824 4.80323 13.9824 4.83871C13.9824 4.87419 14.0408 4.90323 14.1122 4.90323C14.1835 4.90323 14.2419 4.93226 14.2419 4.96774C14.2419 5.00323 14.323 5.03226 14.4222 5.03226C14.528 5.03226 14.641 5.08555 14.6959 5.16129C14.7474 5.23226 14.8297 5.29032 14.8789 5.29032C14.928 5.29032 15.05 5.37742 15.15 5.48387C15.25 5.59032 15.3652 5.67742 15.406 5.67742C15.5023 5.67742 15.7986 5.97219 15.7986 6.06793C15.7986 6.10858 15.8862 6.22316 15.9932 6.32258C16.1003 6.422 16.1878 6.54981 16.1878 6.60652C16.1878 6.66329 16.217 6.70968 16.2527 6.70968C16.2884 6.70968 16.3176 6.76774 16.3176 6.83871C16.3176 6.90968 16.3468 6.96774 16.3824 6.96774C16.4181 6.96774 16.4473 7.02581 16.4473 7.09677C16.4473 7.16774 16.4765 7.22581 16.5122 7.22581C16.5478 7.22581 16.577 7.3129 16.577 7.41935C16.577 7.52581 16.6062 7.6129 16.6419 7.6129C16.6789 7.6129 16.7068 7.80645 16.7068 8.06452C16.7068 8.32258 16.7346 8.51613 16.7716 8.51613C16.8073 8.51613 16.8365 8.60323 16.8365 8.70968C16.8365 8.81613 16.8073 8.90323 16.7716 8.90323C16.7346 8.90323 16.7068 9.09677 16.7068 9.35484C16.7068 9.6129 16.6789 9.80645 16.6419 9.80645C16.6062 9.80645 16.577 9.92258 16.577 10.0645C16.577 10.2065 16.5478 10.3226 16.5122 10.3226C16.4765 10.3226 16.4473 10.3806 16.4473 10.4516C16.4473 10.5226 16.4181 10.5806 16.3824 10.5806C16.3468 10.5806 16.3176 10.6677 16.3176 10.7742C16.3176 10.8806 16.2884 10.9677 16.2527 10.9677C16.217 10.9677 16.1878 11.0258 16.1878 11.0968C16.1878 11.1677 16.1586 11.2258 16.123 11.2258C16.0873 11.2258 16.0581 11.2775 16.0581 11.3406C16.0581 11.4037 15.9997 11.4972 15.9284 11.5484C15.857 11.5995 15.7986 11.693 15.7986 11.7562C15.7986 11.8193 15.7695 11.871 15.7338 11.871C15.6981 11.871 15.6689 11.9148 15.6689 11.9685C15.6689 12.0957 14.3381 13.4194 14.2102 13.4194C14.1563 13.4194 14.1122 13.4484 14.1122 13.4839C14.1122 13.5194 14.0538 13.5484 13.9824 13.5484C13.9111 13.5484 13.8527 13.5774 13.8527 13.6129C13.8527 13.6484 13.7943 13.6774 13.723 13.6774C13.6516 13.6774 13.5932 13.7065 13.5932 13.7419C13.5932 13.7774 13.4473 13.8065 13.2689 13.8065C13.0905 13.8065 12.9446 13.8355 12.9446 13.871C12.9446 13.9065 12.857 13.9355 12.75 13.9355C12.643 13.9355 12.5554 13.9065 12.5554 13.871C12.5554 13.8355 12.4095 13.8065 12.2311 13.8065C12.0527 13.8065 11.9068 13.7774 11.9068 13.7419C11.9068 13.7065 11.8484 13.6774 11.777 13.6774C11.7057 13.6774 11.6473 13.6484 11.6473 13.6129C11.6473 13.5774 11.5889 13.5484 11.5176 13.5484C11.4462 13.5484 11.3878 13.5194 11.3878 13.4839C11.3878 13.4484 11.3418 13.4194 11.2855 13.4194C11.2291 13.4194 11.0709 13.3032 10.9338 13.1613C10.7967 13.0194 10.6509 12.9032 10.6099 12.9032C10.5136 12.9032 10.35 12.7405 10.35 12.6447C10.35 12.6039 10.2332 12.459 10.0905 12.3226C9.94784 12.1862 9.83108 12.0352 9.83108 11.987C9.83108 11.9388 9.7727 11.8576 9.70135 11.8065C9.63 11.7553 9.57162 11.6618 9.57162 11.5986C9.57162 11.5355 9.54243 11.4839 9.50676 11.4839C9.47108 11.4839 9.44189 11.4258 9.44189 11.3548C9.44189 11.2839 9.4127 11.2258 9.37703 11.2258C9.34135 11.2258 9.31216 11.1677 9.31216 11.0968C9.31216 11.0258 9.28297 10.9677 9.2473 10.9677C9.21162 10.9677 9.18243 10.8806 9.18243 10.7742C9.18243 10.6677 9.15324 10.5806 9.11757 10.5806C9.08189 10.5806 9.0527 10.5226 9.0527 10.4516C9.0527 10.3806 9.02351 10.3226 8.98784 10.3226C8.95216 10.3226 8.92297 10.2065 8.92297 10.0645C8.92297 9.92258 8.89378 9.80645 8.85811 9.80645C8.82107 9.80645 8.79324 9.6129 8.79324 9.35484C8.79324 9.09677 8.76542 8.90323 8.72838 8.90323C8.6927 8.90323 8.66351 8.75806 8.66351 8.58064C8.66351 8.40322 8.6927 8.25806 8.72838 8.25806C8.76405 8.25806 8.79324 8.1129 8.79324 7.93548C8.79324 7.75806 8.82243 7.6129 8.85811 7.6129C8.89378 7.6129 8.92297 7.52581 8.92297 7.41935C8.92297 7.3129 8.95216 7.22581 8.98784 7.22581C9.02351 7.22581 9.0527 7.16774 9.0527 7.09677C9.0527 7.02581 9.08189 6.96774 9.11757 6.96774C9.15324 6.96774 9.18243 6.90968 9.18243 6.83871C9.18243 6.76774 9.21162 6.70968 9.2473 6.70968C9.28297 6.70968 9.31216 6.658 9.31216 6.5949C9.31216 6.53174 9.37054 6.43826 9.44189 6.3871C9.51324 6.33594 9.57162 6.25619 9.57162 6.20987C9.57162 6.10026 10.1265 5.54839 10.2367 5.54839C10.2833 5.54839 10.3634 5.49032 10.4149 5.41935C10.4663 5.34839 10.5539 5.29032 10.6095 5.29032C10.665 5.29032 10.7526 5.23226 10.8041 5.16129C10.859 5.08555 10.972 5.03226 11.0778 5.03226C11.177 5.03226 11.2581 5.00323 11.2581 4.96774C11.2581 4.93226 11.3165 4.90323 11.3878 4.90323C11.4592 4.90323 11.5176 4.87419 11.5176 4.83871C11.5176 4.80323 11.6635 4.77419 11.8419 4.77419C12.0203 4.77419 12.1662 4.74516 12.1662 4.70968C12.1662 4.67142 12.4041 4.64516 12.75 4.64516C13.0959 4.64516 13.3338 4.67142 13.3338 4.70968ZM10.35 16.5806C10.35 16.6161 10.4084 16.6452 10.4797 16.6452C10.5511 16.6452 10.6095 16.6742 10.6095 16.7097C10.6095 16.7452 10.6678 16.7742 10.7392 16.7742C10.8105 16.7742 10.8689 16.8032 10.8689 16.8387C10.8689 16.8742 10.9273 16.9032 10.9986 16.9032C11.07 16.9032 11.1284 16.9323 11.1284 16.9677C11.1284 17.0032 11.1868 17.0323 11.2581 17.0323C11.3295 17.0323 11.3878 17.0613 11.3878 17.0968C11.3878 17.1323 11.4754 17.1613 11.5824 17.1613C11.6895 17.1613 11.777 17.1903 11.777 17.2258C11.777 17.2659 12.1446 17.2903 12.75 17.2903C13.3554 17.2903 13.723 17.2659 13.723 17.2258C13.723 17.1903 13.8105 17.1613 13.9176 17.1613C14.0246 17.1613 14.1122 17.1323 14.1122 17.0968C14.1122 17.0613 14.1705 17.0323 14.2419 17.0323C14.3132 17.0323 14.3716 17.0032 14.3716 16.9677C14.3716 16.9323 14.43 16.9032 14.5014 16.9032C14.5727 16.9032 14.6311 16.8742 14.6311 16.8387C14.6311 16.8032 14.6895 16.7742 14.7608 16.7742C14.8322 16.7742 14.8905 16.7452 14.8905 16.7097C14.8905 16.6742 14.9489 16.6452 15.0203 16.6452C15.0916 16.6452 15.15 16.6161 15.15 16.5806C15.15 16.5438 15.3446 16.5161 15.6041 16.5161C15.8635 16.5161 16.0581 16.5438 16.0581 16.5806C16.0581 16.6161 16.1165 16.6452 16.1878 16.6452C16.2592 16.6452 16.3176 16.6742 16.3176 16.7097C16.3176 16.7452 16.3618 16.7742 16.4159 16.7742C16.5355 16.7742 17.4851 17.7061 17.4851 17.8234C17.4851 17.8694 17.5435 17.9488 17.6149 18C17.6862 18.0512 17.7446 18.1446 17.7446 18.2078C17.7446 18.2709 17.7738 18.3226 17.8095 18.3226C17.8451 18.3226 17.8743 18.3743 17.8743 18.4374C17.8743 18.5005 17.9327 18.594 18.0041 18.6452C18.0802 18.6998 18.1338 18.8122 18.1338 18.9175C18.1338 19.0161 18.163 19.0968 18.1986 19.0968C18.2343 19.0968 18.2635 19.1548 18.2635 19.2258C18.2635 19.2968 18.2927 19.3548 18.3284 19.3548C18.3641 19.3548 18.3932 19.4419 18.3932 19.5484C18.3932 19.6548 18.4224 19.7419 18.4581 19.7419C18.4938 19.7419 18.523 19.8581 18.523 20C18.523 20.1419 18.5522 20.2581 18.5878 20.2581C18.6257 20.2581 18.6527 20.4731 18.6527 20.7742C18.6527 21.2259 18.6383 21.2903 18.5373 21.2903C18.4738 21.2903 18.3798 21.3484 18.3284 21.4194C18.2769 21.4903 18.183 21.5484 18.1194 21.5484C18.056 21.5484 18.0041 21.5774 18.0041 21.6129C18.0041 21.6484 17.9457 21.6774 17.8743 21.6774C17.803 21.6774 17.7446 21.7065 17.7446 21.7419C17.7446 21.7774 17.6862 21.8065 17.6149 21.8065C17.5435 21.8065 17.4851 21.8355 17.4851 21.871C17.4851 21.9065 17.4268 21.9355 17.3554 21.9355C17.2841 21.9355 17.2257 21.9645 17.2257 22C17.2257 22.0355 17.1673 22.0645 17.0959 22.0645C17.0246 22.0645 16.9662 22.0935 16.9662 22.129C16.9662 22.1645 16.8786 22.1935 16.7716 22.1935C16.6646 22.1935 16.577 22.2226 16.577 22.2581C16.577 22.2935 16.4895 22.3226 16.3824 22.3226C16.2754 22.3226 16.1878 22.3516 16.1878 22.3871C16.1878 22.4226 16.1003 22.4516 15.9932 22.4516C15.8862 22.4516 15.7986 22.4806 15.7986 22.5161C15.7986 22.5516 15.6819 22.5806 15.5392 22.5806C15.3965 22.5806 15.2797 22.6097 15.2797 22.6452C15.2797 22.6806 15.1338 22.7097 14.9554 22.7097C14.777 22.7097 14.6311 22.7387 14.6311 22.7742C14.6311 22.811 14.4365 22.8387 14.177 22.8387C13.9176 22.8387 13.723 22.8664 13.723 22.9032C13.723 22.9434 13.3554 22.9677 12.75 22.9677C12.1446 22.9677 11.777 22.9434 11.777 22.9032C11.777 22.8664 11.5824 22.8387 11.323 22.8387C11.0635 22.8387 10.8689 22.811 10.8689 22.7742C10.8689 22.7387 10.723 22.7097 10.5446 22.7097C10.3662 22.7097 10.2203 22.6806 10.2203 22.6452C10.2203 22.6097 10.1035 22.5806 9.96081 22.5806C9.81811 22.5806 9.70135 22.5516 9.70135 22.5161C9.70135 22.4806 9.61378 22.4516 9.50676 22.4516C9.39973 22.4516 9.31216 22.4226 9.31216 22.3871C9.31216 22.3516 9.2246 22.3226 9.11757 22.3226C9.01054 22.3226 8.92297 22.2935 8.92297 22.2581C8.92297 22.2226 8.83541 22.1935 8.72838 22.1935C8.62135 22.1935 8.53378 22.1645 8.53378 22.129C8.53378 22.0935 8.47541 22.0645 8.40405 22.0645C8.3327 22.0645 8.27432 22.0355 8.27432 22C8.27432 21.9645 8.21595 21.9355 8.14459 21.9355C8.07324 21.9355 8.01486 21.9065 8.01486 21.871C8.01486 21.8355 7.95649 21.8065 7.88513 21.8065C7.81378 21.8065 7.75541 21.7774 7.75541 21.7419C7.75541 21.7065 7.69703 21.6774 7.62568 21.6774C7.55432 21.6774 7.49595 21.6484 7.49595 21.6129C7.49595 21.5774 7.44399 21.5484 7.38055 21.5484C7.31705 21.5484 7.22306 21.4903 7.17162 21.4194C7.12018 21.3484 7.0262 21.2903 6.96269 21.2903C6.8617 21.2903 6.8473 21.2259 6.8473 20.7742C6.8473 20.4731 6.87435 20.2581 6.91216 20.2581C6.94784 20.2581 6.97703 20.1419 6.97703 20C6.97703 19.8581 7.00622 19.7419 7.04189 19.7419C7.07757 19.7419 7.10676 19.6548 7.10676 19.5484C7.10676 19.4419 7.13595 19.3548 7.17162 19.3548C7.2073 19.3548 7.23649 19.2677 7.23649 19.1613C7.23649 19.0548 7.26568 18.9677 7.30135 18.9677C7.33703 18.9677 7.36622 18.9097 7.36622 18.8387C7.36622 18.7677 7.39541 18.7097 7.43108 18.7097C7.46676 18.7097 7.49595 18.658 7.49595 18.5949C7.49595 18.5317 7.55432 18.4383 7.62568 18.3871C7.69703 18.3359 7.75541 18.2488 7.75541 18.1935C7.75541 18.1383 7.81378 18.0512 7.88513 18C7.95649 17.9488 8.01486 17.8694 8.01486 17.8234C8.01486 17.7061 8.96449 16.7742 9.0841 16.7742C9.1382 16.7742 9.18243 16.7452 9.18243 16.7097C9.18243 16.6742 9.24081 16.6452 9.31216 16.6452C9.38351 16.6452 9.44189 16.6161 9.44189 16.5806C9.44189 16.5438 9.63649 16.5161 9.89595 16.5161C10.1554 16.5161 10.35 16.5438 10.35 16.5806Z" fill="#555555"/> </svg>
      `,

                                              altura: '20px',

                                              largura: '30px',

                                              preenchimento: ['transparent'],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 16,
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Meu Perfil',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.sideMenu',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'hide',
                                        },
                                      }),
                                    },
                                  }),
                                (...args) => {
                                  // ---------- get Function from A_Project Scope
                                  return tools.goTo('b7myprofile');
                                },
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'transparent',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.overflow({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hidden',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginRight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={14}
                                                    height={16}
                                                    viewBox="0 0 14 16"
                                                    {...props}
                                                  >
                                                    
                                                    <Path
                                                      stroke="#555"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth={1.2}
                                                      d="M12.954 6.727c0 4.455-5.727 8.273-5.727 8.273S1.5 11.182 1.5 6.727a5.727 5.727 0 0 1 11.454 0Z"
                                                      {...props}
                                                    />
                                                    <Path
                                                      stroke="#555"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth={1.2}
                                                      d="M7.227 8.636a1.91 1.91 0 1 0 0-3.818 1.91 1.91 0 0 0 0 3.818Z"
                                                      {...props}
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.9545 6.72727C12.9545 11.1818 7.22727 15 7.22727 15C7.22727 15 1.5 11.1818 1.5 6.72727C1.5 5.20831 2.10341 3.75155 3.17748 2.67748C4.25155 1.60341 5.70831 1 7.22727 1C8.74624 1 10.203 1.60341 11.2771 2.67748C12.3511 3.75155 12.9545 5.20831 12.9545 6.72727Z" stroke="#555555" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.22727 8.63636C8.28164 8.63636 9.13636 7.78164 9.13636 6.72727C9.13636 5.67291 8.28164 4.81818 7.22727 4.81818C6.17291 4.81818 5.31818 5.67291 5.31818 6.72727C5.31818 7.78164 6.17291 8.63636 7.22727 8.63636Z" stroke="#555555" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
      `,

                                              altura: '20px',

                                              largura: '25px',

                                              preenchimento: ['transparent'],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 16,
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'Pontos de Retirada',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.sideMenu',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'hide',
                                        },
                                      }),
                                    },
                                  }),
                                (...args) => {
                                  // ---------- get Function from A_Project Scope
                                  return tools.goTo('b3bikemap');
                                },
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'transparent',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.overflow({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hidden',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginRight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={23}
                                                    height={21}
                                                    fill="red"
                                                    viewBox="0 0 23 21"
                                                    {...props}
                                                  >
                                                    
                                                    <Path
                                                      fill="#555"
                                                      d="M22 8.25h-.75v-4.5A.75.75 0 0 0 20.5 3h-18a.75.75 0 0 1-.75-.615v-.27A.75.75 0 0 1 2.5 1.5h17.685a.75.75 0 1 0 0-1.5H2.5A2.25 2.25 0 0 0 .25 2.25a2.31 2.31 0 0 0 0 .27v15.428A3.076 3.076 0 0 0 3.347 21H20.5a.75.75 0 0 0 .75-.75v-4.5H22a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75ZM19.75 19.5H3.347a1.582 1.582 0 0 1-1.597-1.552V4.41c.243.07.497.101.75.09h17.25v3.75H14.5a3.75 3.75 0 0 0 0 7.5h5.25v3.75Zm1.5-5.25H14.5a2.25 2.25 0 1 1 0-4.5h6.75v4.5Z"
                                                    />
                                                    <Path
                                                      fill="#555"
                                                      d="M15.258 13.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22 8.25H21.25V3.75C21.25 3.55109 21.171 3.36032 21.0303 3.21967C20.8897 3.07902 20.6989 3 20.5 3H2.49998C2.32239 3.0029 2.14953 2.94267 2.01219 2.83005C1.87485 2.71743 1.78193 2.55972 1.74998 2.385V2.115C1.78193 1.94028 1.87485 1.78257 2.01219 1.66995C2.14953 1.55733 2.32239 1.4971 2.49998 1.5H20.185C20.3839 1.5 20.5747 1.42098 20.7153 1.28033C20.856 1.13968 20.935 0.948912 20.935 0.75C20.935 0.551088 20.856 0.360322 20.7153 0.21967C20.5747 0.0790178 20.3839 0 20.185 0H2.49998C1.90324 0 1.33095 0.237053 0.908991 0.65901C0.487034 1.08097 0.249981 1.65326 0.249981 2.25C0.244717 2.33992 0.244717 2.43008 0.249981 2.52V17.9475C0.252925 18.3513 0.335381 18.7506 0.49264 19.1226C0.649899 19.4945 0.878882 19.8318 1.16651 20.1153C1.45415 20.3987 1.79479 20.6228 2.169 20.7746C2.54322 20.9264 2.94366 21.003 3.34748 21H20.5C20.6989 21 20.8897 20.921 21.0303 20.7803C21.171 20.6397 21.25 20.4489 21.25 20.25V15.75H22C22.1989 15.75 22.3897 15.671 22.5303 15.5303C22.671 15.3897 22.75 15.1989 22.75 15V9C22.75 8.80109 22.671 8.61032 22.5303 8.46967C22.3897 8.32902 22.1989 8.25 22 8.25ZM19.75 19.5H3.34748C2.93033 19.504 2.52847 19.3432 2.2293 19.0524C1.93013 18.7617 1.75787 18.3646 1.74998 17.9475V4.41C1.99343 4.48055 2.24675 4.51095 2.49998 4.5H19.75V8.25H14.5C13.5054 8.25 12.5516 8.64509 11.8483 9.34835C11.1451 10.0516 10.75 11.0054 10.75 12C10.75 12.9946 11.1451 13.9484 11.8483 14.6517C12.5516 15.3549 13.5054 15.75 14.5 15.75H19.75V19.5ZM21.25 14.25H14.5C13.9032 14.25 13.3309 14.0129 12.909 13.591C12.487 13.169 12.25 12.5967 12.25 12C12.25 11.4033 12.487 10.831 12.909 10.409C13.3309 9.98705 13.9032 9.75 14.5 9.75H21.25V14.25Z" fill="#555555"/> <path d="M15.2575 13.125C15.8788 13.125 16.3825 12.6213 16.3825 12C16.3825 11.3787 15.8788 10.875 15.2575 10.875C14.6362 10.875 14.1325 11.3787 14.1325 12C14.1325 12.6213 14.6362 13.125 15.2575 13.125Z" fill="#555555"/> </svg>
      `,

                                              altura: '15px',

                                              largura: '35px',

                                              preenchimento: ['transparent'],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 16,
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Carteira',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.sideMenu',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'hide',
                                        },
                                      }),
                                    },
                                  }),
                                (...args) => {
                                  // ---------- get Function from A_Project Scope
                                  return tools.goTo('b4chistory');
                                },
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'transparent',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.overflow({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hidden',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginRight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={15}
                                                    height={10}
                                                    fill="red"
                                                    viewBox="0 0 15 10"
                                                    {...props}
                                                  >
                                                    
                                                    <Path
                                                      fill="#555"
                                                      fillRule="evenodd"
                                                      d="M.5 2.455A1.91 1.91 0 0 1 2.41.545h10.18a1.91 1.91 0 0 1 1.91 1.91v.636a.636.636 0 0 1-.636.636 1.273 1.273 0 0 0 0 2.546c.351 0 .636.285.636.636v.636a1.91 1.91 0 0 1-1.91 1.91H2.41A1.91 1.91 0 0 1 .5 7.545V6.91c0-.351.285-.636.636-.636a1.273 1.273 0 1 0 0-2.546.636.636 0 0 1-.636-.636v-.636Zm9.546 5.727h2.545a.636.636 0 0 0 .636-.637v-.08a2.546 2.546 0 0 1 0-4.93v-.08a.636.636 0 0 0-.636-.637h-2.545v6.364ZM8.773 1.818v6.364H2.409a.636.636 0 0 1-.636-.637v-.08a2.547 2.547 0 0 0 0-4.93v-.08c0-.352.285-.637.636-.637h6.364Z"
                                                      clipRule="evenodd"
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg></svg>
      `,

                                              altura: '16px',

                                              largura: '20px',

                                              preenchimento: ['transparent'],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 16,
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Reserva Atual',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.sideMenu',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'hide',
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.condition({
                                    args,
                                    pass: {
                                      conditionPath: [
                                        jsvals.varReader({
                                          pass: {
                                            path: jsvals.j8({
                                              pass: {
                                                propertieValues:
                                                  'sc.B5.currData.locationType',
                                              },
                                            }),
                                          },
                                        }),
                                      ],
                                      expectedValue: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Autônomo',
                                          },
                                        }),
                                      ],
                                      functionsTrue: [
                                        (...args) => {
                                          // ---------- get Function from A_Project Scope
                                          return tools.goTo('b5timerAuto');
                                        },
                                      ],
                                      functionsFalse: [
                                        (...args) => {
                                          // ---------- get Function from A_Project Scope
                                          return tools.goTo('b5timer');
                                        },
                                      ],
                                      args,
                                    },
                                  }),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'transparent',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '26px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.overflow({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'hidden',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginRight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.SvgView1
                                            pass={{
                                              componentSvg: (
                                                Svg: any,
                                                SvgObj: any,
                                              ) => {
                                                const {
                                                  Defs,
                                                  Stop,
                                                  Path,
                                                  LinearGradient,
                                                  G,
                                                  Circle,
                                                  Rect,
                                                  Mask,
                                                } = SvgObj;
                                                return (props: any) => (
                                                  <Svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={13}
                                                    height={14}
                                                    fill="red"
                                                    viewBox="0 0 13 14"
                                                    {...props}
                                                  >
                                                    
                                                    <Mask
                                                      id="a"
                                                      width={14}
                                                      height={14}
                                                      x={-0.5}
                                                      y={0}
                                                      fill="#555"
                                                      maskUnits="userSpaceOnUse"
                                                    >
                                                      
                                                      <Path
                                                        fill="#fff"
                                                        d="M-.5 0h14v14h-14z"
                                                      />
                                                      <Path d="M8.516 12.063H2.944C1.92 10.643 1.438 8.793 1.438 7c0-1.793.482-3.643 1.506-5.063h5.572a.469.469 0 1 0 0-.937H2.709a.469.469 0 0 0-.37.182C1.093 2.789.5 4.917.5 7c0 2.083.593 4.21 1.839 5.818a.469.469 0 0 0 .37.182h5.807a.469.469 0 0 0 0-.938Z" />
                                                      <Path d="m12.364 6.67-.001-.001-1.813-1.814a.469.469 0 0 0-.663.663L10.9 6.531H5a.469.469 0 1 0 0 .938h5.9L9.887 8.482a.469.469 0 1 0 .663.663l1.813-1.814a.47.47 0 0 0 .001-.661Z" />
                                                    </Mask>
                                                    <Path
                                                      fill="#555"
                                                      d="M8.516 12.063H2.944C1.92 10.643 1.438 8.793 1.438 7c0-1.793.482-3.643 1.506-5.063h5.572a.469.469 0 1 0 0-.937H2.709a.469.469 0 0 0-.37.182C1.093 2.789.5 4.917.5 7c0 2.083.593 4.21 1.839 5.818a.469.469 0 0 0 .37.182h5.807a.469.469 0 0 0 0-.938Z"
                                                    />
                                                    <Path
                                                      fill="#555"
                                                      d="m12.364 6.67-.001-.001-1.813-1.814a.469.469 0 0 0-.663.663L10.9 6.531H5a.469.469 0 1 0 0 .938h5.9L9.887 8.482a.469.469 0 1 0 .663.663l1.813-1.814a.47.47 0 0 0 .001-.661Z"
                                                    />
                                                    <Path
                                                      fill="#555"
                                                      d="m2.944 12.063-.162.117.06.082h.102v-.2Zm0-10.126v-.2h-.102l-.06.083.162.117Zm-.605-.755.158.122-.158-.122Zm0 11.636.158-.122-.158.122ZM12.364 6.67l-.149.134.007.007.142-.141Zm-.001-.001.149-.134-.008-.008-.141.142ZM10.55 4.855l-.142.142.142-.142Zm-.663.663.141-.141-.141.141ZM10.9 6.531v.2h.483l-.342-.341-.141.141Zm0 .938.141.141.342-.341H10.9v.2ZM9.887 8.482l-.142-.142.142.142Zm0 .663.141-.142-.141.142Zm.663 0-.142-.142.142.142Zm1.813-1.814.141.142-.141-.142Zm-3.847 4.532H2.944v.4h5.572v-.4Zm-5.41.082C2.112 10.568 1.638 8.762 1.638 7h-.4c0 1.827.49 3.72 1.544 5.18l.324-.235ZM1.638 7c0-1.76.474-3.567 1.468-4.945l-.324-.235C1.728 3.28 1.238 5.174 1.238 7h.4Zm1.306-4.862h5.572v-.4H2.944v.4Zm5.572 0c.37 0 .669-.3.669-.67h-.4c0 .15-.12.27-.27.27v.4Zm.669-.67c0-.369-.3-.668-.67-.668v.4c.15 0 .27.12.27.269h.4ZM8.515.8H2.71v.4h5.807V.8ZM2.71.8a.669.669 0 0 0-.528.26l.316.244a.269.269 0 0 1 .212-.104V.8Zm-.528.26C.903 2.707.3 4.881.3 7h.4c0-2.048.584-4.13 1.797-5.696l-.316-.245ZM.3 7c0 2.118.603 4.291 1.88 5.94l.317-.244C1.284 11.13.7 9.048.7 7H.3Zm1.88 5.94c.127.164.323.26.53.26v-.4a.269.269 0 0 1-.213-.104l-.316.245Zm.53.26h5.806v-.4H2.709v.4Zm5.806 0c.37 0 .669-.3.669-.669h-.4c0 .149-.12.269-.27.269v.4Zm.669-.669c0-.37-.3-.668-.67-.668v.4c.15 0 .27.12.27.268h.4Zm3.328-5.995-.001-.001-.298.267.001.001.298-.267Zm-.009-.009-1.813-1.813-.283.283 1.814 1.813.282-.283Zm-1.813-1.813a.669.669 0 0 0-.946 0l.283.283a.269.269 0 0 1 .38 0l.283-.283Zm-.946 0a.669.669 0 0 0 0 .946l.283-.283a.269.269 0 0 1 0-.38l-.283-.283Zm0 .946 1.013 1.013.283-.283-1.013-1.013-.283.283Zm1.155.671H5v.4h5.9v-.4Zm-5.9 0c-.37 0-.669.3-.669.669h.4c0-.148.12-.269.27-.269v-.4ZM4.331 7c0 .37.3.669.67.669v-.4A.269.269 0 0 1 4.73 7h-.4Zm.67.669H10.9v-.4H5v.4Zm5.757-.342L9.745 8.34l.283.283 1.013-1.013-.283-.283ZM9.745 8.34a.669.669 0 0 0 0 .946l.283-.283a.269.269 0 0 1 0-.38l-.283-.283Zm0 .946a.669.669 0 0 0 .946 0l-.283-.283a.269.269 0 0 1-.38 0l-.283.283Zm.946 0 1.813-1.813-.282-.283-1.814 1.813.283.283Zm1.813-1.813a.67.67 0 0 0 .002-.944l-.284.282a.27.27 0 0 1 0 .379l.282.283Z"
                                                      mask="url(#a)"
                                                    />
                                                  </Svg>
                                                );
                                              },

                                              svgOriginal: `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 7C2.5 4.51472 4.51472 2.5 7 2.5H14.5C16.7091 2.5 18.5 4.29086 18.5 6.5V8.16667C18.5 8.71895 18.0523 9.16667 17.5 9.16667C16.9477 9.16667 16.5 8.71895 16.5 8.16667V6.5C16.5 5.39543 15.6046 4.5 14.5 4.5H7C5.61929 4.5 4.5 5.61929 4.5 7V21C4.5 22.3807 5.61929 23.5 7 23.5H14.5C15.6046 23.5 16.5 22.6046 16.5 21.5V19.8333C16.5 19.281 16.9477 18.8333 17.5 18.8333C18.0523 18.8333 18.5 19.281 18.5 19.8333V21.5C18.5 23.7091 16.7091 25.5 14.5 25.5H7C4.51472 25.5 2.5 23.4853 2.5 21V7ZM21.4596 9.79289C21.8501 9.40237 22.4832 9.40237 22.8738 9.79289L26.3738 13.2929C26.7643 13.6834 26.7643 14.3166 26.3738 14.7071L22.8738 18.2071C22.4832 18.5976 21.8501 18.5976 21.4596 18.2071C21.069 17.8166 21.069 17.1834 21.4596 16.7929L23.2525 15L12.8333 15C12.281 15 11.8333 14.5523 11.8333 14C11.8333 13.4477 12.281 13 12.8333 13L23.2525 13L21.4596 11.2071C21.069 10.8166 21.069 10.1834 21.4596 9.79289Z" fill="#0F1729"/> </svg>
      `,

                                              altura: '20px',

                                              largura: '35px',

                                              preenchimento: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: '#aaa',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 16,
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Sair',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.toggles.sideMenu',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'hide',
                                        },
                                      }),
                                    },
                                  }),
                                (...args) => {
                                  // ---------- get Function from A_Project Scope
                                  return tools.goTo('b1login');
                                },
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.position({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'absolute',
                        },
                      }),
                    ],
                  },
                }),
                stls.flex({ pass: { arrayValue: ['1'] } }),
                stls.width({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.height({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.top({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.left({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.zIndex({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100px',
                        },
                      }),
                    ],
                  },
                }),
                stls.alignItems({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
                stls.justifyContent({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'all.toggles.loaderPurchase',
                  },
                }),
              ],

              expectedVal: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'show',
                  },
                }),
              ],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.position({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'absolute',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({ pass: { arrayValue: ['1'] } }),
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'rgba(0,0,0,0.5)',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.top({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.left({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [{ color: 'black', fontSize: 12 }],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: '',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.toggles.modalCvv',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: 'hide',
                                },
                              }),
                            },
                          }),
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues:
                                      'all.toggles.loaderPurchase',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: null,
                                },
                              }),
                            },
                          }),
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.varReader({
                                pass: {
                                  path: jsvals.j8({
                                    pass: {
                                      propertieValues: 'all.colors.white',
                                    },
                                  }),
                                },
                              }),
                            ],
                          },
                        }),
                        stls.borderRadius({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '20px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.padding({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '20px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.shadows({
                          pass: {
                            shadowColor: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '#000000',
                                },
                              }),
                            ],
                            shadowOffset: ['{width: 0, height: 0}'],
                            shadowOpacity: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0.2',
                                },
                              }),
                            ],
                            shadowRadius: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '10px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '70%',
                                },
                              }),
                            ],
                          },
                        }),

                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.justifyContent({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '290px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      variablePath: [
                        jsvals.j8({
                          pass: {
                            propertieValues: 'all.toggles.creditCard',
                          },
                        }),
                      ],

                      expectedVal: [
                        jsvals.j8({
                          pass: {
                            propertieValues: 'open',
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.ImageBox
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '64px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '64px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              URIvariablePath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues:
                                      'https://firebasestorage.googleapis.com/v0/b/goodbike-cd338.appspot.com/o/images%2Floader.gif?alt=media&token=8475ab7f-8a9f-4a3d-b958-cc74f7068b49',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                stls.position({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'absolute',
                        },
                      }),
                    ],
                  },
                }),
                stls.flex({ pass: { arrayValue: ['1'] } }),
                stls.width({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.height({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100%',
                        },
                      }),
                    ],
                  },
                }),
                stls.top({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.left({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '0px',
                        },
                      }),
                    ],
                  },
                }),
                stls.zIndex({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: '100px',
                        },
                      }),
                    ],
                  },
                }),
                stls.alignItems({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
                stls.justifyContent({
                  pass: {
                    arrayValue: [
                      jsvals.j8({
                        pass: {
                          propertieValues: 'center',
                        },
                      }),
                    ],
                  },
                }),
              ],

              variablePath: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'all.toggles.modalCvv',
                  },
                }),
              ],

              expectedVal: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'show',
                  },
                }),
              ],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        stls.position({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'absolute',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.flex({ pass: { arrayValue: ['1'] } }),
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'rgba(0,0,0,0.5)',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.height({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '100%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.top({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.left({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0px',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [{ color: 'black', fontSize: 12 }],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: '',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.setVar({
                            args,
                            pass: {
                              keyPath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'all.toggles.modalCvv',
                                  },
                                }),
                              ],
                              value: jsvals.j8({
                                pass: {
                                  propertieValues: 'hide',
                                },
                              }),
                            },
                          }),
                      ],

                      args,
                    }}
                  />
                ),

                (...args: any) => (
                  <Elements.DynView
                    pass={{
                      elementsProperties: [{}],

                      styles: [
                        stls.backgroundColor({
                          pass: {
                            arrayValue: [
                              jsvals.varReader({
                                pass: {
                                  path: jsvals.j8({
                                    pass: {
                                      propertieValues: 'all.colors.white',
                                    },
                                  }),
                                },
                              }),
                            ],
                          },
                        }),
                        stls.borderRadius({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '20px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.padding({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '20px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.shadows({
                          pass: {
                            shadowColor: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '#000000',
                                },
                              }),
                            ],
                            shadowOffset: ['{width: 0, height: 0}'],
                            shadowOpacity: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '0.2',
                                },
                              }),
                            ],
                            shadowRadius: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '10px',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.width({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: '70%',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.alignItems({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                        stls.justifyContent({
                          pass: {
                            arrayValue: [
                              jsvals.j8({
                                pass: {
                                  propertieValues: 'center',
                                },
                              }),
                            ],
                          },
                        }),
                      ],

                      variablePath: [
                        jsvals.j8({
                          pass: {
                            propertieValues: 'all.toggles.creditCard',
                          },
                        }),
                      ],

                      expectedVal: [
                        jsvals.j8({
                          pass: {
                            propertieValues: 'open',
                          },
                        }),
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Pressable3
                            pass={{
                              elementProperties: [{}],

                              styles: [
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.colors.white',
                                            },
                                          }),
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.justifyContent({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'space-between',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.borderRadius({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '20px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.paddingBottom({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontWeight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'bold',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'Para pagar informe o número de 3 dígitos atrás do cartão.',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              pressableFunctions: [
                                () => console.log('Você Clicou!'),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.flexDirection({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'row',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.justifyContent({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'space-between',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.backgroundColor({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'rgb(166, 79, 102)',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.padding({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues:
                                      'all.apis.msgs.modalCVV.condShow',
                                  },
                                }),
                              ],

                              expectedVal: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'true',
                                  },
                                }),
                              ],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.CustomListener
                                    pass={{
                                      variable: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'all.apis.msgs.modalCVV.error',
                                          },
                                        }),
                                      ],
                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Text
                                            pass={{
                                              arrProps: [{}],

                                              arrStyles: [
                                                stls.color({
                                                  pass: {
                                                    arrayValue: ['white'],
                                                  },
                                                }),
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '12px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              children: [
                                                jsvals.varReader({
                                                  pass: {
                                                    path: jsvals.j8({
                                                      pass: {
                                                        propertieValues:
                                                          'all.apis.msgs.modalCVV.error',
                                                      },
                                                    }),
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],
                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Pressable3
                                    pass={{
                                      elementProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues:
                                                    'transparent',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Text
                                            pass={{
                                              arrProps: [{}],

                                              arrStyles: [
                                                stls.color({
                                                  pass: {
                                                    arrayValue: ['white'],
                                                  },
                                                }),
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '12px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              children: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'x',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      pressableFunctions: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.apis.msgs.modalCVV.condShow',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: '',
                                                },
                                              }),
                                            },
                                          }),
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'all.apis.msgs.modalCVV.error',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: '',
                                                },
                                              }),
                                            },
                                          }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [[]],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [() => <></>],

                                      args,
                                    }}
                                  />
                                ),

                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.white',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Text
                                            pass={{
                                              arrProps: [{}],

                                              arrStyles: [
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.textSizes.small',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.fontWeight({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'bold',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.color({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.grey2',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              children: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'CVV',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                        (...args: any) => (
                                          <Elements.IptTxtMaskCustomNumbers
                                            pass={{
                                              propsArray: [{}],

                                              stylesArray: [
                                                stls.borderBottomWidth({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '2px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.borderBottomColor({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.grey',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.color({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.colors.grey2',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.textSizes.small',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.varReader({
                                                        pass: {
                                                          path: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'all.textSizes.large',
                                                            },
                                                          }),
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.padding({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '5px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.padding({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '4px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              editPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'sc.B4.currData.orderData.payments.0.credit_card.card.cvv',
                                                  },
                                                }),
                                              ],

                                              funcsArray: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'sc.B4.currData.orderData.payments.0.credit_card.card.cvv',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.argReader({
                                                        pass: {
                                                          argPath: jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                '#0',
                                                            },
                                                          }),
                                                          args,
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],

                                              ipt5: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: '3',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.Pressable3
                                    pass={{
                                      elementProperties: [{}],

                                      styles: [
                                        stls.borderRadius({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '15px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.alignItems({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.justifyContent({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'center',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '32px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.padding({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.backgroundColor({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '#bfe606',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.marginBottom({
                                          pass: { arrayValue: ['10px'] },
                                        }),
                                        stls.marginTop({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '20px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      childrenItems: [
                                        (...args: any) => (
                                          <Elements.Text
                                            pass={{
                                              arrProps: [{}],

                                              arrStyles: [
                                                stls.color({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'black',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.fontSize({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            '14px',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                                stls.fontWeight({
                                                  pass: {
                                                    arrayValue: [
                                                      jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'bold',
                                                        },
                                                      }),
                                                    ],
                                                  },
                                                }),
                                              ],

                                              children: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues: 'Pagar',
                                                  },
                                                }),
                                              ],

                                              args,
                                            }}
                                          />
                                        ),
                                      ],

                                      pressableFunctions: [
                                        async (...args) =>
                                          functions.togglFuncs({
                                            args,
                                            pass: {
                                              conditions: [],
                                              expectedValue: [
                                                (...args) =>
                                                  functions.firebase.whereConds(
                                                    {
                                                      args,
                                                      pass: {
                                                        arrStrings: [
                                                          jsvals.varReader({
                                                            pass: {
                                                              path: jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'sc.B4.currData.orderData.payments.0.credit_card.card.cvv',
                                                                },
                                                              }),
                                                            },
                                                          }),
                                                          jsvals.j8({
                                                            pass: {
                                                              propertieValues:
                                                                'falsy',
                                                            },
                                                          }),
                                                        ],
                                                      },
                                                    },
                                                  ),
                                              ],
                                              functionsTrue: [
                                                async (...args) =>
                                                  functions.funcGroup({
                                                    args,
                                                    pass: {
                                                      arrFunctions: [
                                                        async (...args) =>
                                                          functions.funcGroup({
                                                            args,
                                                            pass: {
                                                              arrFunctions: [
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userName',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userName',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.bikesList',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3C.currData.mainList',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.totalPrice',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3C.currData.currPrice',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.paymentData',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B4.currData.orderData.payments.0',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.localName',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3A.currData.currLocation.data.localName',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4xxx.currData.checkout.bikeId',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3A.currData.currLocation.data.docId',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.localAdress',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3A.currData.currLocation.data.localAddress.formatted_address',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userCPF',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userCPF',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userEmail',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userEmail',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userPhone',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userPhone',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userAddress',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userAddress',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userGender',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userGender',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.locationId',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3A.currData.currLocation.data.docId',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.totalHours',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3C.currData.selecHours',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userId',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.docId',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userCep',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userCep',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.userImage',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'all.userData.userImage',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.locationType',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.varReader(
                                                                            {
                                                                              pass: {
                                                                                path: jsvals.j8(
                                                                                  {
                                                                                    pass: {
                                                                                      propertieValues:
                                                                                        'sc.B3A.currData.currLocation.data.locationType',
                                                                                    },
                                                                                  },
                                                                                ),
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.bikeReturned',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  'não',
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.condition(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        conditionPath:
                                                                          [
                                                                            jsvals.varReader(
                                                                              {
                                                                                pass: {
                                                                                  path: jsvals.j8(
                                                                                    {
                                                                                      pass: {
                                                                                        propertieValues:
                                                                                          'sc.B3A.currData.currLocation.data.locationType',
                                                                                      },
                                                                                    },
                                                                                  ),
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        expectedValue:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'Autônomo',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        functionsTrue:
                                                                          [
                                                                            async (
                                                                              ...args
                                                                            ) =>
                                                                              functions.setVar(
                                                                                {
                                                                                  args,
                                                                                  pass: {
                                                                                    keyPath:
                                                                                      [
                                                                                        jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'sc.B4.currData.checkout.timer',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      ],
                                                                                    value:
                                                                                      jsvals.j8(
                                                                                        {
                                                                                          pass: {
                                                                                            propertieValues:
                                                                                              {
                                                                                                isRunning:
                                                                                                  jsvals.j8(
                                                                                                    {
                                                                                                      pass: {
                                                                                                        propertieValues:
                                                                                                          'true',
                                                                                                      },
                                                                                                    },
                                                                                                  ),
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                      ),
                                                                                  },
                                                                                },
                                                                              ),
                                                                            (
                                                                              ...args: any
                                                                            ) =>
                                                                              customs.setAutoBikeTimerDB(
                                                                                {
                                                                                  pass: {
                                                                                    type: "'plus'",
                                                                                    args,
                                                                                  },
                                                                                },
                                                                              ),
                                                                          ],
                                                                        functionsFalse:
                                                                          [
                                                                            async (
                                                                              ...args
                                                                            ) =>
                                                                              functions.setVar(
                                                                                {
                                                                                  args,
                                                                                  pass: {
                                                                                    keyPath:
                                                                                      [
                                                                                        jsvals.j8(
                                                                                          {
                                                                                            pass: {
                                                                                              propertieValues:
                                                                                                'sc.B4.currData.checkout.timer',
                                                                                            },
                                                                                          },
                                                                                        ),
                                                                                      ],
                                                                                    value:
                                                                                      jsvals.j8(
                                                                                        {
                                                                                          pass: {
                                                                                            propertieValues:
                                                                                              {
                                                                                                isRunning:
                                                                                                  jsvals.j8(
                                                                                                    {
                                                                                                      pass: {
                                                                                                        propertieValues:
                                                                                                          'waiting',
                                                                                                      },
                                                                                                    },
                                                                                                  ),
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                      ),
                                                                                  },
                                                                                },
                                                                              ),
                                                                          ],
                                                                        args,
                                                                      },
                                                                    },
                                                                  ),
                                                                async (
                                                                  ...args
                                                                ) =>
                                                                  functions.setVar(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        keyPath:
                                                                          [
                                                                            jsvals.j8(
                                                                              {
                                                                                pass: {
                                                                                  propertieValues:
                                                                                    'sc.B4.currData.checkout.reasonBlocking',
                                                                                },
                                                                              },
                                                                            ),
                                                                          ],
                                                                        value:
                                                                          jsvals.j8(
                                                                            {
                                                                              pass: {
                                                                                propertieValues:
                                                                                  '',
                                                                              },
                                                                            },
                                                                          ),
                                                                      },
                                                                    },
                                                                  ),
                                                              ],
                                                            },
                                                          }),
                                                        async (...args) =>
                                                          functions.setVar({
                                                            args,
                                                            pass: {
                                                              keyPath: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'all.toggles.modalCvv',
                                                                  },
                                                                }),
                                                              ],
                                                              value: jsvals.j8({
                                                                pass: {
                                                                  propertieValues:
                                                                    'hide',
                                                                },
                                                              }),
                                                            },
                                                          }),
                                                        async (...args) =>
                                                          functions.condition({
                                                            args,
                                                            pass: {
                                                              conditionPath: [
                                                                jsvals.varReader(
                                                                  {
                                                                    pass: {
                                                                      path: jsvals.j8(
                                                                        {
                                                                          pass: {
                                                                            propertieValues:
                                                                              'all.toggles.creditCard',
                                                                          },
                                                                        },
                                                                      ),
                                                                    },
                                                                  },
                                                                ),
                                                              ],
                                                              expectedValue: [
                                                                jsvals.j8({
                                                                  pass: {
                                                                    propertieValues:
                                                                      'open',
                                                                  },
                                                                }),
                                                              ],
                                                              functionsTrue: [
                                                                (...args) =>
                                                                  customs.pagarme.createOrder(
                                                                    {
                                                                      args,
                                                                      pass: {
                                                                        ipt1: [
                                                                          '',
                                                                        ],
                                                                        ipt2: [
                                                                          '',
                                                                        ],
                                                                        ipt3: [
                                                                          '',
                                                                        ],
                                                                        ipt4: [
                                                                          () => {},
                                                                        ],
                                                                      },
                                                                    },
                                                                  ),
                                                              ],
                                                              functionsFalse: [
                                                                () => {},
                                                              ],
                                                              args,
                                                            },
                                                          }),
                                                      ],
                                                    },
                                                  }),
                                              ],
                                              functionsFalse: [
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.apis.msgs.modalCVV.condShow',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'true',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                                async (...args) =>
                                                  functions.setVar({
                                                    args,
                                                    pass: {
                                                      keyPath: [
                                                        jsvals.j8({
                                                          pass: {
                                                            propertieValues:
                                                              'all.apis.msgs.modalCVV.error',
                                                          },
                                                        }),
                                                      ],
                                                      value: jsvals.j8({
                                                        pass: {
                                                          propertieValues:
                                                            'Informe o CVV para prosseguir.',
                                                        },
                                                      }),
                                                    },
                                                  }),
                                              ],
                                              args,
                                            },
                                          }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),

                                (...args: any) => (
                                  <Elements.DynView
                                    pass={{
                                      elementsProperties: [{}],

                                      styles: [
                                        stls.height({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '10px',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.width({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: '100%',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      variablePath: [],

                                      expectedVal: [],

                                      childrenItems: [() => <></>],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.height({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '10px',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                                stls.width({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: '100%',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [() => <></>],

                              args,
                            }}
                          />
                        ),

                        (...args: any) => (
                          <Elements.DynView
                            pass={{
                              elementsProperties: [{}],

                              styles: [
                                stls.alignItems({
                                  pass: {
                                    arrayValue: [
                                      jsvals.j8({
                                        pass: {
                                          propertieValues: 'center',
                                        },
                                      }),
                                    ],
                                  },
                                }),
                              ],

                              variablePath: [],

                              expectedVal: [],

                              childrenItems: [
                                (...args: any) => (
                                  <Elements.Text
                                    pass={{
                                      arrProps: [{}],

                                      arrStyles: [
                                        stls.fontSize({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.textSizes.small',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.fontWeight({
                                          pass: {
                                            arrayValue: [
                                              jsvals.j8({
                                                pass: {
                                                  propertieValues: 'bold',
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                        stls.color({
                                          pass: {
                                            arrayValue: [
                                              jsvals.varReader({
                                                pass: {
                                                  path: jsvals.j8({
                                                    pass: {
                                                      propertieValues:
                                                        'all.colors.grey2',
                                                    },
                                                  }),
                                                },
                                              }),
                                            ],
                                          },
                                        }),
                                      ],

                                      children: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'Ambiente seguro por',
                                          },
                                        }),
                                      ],

                                      args,
                                    }}
                                  />
                                ),
                                (...args: any) => (
                                  <Elements.SvgView1
                                    pass={{
                                      componentSvg: (Svg: any, SvgObj: any) => {
                                        const {
                                          Defs,
                                          Stop,
                                          Path,
                                          LinearGradient,
                                          G,
                                          Circle,
                                          Rect,
                                          Mask,
                                        } = SvgObj;
                                        return (props: any) => (
                                          <Svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={160}
                                            height={57.107}
                                            viewBox="0 0 160 57.107"
                                            fill="red"
                                            {...props}
                                          >
                                            
                                            <G data-name="logo/pagarme">
                                              
                                              <Path
                                                d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z"
                                                style={{ fill: '#65a300' }}
                                                transform="translate(-1422.677)"
                                              />
                                              <Path
                                                d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z"
                                                style={{ fill: '#1b1c29' }}
                                                transform="translate(11319 6227.495)"
                                              />
                                              <Path
                                                d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0 2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329 2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z"
                                                data-name="Path 5415"
                                                style={{ fill: '#454550' }}
                                                transform="translate(70 57)"
                                              />
                                            </G>
                                          </Svg>
                                        );
                                      },

                                      svgOriginal: `
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="57.107" viewBox="0 0 160 57.107">     <defs>         <style>             .cls-1{fill:#65A300}.cls-2{fill:#1B1C29}.cls-3{fill:#454550}         </style>     </defs>     <g id="logo_pagarme" data-name="logo/pagarme" transform="translate(-180 -37)">         <path id="hat" d="M1573.507 28.834h9.142c.015-.374.028-.75.028-1.128A27.738 27.738 0 0 0 1555 0v9.132a18.571 18.571 0 0 1 18.543 18.574c.002.375-.013.754-.036 1.128z" class="cls-1" transform="translate(-1242.677 37)"/>         <path id="pagarme" d="M-11273.433-6184.8a11.688 11.688 0 0 1-2.171-.707 14.324 14.324 0 0 1-1.548-.827 7.446 7.446 0 0 1-1.011-.725l-.3-.3 1.818-2.693.253.256a7.444 7.444 0 0 0 .707.554 8.794 8.794 0 0 0 1.179.725 8.554 8.554 0 0 0 3.585.824 5.477 5.477 0 0 0 3.988-1.227 4.814 4.814 0 0 0 1.23-3.551v-1.446a4.368 4.368 0 0 1-.205.267 6.458 6.458 0 0 1-.639.622 6.246 6.246 0 0 1-1.094.793 6.8 6.8 0 0 1-1.616.6 8.4 8.4 0 0 1-2.176.267 8.528 8.528 0 0 1-6.076-2.222 8.3 8.3 0 0 1-2.372-6.363 8.46 8.46 0 0 1 2.423-6.278 8.125 8.125 0 0 1 5.957-2.406 8.19 8.19 0 0 1 3.264.622 5.7 5.7 0 0 1 1.985 1.23l.54.6v-2.187h3.642v15.283q0 8.582-8.687 8.582h-.036a11.774 11.774 0 0 1-2.64-.293zm-1.418-19.172a5.7 5.7 0 0 0-1.395 3.991 5.564 5.564 0 0 0 1.429 3.955 4.944 4.944 0 0 0 3.787 1.531 5.3 5.3 0 0 0 3.939-1.5 5.432 5.432 0 0 0 1.48-3.988 5.44 5.44 0 0 0-1.515-3.991 5.3 5.3 0 0 0-3.939-1.531 4.881 4.881 0 0 0-3.786 1.536zm-44.149 19.1v-23.5h3.636v2.256c.046-.068.119-.162.219-.287a5.829 5.829 0 0 1 .673-.625 6.661 6.661 0 0 1 1.146-.775 8.2 8.2 0 0 1 1.682-.619 8.358 8.358 0 0 1 2.2-.287 7.86 7.86 0 0 1 5.942 2.409 8.788 8.788 0 0 1 2.307 6.343 8.892 8.892 0 0 1-2.307 6.5 8.116 8.116 0 0 1-6.076 2.357 8.338 8.338 0 0 1-2.153-.27 6.293 6.293 0 0 1-1.65-.656 11.058 11.058 0 0 1-1.11-.759 3.645 3.645 0 0 1-.673-.639l-.2-.27v8.82zm5.017-19.121a5.763 5.763 0 0 0-1.483 4.107 5.655 5.655 0 0 0 1.483 4.139 5.332 5.332 0 0 0 4 1.517 4.733 4.733 0 0 0 3.735-1.565 5.911 5.911 0 0 0 1.381-4.057 5.95 5.95 0 0 0-1.432-4.125 4.846 4.846 0 0 0-3.784-1.6 5.1 5.1 0 0 0-3.9 1.591zm128.1 13q-4.61 0-7.118-2.409a8.727 8.727 0 0 1-2.509-6.613 8.669 8.669 0 0 1 2.56-6.48 8.851 8.851 0 0 1 6.466-2.508 8.578 8.578 0 0 1 6.649 2.625 10.308 10.308 0 0 1 2.406 7.232v.875h-12.729a1.381 1.381 0 0 0 .052.341 3.8 3.8 0 0 0 .32.707 3.6 3.6 0 0 0 .688.909 3.74 3.74 0 0 0 1.278.725 5.723 5.723 0 0 0 2 .318 6.313 6.313 0 0 0 2.46-.488 5.835 5.835 0 0 0 1.716-.992l.5-.505 2.764 3.229c-.067.088-.164.2-.286.338a7.193 7.193 0 0 1-.875.724 9.977 9.977 0 0 1-1.483.926 9.734 9.734 0 0 1-2.1.724 11.7 11.7 0 0 1-2.723.321zm-2.224-13.468a2.841 2.841 0 0 0-1.077.741 5.183 5.183 0 0 0-.607.875 2.154 2.154 0 0 0-.268.742l-.068.3h7.307c-.022-.083-.043-.2-.065-.318a3.738 3.738 0 0 0-.287-.708 3.612 3.612 0 0 0-.622-.909 3.5 3.5 0 0 0-1.079-.707 3.849 3.849 0 0 0-1.616-.318h-.083a4.042 4.042 0 0 0-1.534.305zm-41.35 12.576a3 3 0 0 1-.909-2.153 3.005 3.005 0 0 1 .909-2.156 3.087 3.087 0 0 1 2.222-.875 3.105 3.105 0 0 1 2.224.875 3.01 3.01 0 0 1 .906 2.156 3.009 3.009 0 0 1-.906 2.153 3.251 3.251 0 0 1-2.223.875 3.252 3.252 0 0 1-2.222-.872zm-22.22.818a8.462 8.462 0 0 1-6.076-2.255 8.479 8.479 0 0 1-2.369-6.462 8.643 8.643 0 0 1 2.423-6.395 8.093 8.093 0 0 1 5.957-2.423 8.19 8.19 0 0 1 3.264.622 5.764 5.764 0 0 1 1.986 1.227l.539.608v-2.156h3.634v16.968h-3.637v-2.324c-.045.068-.11.162-.2.284a4.9 4.9 0 0 1-.64.625 6.8 6.8 0 0 1-1.094.773 7.247 7.247 0 0 1-1.616.622 7.9 7.9 0 0 1-2.111.287zm-3.415-12.857a5.842 5.842 0 0 0-1.4 4.071 5.837 5.837 0 0 0 1.432 4.074 4.855 4.855 0 0 0 3.787 1.582 5.235 5.235 0 0 0 3.954-1.514 5.7 5.7 0 0 0 1.466-4.142 5.568 5.568 0 0 0-1.517-4.071 5.255 5.255 0 0 0-3.937-1.548 4.842 4.842 0 0 0-3.784 1.551zm-36.1 12.857a8.444 8.444 0 0 1-6.074-2.255 8.493 8.493 0 0 1-2.374-6.462 8.643 8.643 0 0 1 2.423-6.395 8.1 8.1 0 0 1 5.957-2.423 8.194 8.194 0 0 1 3.267.622 5.807 5.807 0 0 1 1.985 1.227l.537.608v-2.156h3.636v16.968h-3.636v-2.324a8.187 8.187 0 0 1-.2.284 4.912 4.912 0 0 1-.639.625 6.8 6.8 0 0 1-1.094.773 7.3 7.3 0 0 1-1.616.622 7.91 7.91 0 0 1-2.112.287zm-3.418-12.857a5.827 5.827 0 0 0-1.395 4.071 5.836 5.836 0 0 0 1.429 4.074 4.85 4.85 0 0 0 3.787 1.582 5.241 5.241 0 0 0 3.954-1.514 5.688 5.688 0 0 0 1.463-4.142 5.563 5.563 0 0 0-1.515-4.071 5.252 5.252 0 0 0-3.937-1.548 4.841 4.841 0 0 0-3.786 1.551zm92.74 12.59v-10.6q0-2.659-1.954-2.659-2.424 0-2.423 3.534v9.729h-5.116v-10.6q0-2.659-1.952-2.659-2.424 0-2.423 3.534v9.729h-5.116v-17.3h5.116v2.255c.046-.068.1-.156.171-.27a5.251 5.251 0 0 1 .488-.6 5.034 5.034 0 0 1 .857-.772 4.846 4.846 0 0 1 1.275-.608 5.327 5.327 0 0 1 1.716-.267 5.5 5.5 0 0 1 1.719.253 4.052 4.052 0 0 1 1.228.608 5.866 5.866 0 0 1 .759.69 3.02 3.02 0 0 1 .438.605l.1.235c.043-.068.105-.15.185-.255a7.117 7.117 0 0 1 .555-.571 6.056 6.056 0 0 1 .942-.741 5.4 5.4 0 0 1 1.347-.571 5.984 5.984 0 0 1 1.75-.256q5.454 0 5.454 6.295v11.278zm-37.585 0v-17h3.636v3.063a2 2 0 0 1 .15-.37 8.474 8.474 0 0 1 .54-.841 5.3 5.3 0 0 1 .94-1.042 5.137 5.137 0 0 1 1.466-.792 4.838 4.838 0 0 1 2.02-.284l-.3 3.938a4.165 4.165 0 0 0-3.534 1.094 4.808 4.808 0 0 0-1.275 3.551v8.684z" class="cls-2" transform="translate(11499 6264.495)"/>         <path id="Path_5415" d="M-63.247-7.82v5.226a2.54 2.54 0 0 1-.8 1.974 3.03 3.03 0 0 1-2.124.728A3.051 3.051 0 0 1-68.3-.61a2.552 2.552 0 0 1-.79-1.99v-5.22h1.354v5.231a1.662 1.662 0 0 0 .4 1.2 1.551 1.551 0 0 0 1.171.414q1.568 0 1.568-1.654V-7.82zm3.476 0l2.256 5.994 2.25-5.994h1.756V0h-1.354v-2.578l.134-3.448L-57.038 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm12.51 6h-3.029L-50.924 0h-1.413l2.954-7.82h1.219L-45.2 0h-1.418zm-2.648-1.1h2.267l-1.133-3.244zm13.429-.575h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm3.675-4.329l2.256 5.994 2.249-5.99h1.756V0H-27.9v-2.578l.134-3.448L-30.071 0h-.972l-2.3-6.021.134 3.443V0h-1.354v-7.82zm9.492 4.915V0h-1.359v-7.82h2.992a3.027 3.027 0 0 1 2.081.682 2.292 2.292 0 0 1 .771 1.8 2.216 2.216 0 0 1-.755 1.789 3.174 3.174 0 0 1-2.114.639zm0-1.09h1.633a1.608 1.608 0 0 0 1.106-.341 1.253 1.253 0 0 0 .381-.986 1.352 1.352 0 0 0-.387-1.012 1.491 1.491 0 0 0-1.063-.389h-1.67zm8.809.983h-1.515V0h-1.359v-7.82h2.75a3.2 3.2 0 0 1 2.089.607 2.146 2.146 0 0 1 .739 1.756 2.2 2.2 0 0 1-.379 1.313 2.409 2.409 0 0 1-1.055.814l1.754 3.26V0h-1.456zM-16.019-4.1h1.4a1.553 1.553 0 0 0 1.074-.346 1.208 1.208 0 0 0 .387-.948 1.286 1.286 0 0 0-.357-.972 1.517 1.517 0 0 0-1.066-.354h-1.434zm10.34.612h-3.212v2.406h3.754V0h-5.113v-7.82h5.076v1.1h-3.717v2.159h3.212zm6 1.477a.944.944 0 0 0-.363-.795A4.362 4.362 0 0 0-1.35-3.37a6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.072-1.754 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233H.321A1.225 1.225 0 0 0-.063-6.5a1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.465.62 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05A1.861 1.861 0 0 1 .931-.47 3.25 3.25 0 0 1-1.1.107a3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289H-2.8a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.26.365 1.676 1.676 0 0 0 1.064-.287.927.927 0 0 0 .357-.76zm7.193.193H4.485L3.851 0H2.438l2.955-7.82h1.219L9.571 0H8.153zm-2.648-1.1h2.267L6-6.161zm12.946.9a.944.944 0 0 0-.363-.795 4.362 4.362 0 0 0-1.308-.564 6.316 6.316 0 0 1-1.5-.634 2.007 2.007 0 0 1-1.069-1.751 1.906 1.906 0 0 1 .771-1.558 3.12 3.12 0 0 1 2-.612 3.379 3.379 0 0 1 1.456.3 2.389 2.389 0 0 1 1 .857 2.2 2.2 0 0 1 .365 1.233h-1.352a1.225 1.225 0 0 0-.384-.959 1.585 1.585 0 0 0-1.1-.346 1.655 1.655 0 0 0-1.034.285.948.948 0 0 0-.368.795.857.857 0 0 0 .4.717 4.579 4.579 0 0 0 1.311.559 6.028 6.028 0 0 1 1.463.621 2.332 2.332 0 0 1 .811.795 2.07 2.07 0 0 1 .258 1.05 1.861 1.861 0 0 1-.747 1.555 3.25 3.25 0 0 1-2.033.577 3.82 3.82 0 0 1-1.56-.314 2.621 2.621 0 0 1-1.106-.867 2.162 2.162 0 0 1-.395-1.289h1.359a1.265 1.265 0 0 0 .44 1.031 1.929 1.929 0 0 0 1.262.365 1.676 1.676 0 0 0 1.066-.287.927.927 0 0 0 .357-.76zm8.466-4.71h-2.439V0h-1.348v-6.725h-2.417v-1.1h6.2zm7.381 3.019a4.8 4.8 0 0 1-.4 2.017 3.005 3.005 0 0 1-1.134 1.335 3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.695-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.14 1.319 4.747 4.747 0 0 1 .408 2.006zM32.3-4.114a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.395-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.392-.686 3.466 3.466 0 0 0 .486-2.006zM41.48 0h-1.359l-3.486-5.548V0h-1.359v-7.82h1.359l3.5 5.57v-5.57h1.345zm6.44-3.491h-3.211v2.406h3.754V0H43.35v-7.82h5.076v1.1h-3.717v2.159h3.211zm10.88.945a2.824 2.824 0 0 1-.92 1.952 3.149 3.149 0 0 1-2.143.7 3.05 3.05 0 0 1-1.646-.443 2.909 2.909 0 0 1-1.1-1.26 4.545 4.545 0 0 1-.4-1.9v-.73a4.578 4.578 0 0 1 .392-1.95 2.955 2.955 0 0 1 1.125-1.3 3.139 3.139 0 0 1 1.692-.451 3.016 3.016 0 0 1 2.084.7 2.939 2.939 0 0 1 .916 1.991h-1.35a1.932 1.932 0 0 0-.491-1.217 1.624 1.624 0 0 0-1.159-.373 1.587 1.587 0 0 0-1.362.647 3.232 3.232 0 0 0-.486 1.9v.693a3.429 3.429 0 0 0 .454 1.934 1.507 1.507 0 0 0 1.329.666 1.757 1.757 0 0 0 1.2-.36 1.876 1.876 0 0 0 .51-1.2zm7.719-1.16a4.8 4.8 0 0 1-.4 2.017A3.005 3.005 0 0 1 64.99-.357a3.125 3.125 0 0 1-1.7.465 3.132 3.132 0 0 1-1.69-.465 3.051 3.051 0 0 1-1.149-1.324 4.648 4.648 0 0 1-.411-1.982V-4.1a4.757 4.757 0 0 1 .406-2.02 3.048 3.048 0 0 1 1.144-1.34 3.115 3.115 0 0 1 1.695-.465 3.142 3.142 0 0 1 1.695.459 3.009 3.009 0 0 1 1.141 1.321 4.747 4.747 0 0 1 .408 2.006zm-1.359-.408a3.419 3.419 0 0 0-.491-1.993 1.608 1.608 0 0 0-1.39-.693 1.6 1.6 0 0 0-1.378.69 3.353 3.353 0 0 0-.508 1.952v.451a3.393 3.393 0 0 0 .5 1.993 1.617 1.617 0 0 0 1.394.7 1.6 1.6 0 0 0 1.391-.686 3.466 3.466 0 0 0 .486-2.009zm3.009 2.739a.746.746 0 0 1 .564.207.718.718 0 0 1 .2.518.693.693 0 0 1-.2.508.757.757 0 0 1-.564.2.759.759 0 0 1-.553-.2.681.681 0 0 1-.2-.51.718.718 0 0 1 .2-.518.738.738 0 0 1 .557-.205z" class="cls-3" data-name="Path 5415" transform="translate(250 94)"/>     </g> </svg>
      `,

                                      altura: '40px',

                                      largura: '100px',

                                      preenchimento: ['transparent'],

                                      args,
                                    }}
                                  />
                                ),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),

        (...args: any) => (
          <Elements.DynView
            pass={{
              elementsProperties: [{}],

              styles: [
                {
                  backgroundColor: 'white',
                  justifyContent: 'center',
                  minHeight: 22,
                  width: '100%',
                },
              ],

              variablePath: [
                jsvals.j8({
                  pass: {
                    propertieValues: 'zzxx',
                  },
                }),
              ],

              expectedVal: [],

              childrenItems: [
                (...args: any) => (
                  <Elements.Pressable3
                    pass={{
                      elementProperties: [{}],

                      styles: [
                        {
                          backgroundColor: 'blue',
                          borderRadius: 20,
                          paddingVertical: 5,
                          paddingHorizontal: 20,
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                      ],

                      childrenItems: [
                        (...args: any) => (
                          <Elements.Text
                            pass={{
                              arrProps: [{}],

                              arrStyles: [{ color: 'black', fontSize: 12 }],

                              children: [
                                jsvals.j8({
                                  pass: {
                                    propertieValues: 'Testar Checkout (Dados)',
                                  },
                                }),
                              ],

                              args,
                            }}
                          />
                        ),
                      ],

                      pressableFunctions: [
                        async (...args) =>
                          functions.funcGroup({
                            args,
                            pass: {
                              arrFunctions: [
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userName',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userName',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.bikesList',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.mainList',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.totalPrice',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.currPrice',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.paymentData',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B4.currData.orderData.payments.0',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.localName',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.localName',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4xxx.currData.checkout.bikeId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.localAdress',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.localAddress.formatted_address',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userCPF',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userCPF',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userEmail',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userEmail',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userPhone',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userPhone',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userAddress',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userAddress',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userGender',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userGender',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.locationId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.totalHours',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3C.currData.selecHours',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userId',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.docId',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userCep',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userCep',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.userImage',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'all.userData.userImage',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.locationType',
                                          },
                                        }),
                                      ],
                                      value: jsvals.varReader({
                                        pass: {
                                          path: jsvals.j8({
                                            pass: {
                                              propertieValues:
                                                'sc.B3A.currData.currLocation.data.locationType',
                                            },
                                          }),
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.bikeReturned',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: 'não',
                                        },
                                      }),
                                    },
                                  }),
                                async (...args) =>
                                  functions.condition({
                                    args,
                                    pass: {
                                      conditionPath: [
                                        jsvals.varReader({
                                          pass: {
                                            path: jsvals.j8({
                                              pass: {
                                                propertieValues:
                                                  'sc.B3A.currData.currLocation.data.locationType',
                                              },
                                            }),
                                          },
                                        }),
                                      ],
                                      expectedValue: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues: 'Autônomo',
                                          },
                                        }),
                                      ],
                                      functionsTrue: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'sc.B4.currData.checkout.timer',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: {
                                                    isRunning: jsvals.j8({
                                                      pass: {
                                                        propertieValues: 'true',
                                                      },
                                                    }),
                                                  },
                                                },
                                              }),
                                            },
                                          }),
                                        (...args: any) =>
                                          customs.setAutoBikeTimerDB({
                                            pass: {
                                              type: "'plus'",
                                              args,
                                            },
                                          }),
                                      ],
                                      functionsFalse: [
                                        async (...args) =>
                                          functions.setVar({
                                            args,
                                            pass: {
                                              keyPath: [
                                                jsvals.j8({
                                                  pass: {
                                                    propertieValues:
                                                      'sc.B4.currData.checkout.timer',
                                                  },
                                                }),
                                              ],
                                              value: jsvals.j8({
                                                pass: {
                                                  propertieValues: {
                                                    isRunning: jsvals.j8({
                                                      pass: {
                                                        propertieValues:
                                                          'waiting',
                                                      },
                                                    }),
                                                  },
                                                },
                                              }),
                                            },
                                          }),
                                      ],
                                      args,
                                    },
                                  }),
                                async (...args) =>
                                  functions.setVar({
                                    args,
                                    pass: {
                                      keyPath: [
                                        jsvals.j8({
                                          pass: {
                                            propertieValues:
                                              'sc.B4.currData.checkout.reasonBlocking',
                                          },
                                        }),
                                      ],
                                      value: jsvals.j8({
                                        pass: {
                                          propertieValues: '',
                                        },
                                      }),
                                    },
                                  }),
                              ],
                            },
                          }),
                        (...args) => {
                          // ---------- set Capsules Inputs
                          const itemsToLog = [
                            jsvals.varReader({
                              pass: {
                                path: jsvals.j8({
                                  pass: {
                                    propertieValues: 'sc.B4.currData.checkout',
                                  },
                                }),
                              },
                            }),
                          ];

                          // ---------- set Console Log
                          itemsToLog.forEach(item => {
                            if (typeof item === 'function')
                              return console.log({
                                function: item,
                                response: item(args),
                              });

                            if (typeof item === 'string') {
                              // ---------- set Arguments Values (If Exists)
                              const checkArgs = item.startsWith('#');
                              if (checkArgs) item = tools.argSel(args, item);

                              // ---------- set Variables Values (If Exists)
                              const [condVar, varValue] = tools.getVarValue(
                                item,
                                'noComponent',
                              );
                              if (condVar) item = varValue;

                              return console.log(item);
                            }

                            console.log(item);
                          });
                        },
                      ],

                      args,
                    }}
                  />
                ),
              ],

              args,
            }}
          />
        ),
      ],

      startFunctions: [
        async (...args) =>
          functions.setVar({
            args,
            pass: {
              keyPath: [
                jsvals.j8({
                  pass: {
                    propertieValues:
                      'sc.B4.currData.orderData.payments.0.credit_card.card',
                  },
                }),
              ],
              value: jsvals.j8({
                pass: {
                  propertieValues: {},
                },
              }),
            },
          }),
      ],

      args,
    }}
  />
);
